
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3b07"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3b07"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2gL4C", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1a71973a276cda83$export$ffb0004e005737fa; }, function (v) { return $1a71973a276cda83$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1a71973a276cda83$export$34b9dba7ce09269b; }, function (v) { return $1a71973a276cda83$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1a71973a276cda83$export$25062201e9e25d76; }, function (v) { return $1a71973a276cda83$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1a71973a276cda83$export$ffb0004e005737fa;
var $1a71973a276cda83$export$34b9dba7ce09269b;
var $1a71973a276cda83$export$25062201e9e25d76;
'use strict';

var $7K7RB = parcelRequire("7K7RB");
var $1a71973a276cda83$var$k = Symbol.for("react.element"), $1a71973a276cda83$var$l = Symbol.for("react.fragment"), $1a71973a276cda83$var$m = Object.prototype.hasOwnProperty, $1a71973a276cda83$var$n = $7K7RB.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1a71973a276cda83$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1a71973a276cda83$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1a71973a276cda83$var$m.call(a, b) && !$1a71973a276cda83$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1a71973a276cda83$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1a71973a276cda83$var$n.current
    };
}
$1a71973a276cda83$export$ffb0004e005737fa = $1a71973a276cda83$var$l;
$1a71973a276cda83$export$34b9dba7ce09269b = $1a71973a276cda83$var$q;
$1a71973a276cda83$export$25062201e9e25d76 = $1a71973a276cda83$var$q;

});
parcelRegister("7K7RB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fbKMU"));

});
parcelRegister("fbKMU", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b0ec2d2b36ab34f8$export$dca3b0875bd9a954; }, function (v) { return $b0ec2d2b36ab34f8$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b0ec2d2b36ab34f8$export$16fa2f45be04daa8; }, function (v) { return $b0ec2d2b36ab34f8$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b0ec2d2b36ab34f8$export$ffb0004e005737fa; }, function (v) { return $b0ec2d2b36ab34f8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b0ec2d2b36ab34f8$export$e2c29f18771995cb; }, function (v) { return $b0ec2d2b36ab34f8$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b0ec2d2b36ab34f8$export$221d75b3f55bb0bd; }, function (v) { return $b0ec2d2b36ab34f8$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b0ec2d2b36ab34f8$export$5f8d39834fd61797; }, function (v) { return $b0ec2d2b36ab34f8$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b0ec2d2b36ab34f8$export$74bf444e3cd11ea5; }, function (v) { return $b0ec2d2b36ab34f8$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b0ec2d2b36ab34f8$export$ae55be85d98224ed; }, function (v) { return $b0ec2d2b36ab34f8$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $b0ec2d2b36ab34f8$export$3ba232387fd5d6dd; }, function (v) { return $b0ec2d2b36ab34f8$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b0ec2d2b36ab34f8$export$e530037191fcd5d7; }, function (v) { return $b0ec2d2b36ab34f8$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b0ec2d2b36ab34f8$export$fd42f52fd3ae1109; }, function (v) { return $b0ec2d2b36ab34f8$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b0ec2d2b36ab34f8$export$c8a8987d4410bf2d; }, function (v) { return $b0ec2d2b36ab34f8$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b0ec2d2b36ab34f8$export$d38cd72104c1f0e9; }, function (v) { return $b0ec2d2b36ab34f8$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b0ec2d2b36ab34f8$export$7d1e3a5e95ceca43; }, function (v) { return $b0ec2d2b36ab34f8$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b0ec2d2b36ab34f8$export$257a8862b851cb5b; }, function (v) { return $b0ec2d2b36ab34f8$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b0ec2d2b36ab34f8$export$a8257692ac88316c; }, function (v) { return $b0ec2d2b36ab34f8$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b0ec2d2b36ab34f8$export$488013bae63b21da; }, function (v) { return $b0ec2d2b36ab34f8$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b0ec2d2b36ab34f8$export$7c73462e0d25e514; }, function (v) { return $b0ec2d2b36ab34f8$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b0ec2d2b36ab34f8$export$7568632d0d33d16d; }, function (v) { return $b0ec2d2b36ab34f8$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b0ec2d2b36ab34f8$export$88948ce120ea2619; }, function (v) { return $b0ec2d2b36ab34f8$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b0ec2d2b36ab34f8$export$35808ee640e87ca7; }, function (v) { return $b0ec2d2b36ab34f8$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b0ec2d2b36ab34f8$export$fae74005e78b1a27; }, function (v) { return $b0ec2d2b36ab34f8$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b0ec2d2b36ab34f8$export$dc8fbce3eb94dc1e; }, function (v) { return $b0ec2d2b36ab34f8$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b0ec2d2b36ab34f8$export$6a7bc4e911dc01cf; }, function (v) { return $b0ec2d2b36ab34f8$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b0ec2d2b36ab34f8$export$6d9c69b0de29b591; }, function (v) { return $b0ec2d2b36ab34f8$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b0ec2d2b36ab34f8$export$f680877a34711e37; }, function (v) { return $b0ec2d2b36ab34f8$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b0ec2d2b36ab34f8$export$d5a552a76deda3c2; }, function (v) { return $b0ec2d2b36ab34f8$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b0ec2d2b36ab34f8$export$aaabe4eda9ed9969; }, function (v) { return $b0ec2d2b36ab34f8$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b0ec2d2b36ab34f8$export$e5c5a5f917a5871c; }, function (v) { return $b0ec2d2b36ab34f8$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b0ec2d2b36ab34f8$export$1538c33de8887b59; }, function (v) { return $b0ec2d2b36ab34f8$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b0ec2d2b36ab34f8$export$13e3392192263954; }, function (v) { return $b0ec2d2b36ab34f8$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b0ec2d2b36ab34f8$export$b8f5890fc79d6aca; }, function (v) { return $b0ec2d2b36ab34f8$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b0ec2d2b36ab34f8$export$60241385465d0a34; }, function (v) { return $b0ec2d2b36ab34f8$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b0ec2d2b36ab34f8$export$306c0aa65ff9ec16; }, function (v) { return $b0ec2d2b36ab34f8$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b0ec2d2b36ab34f8$export$7b286972b8d8ccbf; }, function (v) { return $b0ec2d2b36ab34f8$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b0ec2d2b36ab34f8$export$83d89fbfd8236492; }, function (v) { return $b0ec2d2b36ab34f8$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0ec2d2b36ab34f8$export$dca3b0875bd9a954;
var $b0ec2d2b36ab34f8$export$16fa2f45be04daa8;
var $b0ec2d2b36ab34f8$export$ffb0004e005737fa;
var $b0ec2d2b36ab34f8$export$e2c29f18771995cb;
var $b0ec2d2b36ab34f8$export$221d75b3f55bb0bd;
var $b0ec2d2b36ab34f8$export$5f8d39834fd61797;
var $b0ec2d2b36ab34f8$export$74bf444e3cd11ea5;
var $b0ec2d2b36ab34f8$export$ae55be85d98224ed;
var $b0ec2d2b36ab34f8$export$3ba232387fd5d6dd;
var $b0ec2d2b36ab34f8$export$e530037191fcd5d7;
var $b0ec2d2b36ab34f8$export$fd42f52fd3ae1109;
var $b0ec2d2b36ab34f8$export$c8a8987d4410bf2d;
var $b0ec2d2b36ab34f8$export$d38cd72104c1f0e9;
var $b0ec2d2b36ab34f8$export$7d1e3a5e95ceca43;
var $b0ec2d2b36ab34f8$export$257a8862b851cb5b;
var $b0ec2d2b36ab34f8$export$a8257692ac88316c;
var $b0ec2d2b36ab34f8$export$488013bae63b21da;
var $b0ec2d2b36ab34f8$export$7c73462e0d25e514;
var $b0ec2d2b36ab34f8$export$7568632d0d33d16d;
var $b0ec2d2b36ab34f8$export$88948ce120ea2619;
var $b0ec2d2b36ab34f8$export$35808ee640e87ca7;
var $b0ec2d2b36ab34f8$export$fae74005e78b1a27;
var $b0ec2d2b36ab34f8$export$dc8fbce3eb94dc1e;
var $b0ec2d2b36ab34f8$export$6a7bc4e911dc01cf;
var $b0ec2d2b36ab34f8$export$6d9c69b0de29b591;
var $b0ec2d2b36ab34f8$export$f680877a34711e37;
var $b0ec2d2b36ab34f8$export$d5a552a76deda3c2;
var $b0ec2d2b36ab34f8$export$aaabe4eda9ed9969;
var $b0ec2d2b36ab34f8$export$e5c5a5f917a5871c;
var $b0ec2d2b36ab34f8$export$1538c33de8887b59;
var $b0ec2d2b36ab34f8$export$13e3392192263954;
var $b0ec2d2b36ab34f8$export$b8f5890fc79d6aca;
var $b0ec2d2b36ab34f8$export$60241385465d0a34;
var $b0ec2d2b36ab34f8$export$306c0aa65ff9ec16;
var $b0ec2d2b36ab34f8$export$7b286972b8d8ccbf;
var $b0ec2d2b36ab34f8$export$83d89fbfd8236492;
'use strict';
var $b0ec2d2b36ab34f8$var$l = Symbol.for("react.element"), $b0ec2d2b36ab34f8$var$n = Symbol.for("react.portal"), $b0ec2d2b36ab34f8$var$p = Symbol.for("react.fragment"), $b0ec2d2b36ab34f8$var$q = Symbol.for("react.strict_mode"), $b0ec2d2b36ab34f8$var$r = Symbol.for("react.profiler"), $b0ec2d2b36ab34f8$var$t = Symbol.for("react.provider"), $b0ec2d2b36ab34f8$var$u = Symbol.for("react.context"), $b0ec2d2b36ab34f8$var$v = Symbol.for("react.forward_ref"), $b0ec2d2b36ab34f8$var$w = Symbol.for("react.suspense"), $b0ec2d2b36ab34f8$var$x = Symbol.for("react.memo"), $b0ec2d2b36ab34f8$var$y = Symbol.for("react.lazy"), $b0ec2d2b36ab34f8$var$z = Symbol.iterator;
function $b0ec2d2b36ab34f8$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b0ec2d2b36ab34f8$var$z && a[$b0ec2d2b36ab34f8$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b0ec2d2b36ab34f8$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b0ec2d2b36ab34f8$var$C = Object.assign, $b0ec2d2b36ab34f8$var$D = {};
function $b0ec2d2b36ab34f8$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b0ec2d2b36ab34f8$var$D;
    this.updater = e || $b0ec2d2b36ab34f8$var$B;
}
$b0ec2d2b36ab34f8$var$E.prototype.isReactComponent = {};
$b0ec2d2b36ab34f8$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b0ec2d2b36ab34f8$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b0ec2d2b36ab34f8$var$F() {}
$b0ec2d2b36ab34f8$var$F.prototype = $b0ec2d2b36ab34f8$var$E.prototype;
function $b0ec2d2b36ab34f8$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b0ec2d2b36ab34f8$var$D;
    this.updater = e || $b0ec2d2b36ab34f8$var$B;
}
var $b0ec2d2b36ab34f8$var$H = $b0ec2d2b36ab34f8$var$G.prototype = new $b0ec2d2b36ab34f8$var$F;
$b0ec2d2b36ab34f8$var$H.constructor = $b0ec2d2b36ab34f8$var$G;
$b0ec2d2b36ab34f8$var$C($b0ec2d2b36ab34f8$var$H, $b0ec2d2b36ab34f8$var$E.prototype);
$b0ec2d2b36ab34f8$var$H.isPureReactComponent = !0;
var $b0ec2d2b36ab34f8$var$I = Array.isArray, $b0ec2d2b36ab34f8$var$J = Object.prototype.hasOwnProperty, $b0ec2d2b36ab34f8$var$K = {
    current: null
}, $b0ec2d2b36ab34f8$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b0ec2d2b36ab34f8$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b0ec2d2b36ab34f8$var$J.call(b, d) && !$b0ec2d2b36ab34f8$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b0ec2d2b36ab34f8$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b0ec2d2b36ab34f8$var$K.current
    };
}
function $b0ec2d2b36ab34f8$var$N(a, b) {
    return {
        $$typeof: $b0ec2d2b36ab34f8$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b0ec2d2b36ab34f8$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b0ec2d2b36ab34f8$var$l;
}
function $b0ec2d2b36ab34f8$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b0ec2d2b36ab34f8$var$P = /\/+/g;
function $b0ec2d2b36ab34f8$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b0ec2d2b36ab34f8$var$escape("" + a.key) : b.toString(36);
}
function $b0ec2d2b36ab34f8$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b0ec2d2b36ab34f8$var$l:
                case $b0ec2d2b36ab34f8$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b0ec2d2b36ab34f8$var$Q(h, 0) : d, $b0ec2d2b36ab34f8$var$I(c) ? (e = "", null != a && (e = a.replace($b0ec2d2b36ab34f8$var$P, "$&/") + "/"), $b0ec2d2b36ab34f8$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b0ec2d2b36ab34f8$var$O(c) && (c = $b0ec2d2b36ab34f8$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b0ec2d2b36ab34f8$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b0ec2d2b36ab34f8$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b0ec2d2b36ab34f8$var$Q(k, g);
        h += $b0ec2d2b36ab34f8$var$R(k, b, e, f, c);
    }
    else if (f = $b0ec2d2b36ab34f8$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b0ec2d2b36ab34f8$var$Q(k, g++), h += $b0ec2d2b36ab34f8$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b0ec2d2b36ab34f8$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b0ec2d2b36ab34f8$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b0ec2d2b36ab34f8$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b0ec2d2b36ab34f8$var$U = {
    current: null
}, $b0ec2d2b36ab34f8$var$V = {
    transition: null
}, $b0ec2d2b36ab34f8$var$W = {
    ReactCurrentDispatcher: $b0ec2d2b36ab34f8$var$U,
    ReactCurrentBatchConfig: $b0ec2d2b36ab34f8$var$V,
    ReactCurrentOwner: $b0ec2d2b36ab34f8$var$K
};
function $b0ec2d2b36ab34f8$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$b0ec2d2b36ab34f8$export$dca3b0875bd9a954 = {
    map: $b0ec2d2b36ab34f8$var$S,
    forEach: function(a, b, e) {
        $b0ec2d2b36ab34f8$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b0ec2d2b36ab34f8$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b0ec2d2b36ab34f8$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b0ec2d2b36ab34f8$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b0ec2d2b36ab34f8$export$16fa2f45be04daa8 = $b0ec2d2b36ab34f8$var$E;
$b0ec2d2b36ab34f8$export$ffb0004e005737fa = $b0ec2d2b36ab34f8$var$p;
$b0ec2d2b36ab34f8$export$e2c29f18771995cb = $b0ec2d2b36ab34f8$var$r;
$b0ec2d2b36ab34f8$export$221d75b3f55bb0bd = $b0ec2d2b36ab34f8$var$G;
$b0ec2d2b36ab34f8$export$5f8d39834fd61797 = $b0ec2d2b36ab34f8$var$q;
$b0ec2d2b36ab34f8$export$74bf444e3cd11ea5 = $b0ec2d2b36ab34f8$var$w;
$b0ec2d2b36ab34f8$export$ae55be85d98224ed = $b0ec2d2b36ab34f8$var$W;
$b0ec2d2b36ab34f8$export$3ba232387fd5d6dd = $b0ec2d2b36ab34f8$var$X;
$b0ec2d2b36ab34f8$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b0ec2d2b36ab34f8$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b0ec2d2b36ab34f8$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b0ec2d2b36ab34f8$var$J.call(b, f) && !$b0ec2d2b36ab34f8$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b0ec2d2b36ab34f8$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b0ec2d2b36ab34f8$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b0ec2d2b36ab34f8$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b0ec2d2b36ab34f8$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b0ec2d2b36ab34f8$export$c8a8987d4410bf2d = $b0ec2d2b36ab34f8$var$M;
$b0ec2d2b36ab34f8$export$d38cd72104c1f0e9 = function(a) {
    var b = $b0ec2d2b36ab34f8$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b0ec2d2b36ab34f8$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b0ec2d2b36ab34f8$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b0ec2d2b36ab34f8$var$v,
        render: a
    };
};
$b0ec2d2b36ab34f8$export$a8257692ac88316c = $b0ec2d2b36ab34f8$var$O;
$b0ec2d2b36ab34f8$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b0ec2d2b36ab34f8$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b0ec2d2b36ab34f8$var$T
    };
};
$b0ec2d2b36ab34f8$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b0ec2d2b36ab34f8$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b0ec2d2b36ab34f8$export$7568632d0d33d16d = function(a) {
    var b = $b0ec2d2b36ab34f8$var$V.transition;
    $b0ec2d2b36ab34f8$var$V.transition = {};
    try {
        a();
    } finally{
        $b0ec2d2b36ab34f8$var$V.transition = b;
    }
};
$b0ec2d2b36ab34f8$export$88948ce120ea2619 = $b0ec2d2b36ab34f8$var$X;
$b0ec2d2b36ab34f8$export$35808ee640e87ca7 = function(a, b) {
    return $b0ec2d2b36ab34f8$var$U.current.useCallback(a, b);
};
$b0ec2d2b36ab34f8$export$fae74005e78b1a27 = function(a) {
    return $b0ec2d2b36ab34f8$var$U.current.useContext(a);
};
$b0ec2d2b36ab34f8$export$dc8fbce3eb94dc1e = function() {};
$b0ec2d2b36ab34f8$export$6a7bc4e911dc01cf = function(a) {
    return $b0ec2d2b36ab34f8$var$U.current.useDeferredValue(a);
};
$b0ec2d2b36ab34f8$export$6d9c69b0de29b591 = function(a, b) {
    return $b0ec2d2b36ab34f8$var$U.current.useEffect(a, b);
};
$b0ec2d2b36ab34f8$export$f680877a34711e37 = function() {
    return $b0ec2d2b36ab34f8$var$U.current.useId();
};
$b0ec2d2b36ab34f8$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b0ec2d2b36ab34f8$var$U.current.useImperativeHandle(a, b, e);
};
$b0ec2d2b36ab34f8$export$aaabe4eda9ed9969 = function(a, b) {
    return $b0ec2d2b36ab34f8$var$U.current.useInsertionEffect(a, b);
};
$b0ec2d2b36ab34f8$export$e5c5a5f917a5871c = function(a, b) {
    return $b0ec2d2b36ab34f8$var$U.current.useLayoutEffect(a, b);
};
$b0ec2d2b36ab34f8$export$1538c33de8887b59 = function(a, b) {
    return $b0ec2d2b36ab34f8$var$U.current.useMemo(a, b);
};
$b0ec2d2b36ab34f8$export$13e3392192263954 = function(a, b, e) {
    return $b0ec2d2b36ab34f8$var$U.current.useReducer(a, b, e);
};
$b0ec2d2b36ab34f8$export$b8f5890fc79d6aca = function(a) {
    return $b0ec2d2b36ab34f8$var$U.current.useRef(a);
};
$b0ec2d2b36ab34f8$export$60241385465d0a34 = function(a) {
    return $b0ec2d2b36ab34f8$var$U.current.useState(a);
};
$b0ec2d2b36ab34f8$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b0ec2d2b36ab34f8$var$U.current.useSyncExternalStore(a, b, e);
};
$b0ec2d2b36ab34f8$export$7b286972b8d8ccbf = function() {
    return $b0ec2d2b36ab34f8$var$U.current.useTransition();
};
$b0ec2d2b36ab34f8$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("36IZB", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $2434d53d0d34de35$export$ae55be85d98224ed; }, function (v) { return $2434d53d0d34de35$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $2434d53d0d34de35$export$d39a5bbd09211389; }, function (v) { return $2434d53d0d34de35$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $2434d53d0d34de35$export$882461b6382ed46c; }, function (v) { return $2434d53d0d34de35$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $2434d53d0d34de35$export$466bfc07425424d5; }, function (v) { return $2434d53d0d34de35$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $2434d53d0d34de35$export$cd75ccfd720a3cd4; }, function (v) { return $2434d53d0d34de35$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $2434d53d0d34de35$export$fa8d919ba61d84db; }, function (v) { return $2434d53d0d34de35$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $2434d53d0d34de35$export$757ceba2d55c277e; }, function (v) { return $2434d53d0d34de35$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $2434d53d0d34de35$export$b3890eb0ae9dca99; }, function (v) { return $2434d53d0d34de35$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $2434d53d0d34de35$export$502457920280e6be; }, function (v) { return $2434d53d0d34de35$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $2434d53d0d34de35$export$c78a37762a8d58e1; }, function (v) { return $2434d53d0d34de35$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $2434d53d0d34de35$export$dc54d992c10e8a18; }, function (v) { return $2434d53d0d34de35$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $2434d53d0d34de35$export$83d89fbfd8236492; }, function (v) { return $2434d53d0d34de35$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $2434d53d0d34de35$export$ae55be85d98224ed;
var $2434d53d0d34de35$export$d39a5bbd09211389;
var $2434d53d0d34de35$export$882461b6382ed46c;
var $2434d53d0d34de35$export$466bfc07425424d5;
var $2434d53d0d34de35$export$cd75ccfd720a3cd4;
var $2434d53d0d34de35$export$fa8d919ba61d84db;
var $2434d53d0d34de35$export$757ceba2d55c277e;
var $2434d53d0d34de35$export$b3890eb0ae9dca99;
var $2434d53d0d34de35$export$502457920280e6be;
var $2434d53d0d34de35$export$c78a37762a8d58e1;
var $2434d53d0d34de35$export$dc54d992c10e8a18;
var $2434d53d0d34de35$export$83d89fbfd8236492;
'use strict';

var $7K7RB = parcelRequire("7K7RB");

var $gaQTF = parcelRequire("gaQTF");
function $2434d53d0d34de35$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $2434d53d0d34de35$var$da = new Set, $2434d53d0d34de35$var$ea = {};
function $2434d53d0d34de35$var$fa(a, b) {
    $2434d53d0d34de35$var$ha(a, b);
    $2434d53d0d34de35$var$ha(a + "Capture", b);
}
function $2434d53d0d34de35$var$ha(a, b) {
    $2434d53d0d34de35$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$2434d53d0d34de35$var$da.add(b[a]);
}
var $2434d53d0d34de35$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $2434d53d0d34de35$var$ja = Object.prototype.hasOwnProperty, $2434d53d0d34de35$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $2434d53d0d34de35$var$la = {}, $2434d53d0d34de35$var$ma = {};
function $2434d53d0d34de35$var$oa(a) {
    if ($2434d53d0d34de35$var$ja.call($2434d53d0d34de35$var$ma, a)) return !0;
    if ($2434d53d0d34de35$var$ja.call($2434d53d0d34de35$var$la, a)) return !1;
    if ($2434d53d0d34de35$var$ka.test(a)) return $2434d53d0d34de35$var$ma[a] = !0;
    $2434d53d0d34de35$var$la[a] = !0;
    return !1;
}
function $2434d53d0d34de35$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $2434d53d0d34de35$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $2434d53d0d34de35$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $2434d53d0d34de35$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $2434d53d0d34de35$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $2434d53d0d34de35$var$z[a] = new $2434d53d0d34de35$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $2434d53d0d34de35$var$z[b] = new $2434d53d0d34de35$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $2434d53d0d34de35$var$z[a] = new $2434d53d0d34de35$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $2434d53d0d34de35$var$z[a] = new $2434d53d0d34de35$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $2434d53d0d34de35$var$z[a] = new $2434d53d0d34de35$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $2434d53d0d34de35$var$z[a] = new $2434d53d0d34de35$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $2434d53d0d34de35$var$z[a] = new $2434d53d0d34de35$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $2434d53d0d34de35$var$z[a] = new $2434d53d0d34de35$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $2434d53d0d34de35$var$z[a] = new $2434d53d0d34de35$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $2434d53d0d34de35$var$ra = /[\-:]([a-z])/g;
function $2434d53d0d34de35$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($2434d53d0d34de35$var$ra, $2434d53d0d34de35$var$sa);
    $2434d53d0d34de35$var$z[b] = new $2434d53d0d34de35$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($2434d53d0d34de35$var$ra, $2434d53d0d34de35$var$sa);
    $2434d53d0d34de35$var$z[b] = new $2434d53d0d34de35$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($2434d53d0d34de35$var$ra, $2434d53d0d34de35$var$sa);
    $2434d53d0d34de35$var$z[b] = new $2434d53d0d34de35$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $2434d53d0d34de35$var$z[a] = new $2434d53d0d34de35$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$2434d53d0d34de35$var$z.xlinkHref = new $2434d53d0d34de35$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $2434d53d0d34de35$var$z[a] = new $2434d53d0d34de35$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $2434d53d0d34de35$var$ta(a, b, c, d) {
    var e = $2434d53d0d34de35$var$z.hasOwnProperty(b) ? $2434d53d0d34de35$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $2434d53d0d34de35$var$qa(b, c, e, d) && (c = null), d || null === e ? $2434d53d0d34de35$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $2434d53d0d34de35$var$ua = $7K7RB.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $2434d53d0d34de35$var$va = Symbol.for("react.element"), $2434d53d0d34de35$var$wa = Symbol.for("react.portal"), $2434d53d0d34de35$var$ya = Symbol.for("react.fragment"), $2434d53d0d34de35$var$za = Symbol.for("react.strict_mode"), $2434d53d0d34de35$var$Aa = Symbol.for("react.profiler"), $2434d53d0d34de35$var$Ba = Symbol.for("react.provider"), $2434d53d0d34de35$var$Ca = Symbol.for("react.context"), $2434d53d0d34de35$var$Da = Symbol.for("react.forward_ref"), $2434d53d0d34de35$var$Ea = Symbol.for("react.suspense"), $2434d53d0d34de35$var$Fa = Symbol.for("react.suspense_list"), $2434d53d0d34de35$var$Ga = Symbol.for("react.memo"), $2434d53d0d34de35$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $2434d53d0d34de35$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $2434d53d0d34de35$var$Ja = Symbol.iterator;
function $2434d53d0d34de35$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $2434d53d0d34de35$var$Ja && a[$2434d53d0d34de35$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $2434d53d0d34de35$var$A = Object.assign, $2434d53d0d34de35$var$La;
function $2434d53d0d34de35$var$Ma(a) {
    if (void 0 === $2434d53d0d34de35$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $2434d53d0d34de35$var$La = b && b[1] || "";
    }
    return "\n" + $2434d53d0d34de35$var$La + a;
}
var $2434d53d0d34de35$var$Na = !1;
function $2434d53d0d34de35$var$Oa(a, b) {
    if (!a || $2434d53d0d34de35$var$Na) return "";
    $2434d53d0d34de35$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $2434d53d0d34de35$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $2434d53d0d34de35$var$Ma(a) : "";
}
function $2434d53d0d34de35$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $2434d53d0d34de35$var$Ma(a.type);
        case 16:
            return $2434d53d0d34de35$var$Ma("Lazy");
        case 13:
            return $2434d53d0d34de35$var$Ma("Suspense");
        case 19:
            return $2434d53d0d34de35$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $2434d53d0d34de35$var$Oa(a.type, !1), a;
        case 11:
            return a = $2434d53d0d34de35$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $2434d53d0d34de35$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $2434d53d0d34de35$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $2434d53d0d34de35$var$ya:
            return "Fragment";
        case $2434d53d0d34de35$var$wa:
            return "Portal";
        case $2434d53d0d34de35$var$Aa:
            return "Profiler";
        case $2434d53d0d34de35$var$za:
            return "StrictMode";
        case $2434d53d0d34de35$var$Ea:
            return "Suspense";
        case $2434d53d0d34de35$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $2434d53d0d34de35$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $2434d53d0d34de35$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $2434d53d0d34de35$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $2434d53d0d34de35$var$Ga:
            return b = a.displayName || null, null !== b ? b : $2434d53d0d34de35$var$Qa(a.type) || "Memo";
        case $2434d53d0d34de35$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $2434d53d0d34de35$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $2434d53d0d34de35$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $2434d53d0d34de35$var$Qa(b);
        case 8:
            return b === $2434d53d0d34de35$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $2434d53d0d34de35$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $2434d53d0d34de35$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $2434d53d0d34de35$var$Ua(a) {
    var b = $2434d53d0d34de35$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $2434d53d0d34de35$var$Va(a) {
    a._valueTracker || (a._valueTracker = $2434d53d0d34de35$var$Ua(a));
}
function $2434d53d0d34de35$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $2434d53d0d34de35$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $2434d53d0d34de35$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $2434d53d0d34de35$var$Ya(a, b) {
    var c = b.checked;
    return $2434d53d0d34de35$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $2434d53d0d34de35$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $2434d53d0d34de35$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $2434d53d0d34de35$var$ab(a, b) {
    b = b.checked;
    null != b && $2434d53d0d34de35$var$ta(a, "checked", b, !1);
}
function $2434d53d0d34de35$var$bb(a, b) {
    $2434d53d0d34de35$var$ab(a, b);
    var c = $2434d53d0d34de35$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $2434d53d0d34de35$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $2434d53d0d34de35$var$cb(a, b.type, $2434d53d0d34de35$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $2434d53d0d34de35$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $2434d53d0d34de35$var$cb(a, b, c) {
    if ("number" !== b || $2434d53d0d34de35$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $2434d53d0d34de35$var$eb = Array.isArray;
function $2434d53d0d34de35$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $2434d53d0d34de35$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $2434d53d0d34de35$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($2434d53d0d34de35$var$p(91));
    return $2434d53d0d34de35$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $2434d53d0d34de35$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($2434d53d0d34de35$var$p(92));
            if ($2434d53d0d34de35$var$eb(c)) {
                if (1 < c.length) throw Error($2434d53d0d34de35$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $2434d53d0d34de35$var$Sa(c)
    };
}
function $2434d53d0d34de35$var$ib(a, b) {
    var c = $2434d53d0d34de35$var$Sa(b.value), d = $2434d53d0d34de35$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $2434d53d0d34de35$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $2434d53d0d34de35$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $2434d53d0d34de35$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $2434d53d0d34de35$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $2434d53d0d34de35$var$mb, $2434d53d0d34de35$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $2434d53d0d34de35$var$mb = $2434d53d0d34de35$var$mb || document.createElement("div");
        $2434d53d0d34de35$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $2434d53d0d34de35$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $2434d53d0d34de35$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $2434d53d0d34de35$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $2434d53d0d34de35$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($2434d53d0d34de35$var$pb).forEach(function(a) {
    $2434d53d0d34de35$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $2434d53d0d34de35$var$pb[b] = $2434d53d0d34de35$var$pb[a];
    });
});
function $2434d53d0d34de35$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $2434d53d0d34de35$var$pb.hasOwnProperty(a) && $2434d53d0d34de35$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $2434d53d0d34de35$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $2434d53d0d34de35$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $2434d53d0d34de35$var$tb = $2434d53d0d34de35$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $2434d53d0d34de35$var$ub(a, b) {
    if (b) {
        if ($2434d53d0d34de35$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($2434d53d0d34de35$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($2434d53d0d34de35$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($2434d53d0d34de35$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($2434d53d0d34de35$var$p(62));
    }
}
function $2434d53d0d34de35$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $2434d53d0d34de35$var$wb = null;
function $2434d53d0d34de35$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $2434d53d0d34de35$var$yb = null, $2434d53d0d34de35$var$zb = null, $2434d53d0d34de35$var$Ab = null;
function $2434d53d0d34de35$var$Bb(a) {
    if (a = $2434d53d0d34de35$var$Cb(a)) {
        if ("function" !== typeof $2434d53d0d34de35$var$yb) throw Error($2434d53d0d34de35$var$p(280));
        var b = a.stateNode;
        b && (b = $2434d53d0d34de35$var$Db(b), $2434d53d0d34de35$var$yb(a.stateNode, a.type, b));
    }
}
function $2434d53d0d34de35$var$Eb(a) {
    $2434d53d0d34de35$var$zb ? $2434d53d0d34de35$var$Ab ? $2434d53d0d34de35$var$Ab.push(a) : $2434d53d0d34de35$var$Ab = [
        a
    ] : $2434d53d0d34de35$var$zb = a;
}
function $2434d53d0d34de35$var$Fb() {
    if ($2434d53d0d34de35$var$zb) {
        var a = $2434d53d0d34de35$var$zb, b = $2434d53d0d34de35$var$Ab;
        $2434d53d0d34de35$var$Ab = $2434d53d0d34de35$var$zb = null;
        $2434d53d0d34de35$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$2434d53d0d34de35$var$Bb(b[a]);
    }
}
function $2434d53d0d34de35$var$Gb(a, b) {
    return a(b);
}
function $2434d53d0d34de35$var$Hb() {}
var $2434d53d0d34de35$var$Ib = !1;
function $2434d53d0d34de35$var$Jb(a, b, c) {
    if ($2434d53d0d34de35$var$Ib) return a(b, c);
    $2434d53d0d34de35$var$Ib = !0;
    try {
        return $2434d53d0d34de35$var$Gb(a, b, c);
    } finally{
        if ($2434d53d0d34de35$var$Ib = !1, null !== $2434d53d0d34de35$var$zb || null !== $2434d53d0d34de35$var$Ab) $2434d53d0d34de35$var$Hb(), $2434d53d0d34de35$var$Fb();
    }
}
function $2434d53d0d34de35$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $2434d53d0d34de35$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($2434d53d0d34de35$var$p(231, b, typeof c));
    return c;
}
var $2434d53d0d34de35$var$Lb = !1;
if ($2434d53d0d34de35$var$ia) try {
    var $2434d53d0d34de35$var$Mb = {};
    Object.defineProperty($2434d53d0d34de35$var$Mb, "passive", {
        get: function() {
            $2434d53d0d34de35$var$Lb = !0;
        }
    });
    window.addEventListener("test", $2434d53d0d34de35$var$Mb, $2434d53d0d34de35$var$Mb);
    window.removeEventListener("test", $2434d53d0d34de35$var$Mb, $2434d53d0d34de35$var$Mb);
} catch (a) {
    $2434d53d0d34de35$var$Lb = !1;
}
function $2434d53d0d34de35$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $2434d53d0d34de35$var$Ob = !1, $2434d53d0d34de35$var$Pb = null, $2434d53d0d34de35$var$Qb = !1, $2434d53d0d34de35$var$Rb = null, $2434d53d0d34de35$var$Sb = {
    onError: function(a) {
        $2434d53d0d34de35$var$Ob = !0;
        $2434d53d0d34de35$var$Pb = a;
    }
};
function $2434d53d0d34de35$var$Tb(a, b, c, d, e, f, g, h, k) {
    $2434d53d0d34de35$var$Ob = !1;
    $2434d53d0d34de35$var$Pb = null;
    $2434d53d0d34de35$var$Nb.apply($2434d53d0d34de35$var$Sb, arguments);
}
function $2434d53d0d34de35$var$Ub(a, b, c, d, e, f, g, h, k) {
    $2434d53d0d34de35$var$Tb.apply(this, arguments);
    if ($2434d53d0d34de35$var$Ob) {
        if ($2434d53d0d34de35$var$Ob) {
            var l = $2434d53d0d34de35$var$Pb;
            $2434d53d0d34de35$var$Ob = !1;
            $2434d53d0d34de35$var$Pb = null;
        } else throw Error($2434d53d0d34de35$var$p(198));
        $2434d53d0d34de35$var$Qb || ($2434d53d0d34de35$var$Qb = !0, $2434d53d0d34de35$var$Rb = l);
    }
}
function $2434d53d0d34de35$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $2434d53d0d34de35$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $2434d53d0d34de35$var$Xb(a) {
    if ($2434d53d0d34de35$var$Vb(a) !== a) throw Error($2434d53d0d34de35$var$p(188));
}
function $2434d53d0d34de35$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $2434d53d0d34de35$var$Vb(a);
        if (null === b) throw Error($2434d53d0d34de35$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $2434d53d0d34de35$var$Xb(e), a;
                if (f === d) return $2434d53d0d34de35$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($2434d53d0d34de35$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($2434d53d0d34de35$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($2434d53d0d34de35$var$p(190));
    }
    if (3 !== c.tag) throw Error($2434d53d0d34de35$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $2434d53d0d34de35$var$Zb(a) {
    a = $2434d53d0d34de35$var$Yb(a);
    return null !== a ? $2434d53d0d34de35$var$$b(a) : null;
}
function $2434d53d0d34de35$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $2434d53d0d34de35$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $2434d53d0d34de35$var$ac = $gaQTF.unstable_scheduleCallback, $2434d53d0d34de35$var$bc = $gaQTF.unstable_cancelCallback, $2434d53d0d34de35$var$cc = $gaQTF.unstable_shouldYield, $2434d53d0d34de35$var$dc = $gaQTF.unstable_requestPaint, $2434d53d0d34de35$var$B = $gaQTF.unstable_now, $2434d53d0d34de35$var$ec = $gaQTF.unstable_getCurrentPriorityLevel, $2434d53d0d34de35$var$fc = $gaQTF.unstable_ImmediatePriority, $2434d53d0d34de35$var$gc = $gaQTF.unstable_UserBlockingPriority, $2434d53d0d34de35$var$hc = $gaQTF.unstable_NormalPriority, $2434d53d0d34de35$var$ic = $gaQTF.unstable_LowPriority, $2434d53d0d34de35$var$jc = $gaQTF.unstable_IdlePriority, $2434d53d0d34de35$var$kc = null, $2434d53d0d34de35$var$lc = null;
function $2434d53d0d34de35$var$mc(a) {
    if ($2434d53d0d34de35$var$lc && "function" === typeof $2434d53d0d34de35$var$lc.onCommitFiberRoot) try {
        $2434d53d0d34de35$var$lc.onCommitFiberRoot($2434d53d0d34de35$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $2434d53d0d34de35$var$oc = Math.clz32 ? Math.clz32 : $2434d53d0d34de35$var$nc, $2434d53d0d34de35$var$pc = Math.log, $2434d53d0d34de35$var$qc = Math.LN2;
function $2434d53d0d34de35$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($2434d53d0d34de35$var$pc(a) / $2434d53d0d34de35$var$qc | 0) | 0;
}
var $2434d53d0d34de35$var$rc = 64, $2434d53d0d34de35$var$sc = 4194304;
function $2434d53d0d34de35$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $2434d53d0d34de35$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $2434d53d0d34de35$var$tc(h) : (f &= g, 0 !== f && (d = $2434d53d0d34de35$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $2434d53d0d34de35$var$tc(g) : 0 !== f && (d = $2434d53d0d34de35$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $2434d53d0d34de35$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $2434d53d0d34de35$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $2434d53d0d34de35$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $2434d53d0d34de35$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $2434d53d0d34de35$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $2434d53d0d34de35$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $2434d53d0d34de35$var$yc() {
    var a = $2434d53d0d34de35$var$rc;
    $2434d53d0d34de35$var$rc <<= 1;
    0 === ($2434d53d0d34de35$var$rc & 4194240) && ($2434d53d0d34de35$var$rc = 64);
    return a;
}
function $2434d53d0d34de35$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $2434d53d0d34de35$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $2434d53d0d34de35$var$oc(b);
    a[b] = c;
}
function $2434d53d0d34de35$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $2434d53d0d34de35$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $2434d53d0d34de35$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $2434d53d0d34de35$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $2434d53d0d34de35$var$C = 0;
function $2434d53d0d34de35$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $2434d53d0d34de35$var$Ec, $2434d53d0d34de35$var$Fc, $2434d53d0d34de35$var$Gc, $2434d53d0d34de35$var$Hc, $2434d53d0d34de35$var$Ic, $2434d53d0d34de35$var$Jc = !1, $2434d53d0d34de35$var$Kc = [], $2434d53d0d34de35$var$Lc = null, $2434d53d0d34de35$var$Mc = null, $2434d53d0d34de35$var$Nc = null, $2434d53d0d34de35$var$Oc = new Map, $2434d53d0d34de35$var$Pc = new Map, $2434d53d0d34de35$var$Qc = [], $2434d53d0d34de35$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $2434d53d0d34de35$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $2434d53d0d34de35$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $2434d53d0d34de35$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $2434d53d0d34de35$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $2434d53d0d34de35$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $2434d53d0d34de35$var$Pc.delete(b.pointerId);
    }
}
function $2434d53d0d34de35$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $2434d53d0d34de35$var$Cb(b), null !== b && $2434d53d0d34de35$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $2434d53d0d34de35$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $2434d53d0d34de35$var$Lc = $2434d53d0d34de35$var$Tc($2434d53d0d34de35$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $2434d53d0d34de35$var$Mc = $2434d53d0d34de35$var$Tc($2434d53d0d34de35$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $2434d53d0d34de35$var$Nc = $2434d53d0d34de35$var$Tc($2434d53d0d34de35$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $2434d53d0d34de35$var$Oc.set(f, $2434d53d0d34de35$var$Tc($2434d53d0d34de35$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $2434d53d0d34de35$var$Pc.set(f, $2434d53d0d34de35$var$Tc($2434d53d0d34de35$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $2434d53d0d34de35$var$Vc(a) {
    var b = $2434d53d0d34de35$var$Wc(a.target);
    if (null !== b) {
        var c = $2434d53d0d34de35$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $2434d53d0d34de35$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $2434d53d0d34de35$var$Ic(a.priority, function() {
                        $2434d53d0d34de35$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $2434d53d0d34de35$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $2434d53d0d34de35$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $2434d53d0d34de35$var$wb = d;
            c.target.dispatchEvent(d);
            $2434d53d0d34de35$var$wb = null;
        } else return b = $2434d53d0d34de35$var$Cb(c), null !== b && $2434d53d0d34de35$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $2434d53d0d34de35$var$Zc(a, b, c) {
    $2434d53d0d34de35$var$Xc(a) && c.delete(b);
}
function $2434d53d0d34de35$var$$c() {
    $2434d53d0d34de35$var$Jc = !1;
    null !== $2434d53d0d34de35$var$Lc && $2434d53d0d34de35$var$Xc($2434d53d0d34de35$var$Lc) && ($2434d53d0d34de35$var$Lc = null);
    null !== $2434d53d0d34de35$var$Mc && $2434d53d0d34de35$var$Xc($2434d53d0d34de35$var$Mc) && ($2434d53d0d34de35$var$Mc = null);
    null !== $2434d53d0d34de35$var$Nc && $2434d53d0d34de35$var$Xc($2434d53d0d34de35$var$Nc) && ($2434d53d0d34de35$var$Nc = null);
    $2434d53d0d34de35$var$Oc.forEach($2434d53d0d34de35$var$Zc);
    $2434d53d0d34de35$var$Pc.forEach($2434d53d0d34de35$var$Zc);
}
function $2434d53d0d34de35$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $2434d53d0d34de35$var$Jc || ($2434d53d0d34de35$var$Jc = !0, $gaQTF.unstable_scheduleCallback($gaQTF.unstable_NormalPriority, $2434d53d0d34de35$var$$c)));
}
function $2434d53d0d34de35$var$bd(a) {
    function b(b) {
        return $2434d53d0d34de35$var$ad(b, a);
    }
    if (0 < $2434d53d0d34de35$var$Kc.length) {
        $2434d53d0d34de35$var$ad($2434d53d0d34de35$var$Kc[0], a);
        for(var c = 1; c < $2434d53d0d34de35$var$Kc.length; c++){
            var d = $2434d53d0d34de35$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $2434d53d0d34de35$var$Lc && $2434d53d0d34de35$var$ad($2434d53d0d34de35$var$Lc, a);
    null !== $2434d53d0d34de35$var$Mc && $2434d53d0d34de35$var$ad($2434d53d0d34de35$var$Mc, a);
    null !== $2434d53d0d34de35$var$Nc && $2434d53d0d34de35$var$ad($2434d53d0d34de35$var$Nc, a);
    $2434d53d0d34de35$var$Oc.forEach(b);
    $2434d53d0d34de35$var$Pc.forEach(b);
    for(c = 0; c < $2434d53d0d34de35$var$Qc.length; c++)d = $2434d53d0d34de35$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $2434d53d0d34de35$var$Qc.length && (c = $2434d53d0d34de35$var$Qc[0], null === c.blockedOn);)$2434d53d0d34de35$var$Vc(c), null === c.blockedOn && $2434d53d0d34de35$var$Qc.shift();
}
var $2434d53d0d34de35$var$cd = $2434d53d0d34de35$var$ua.ReactCurrentBatchConfig, $2434d53d0d34de35$var$dd = !0;
function $2434d53d0d34de35$var$ed(a, b, c, d) {
    var e = $2434d53d0d34de35$var$C, f = $2434d53d0d34de35$var$cd.transition;
    $2434d53d0d34de35$var$cd.transition = null;
    try {
        $2434d53d0d34de35$var$C = 1, $2434d53d0d34de35$var$fd(a, b, c, d);
    } finally{
        $2434d53d0d34de35$var$C = e, $2434d53d0d34de35$var$cd.transition = f;
    }
}
function $2434d53d0d34de35$var$gd(a, b, c, d) {
    var e = $2434d53d0d34de35$var$C, f = $2434d53d0d34de35$var$cd.transition;
    $2434d53d0d34de35$var$cd.transition = null;
    try {
        $2434d53d0d34de35$var$C = 4, $2434d53d0d34de35$var$fd(a, b, c, d);
    } finally{
        $2434d53d0d34de35$var$C = e, $2434d53d0d34de35$var$cd.transition = f;
    }
}
function $2434d53d0d34de35$var$fd(a, b, c, d) {
    if ($2434d53d0d34de35$var$dd) {
        var e = $2434d53d0d34de35$var$Yc(a, b, c, d);
        if (null === e) $2434d53d0d34de35$var$hd(a, b, d, $2434d53d0d34de35$var$id, c), $2434d53d0d34de35$var$Sc(a, d);
        else if ($2434d53d0d34de35$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($2434d53d0d34de35$var$Sc(a, d), b & 4 && -1 < $2434d53d0d34de35$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $2434d53d0d34de35$var$Cb(e);
                null !== f && $2434d53d0d34de35$var$Ec(f);
                f = $2434d53d0d34de35$var$Yc(a, b, c, d);
                null === f && $2434d53d0d34de35$var$hd(a, b, d, $2434d53d0d34de35$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $2434d53d0d34de35$var$hd(a, b, d, null, c);
    }
}
var $2434d53d0d34de35$var$id = null;
function $2434d53d0d34de35$var$Yc(a, b, c, d) {
    $2434d53d0d34de35$var$id = null;
    a = $2434d53d0d34de35$var$xb(d);
    a = $2434d53d0d34de35$var$Wc(a);
    if (null !== a) {
        if (b = $2434d53d0d34de35$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $2434d53d0d34de35$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $2434d53d0d34de35$var$id = a;
    return null;
}
function $2434d53d0d34de35$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($2434d53d0d34de35$var$ec()){
                case $2434d53d0d34de35$var$fc:
                    return 1;
                case $2434d53d0d34de35$var$gc:
                    return 4;
                case $2434d53d0d34de35$var$hc:
                case $2434d53d0d34de35$var$ic:
                    return 16;
                case $2434d53d0d34de35$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $2434d53d0d34de35$var$kd = null, $2434d53d0d34de35$var$ld = null, $2434d53d0d34de35$var$md = null;
function $2434d53d0d34de35$var$nd() {
    if ($2434d53d0d34de35$var$md) return $2434d53d0d34de35$var$md;
    var a, b = $2434d53d0d34de35$var$ld, c = b.length, d, e = "value" in $2434d53d0d34de35$var$kd ? $2434d53d0d34de35$var$kd.value : $2434d53d0d34de35$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $2434d53d0d34de35$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $2434d53d0d34de35$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $2434d53d0d34de35$var$pd() {
    return !0;
}
function $2434d53d0d34de35$var$qd() {
    return !1;
}
function $2434d53d0d34de35$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $2434d53d0d34de35$var$pd : $2434d53d0d34de35$var$qd;
        this.isPropagationStopped = $2434d53d0d34de35$var$qd;
        return this;
    }
    $2434d53d0d34de35$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $2434d53d0d34de35$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $2434d53d0d34de35$var$pd);
        },
        persist: function() {},
        isPersistent: $2434d53d0d34de35$var$pd
    });
    return b;
}
var $2434d53d0d34de35$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $2434d53d0d34de35$var$td = $2434d53d0d34de35$var$rd($2434d53d0d34de35$var$sd), $2434d53d0d34de35$var$ud = $2434d53d0d34de35$var$A({}, $2434d53d0d34de35$var$sd, {
    view: 0,
    detail: 0
}), $2434d53d0d34de35$var$vd = $2434d53d0d34de35$var$rd($2434d53d0d34de35$var$ud), $2434d53d0d34de35$var$wd, $2434d53d0d34de35$var$xd, $2434d53d0d34de35$var$yd, $2434d53d0d34de35$var$Ad = $2434d53d0d34de35$var$A({}, $2434d53d0d34de35$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $2434d53d0d34de35$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $2434d53d0d34de35$var$yd && ($2434d53d0d34de35$var$yd && "mousemove" === a.type ? ($2434d53d0d34de35$var$wd = a.screenX - $2434d53d0d34de35$var$yd.screenX, $2434d53d0d34de35$var$xd = a.screenY - $2434d53d0d34de35$var$yd.screenY) : $2434d53d0d34de35$var$xd = $2434d53d0d34de35$var$wd = 0, $2434d53d0d34de35$var$yd = a);
        return $2434d53d0d34de35$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $2434d53d0d34de35$var$xd;
    }
}), $2434d53d0d34de35$var$Bd = $2434d53d0d34de35$var$rd($2434d53d0d34de35$var$Ad), $2434d53d0d34de35$var$Cd = $2434d53d0d34de35$var$A({}, $2434d53d0d34de35$var$Ad, {
    dataTransfer: 0
}), $2434d53d0d34de35$var$Dd = $2434d53d0d34de35$var$rd($2434d53d0d34de35$var$Cd), $2434d53d0d34de35$var$Ed = $2434d53d0d34de35$var$A({}, $2434d53d0d34de35$var$ud, {
    relatedTarget: 0
}), $2434d53d0d34de35$var$Fd = $2434d53d0d34de35$var$rd($2434d53d0d34de35$var$Ed), $2434d53d0d34de35$var$Gd = $2434d53d0d34de35$var$A({}, $2434d53d0d34de35$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2434d53d0d34de35$var$Hd = $2434d53d0d34de35$var$rd($2434d53d0d34de35$var$Gd), $2434d53d0d34de35$var$Id = $2434d53d0d34de35$var$A({}, $2434d53d0d34de35$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $2434d53d0d34de35$var$Jd = $2434d53d0d34de35$var$rd($2434d53d0d34de35$var$Id), $2434d53d0d34de35$var$Kd = $2434d53d0d34de35$var$A({}, $2434d53d0d34de35$var$sd, {
    data: 0
}), $2434d53d0d34de35$var$Ld = $2434d53d0d34de35$var$rd($2434d53d0d34de35$var$Kd), $2434d53d0d34de35$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $2434d53d0d34de35$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $2434d53d0d34de35$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $2434d53d0d34de35$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $2434d53d0d34de35$var$Od[a]) ? !!b[a] : !1;
}
function $2434d53d0d34de35$var$zd() {
    return $2434d53d0d34de35$var$Pd;
}
var $2434d53d0d34de35$var$Qd = $2434d53d0d34de35$var$A({}, $2434d53d0d34de35$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $2434d53d0d34de35$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $2434d53d0d34de35$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $2434d53d0d34de35$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $2434d53d0d34de35$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $2434d53d0d34de35$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $2434d53d0d34de35$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $2434d53d0d34de35$var$Rd = $2434d53d0d34de35$var$rd($2434d53d0d34de35$var$Qd), $2434d53d0d34de35$var$Sd = $2434d53d0d34de35$var$A({}, $2434d53d0d34de35$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $2434d53d0d34de35$var$Td = $2434d53d0d34de35$var$rd($2434d53d0d34de35$var$Sd), $2434d53d0d34de35$var$Ud = $2434d53d0d34de35$var$A({}, $2434d53d0d34de35$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $2434d53d0d34de35$var$zd
}), $2434d53d0d34de35$var$Vd = $2434d53d0d34de35$var$rd($2434d53d0d34de35$var$Ud), $2434d53d0d34de35$var$Wd = $2434d53d0d34de35$var$A({}, $2434d53d0d34de35$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2434d53d0d34de35$var$Xd = $2434d53d0d34de35$var$rd($2434d53d0d34de35$var$Wd), $2434d53d0d34de35$var$Yd = $2434d53d0d34de35$var$A({}, $2434d53d0d34de35$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $2434d53d0d34de35$var$Zd = $2434d53d0d34de35$var$rd($2434d53d0d34de35$var$Yd), $2434d53d0d34de35$var$$d = [
    9,
    13,
    27,
    32
], $2434d53d0d34de35$var$ae = $2434d53d0d34de35$var$ia && "CompositionEvent" in window, $2434d53d0d34de35$var$be = null;
$2434d53d0d34de35$var$ia && "documentMode" in document && ($2434d53d0d34de35$var$be = document.documentMode);
var $2434d53d0d34de35$var$ce = $2434d53d0d34de35$var$ia && "TextEvent" in window && !$2434d53d0d34de35$var$be, $2434d53d0d34de35$var$de = $2434d53d0d34de35$var$ia && (!$2434d53d0d34de35$var$ae || $2434d53d0d34de35$var$be && 8 < $2434d53d0d34de35$var$be && 11 >= $2434d53d0d34de35$var$be), $2434d53d0d34de35$var$ee = String.fromCharCode(32), $2434d53d0d34de35$var$fe = !1;
function $2434d53d0d34de35$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $2434d53d0d34de35$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $2434d53d0d34de35$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $2434d53d0d34de35$var$ie = !1;
function $2434d53d0d34de35$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $2434d53d0d34de35$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $2434d53d0d34de35$var$fe = !0;
            return $2434d53d0d34de35$var$ee;
        case "textInput":
            return a = b.data, a === $2434d53d0d34de35$var$ee && $2434d53d0d34de35$var$fe ? null : a;
        default:
            return null;
    }
}
function $2434d53d0d34de35$var$ke(a, b) {
    if ($2434d53d0d34de35$var$ie) return "compositionend" === a || !$2434d53d0d34de35$var$ae && $2434d53d0d34de35$var$ge(a, b) ? (a = $2434d53d0d34de35$var$nd(), $2434d53d0d34de35$var$md = $2434d53d0d34de35$var$ld = $2434d53d0d34de35$var$kd = null, $2434d53d0d34de35$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $2434d53d0d34de35$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $2434d53d0d34de35$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $2434d53d0d34de35$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$2434d53d0d34de35$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $2434d53d0d34de35$var$ne(a, b, c, d) {
    $2434d53d0d34de35$var$Eb(d);
    b = $2434d53d0d34de35$var$oe(b, "onChange");
    0 < b.length && (c = new $2434d53d0d34de35$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $2434d53d0d34de35$var$pe = null, $2434d53d0d34de35$var$qe = null;
function $2434d53d0d34de35$var$re(a) {
    $2434d53d0d34de35$var$se(a, 0);
}
function $2434d53d0d34de35$var$te(a) {
    var b = $2434d53d0d34de35$var$ue(a);
    if ($2434d53d0d34de35$var$Wa(b)) return a;
}
function $2434d53d0d34de35$var$ve(a, b) {
    if ("change" === a) return b;
}
var $2434d53d0d34de35$var$we = !1;
if ($2434d53d0d34de35$var$ia) {
    var $2434d53d0d34de35$var$xe;
    if ($2434d53d0d34de35$var$ia) {
        var $2434d53d0d34de35$var$ye = "oninput" in document;
        if (!$2434d53d0d34de35$var$ye) {
            var $2434d53d0d34de35$var$ze = document.createElement("div");
            $2434d53d0d34de35$var$ze.setAttribute("oninput", "return;");
            $2434d53d0d34de35$var$ye = "function" === typeof $2434d53d0d34de35$var$ze.oninput;
        }
        $2434d53d0d34de35$var$xe = $2434d53d0d34de35$var$ye;
    } else $2434d53d0d34de35$var$xe = !1;
    $2434d53d0d34de35$var$we = $2434d53d0d34de35$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $2434d53d0d34de35$var$Ae() {
    $2434d53d0d34de35$var$pe && ($2434d53d0d34de35$var$pe.detachEvent("onpropertychange", $2434d53d0d34de35$var$Be), $2434d53d0d34de35$var$qe = $2434d53d0d34de35$var$pe = null);
}
function $2434d53d0d34de35$var$Be(a) {
    if ("value" === a.propertyName && $2434d53d0d34de35$var$te($2434d53d0d34de35$var$qe)) {
        var b = [];
        $2434d53d0d34de35$var$ne(b, $2434d53d0d34de35$var$qe, a, $2434d53d0d34de35$var$xb(a));
        $2434d53d0d34de35$var$Jb($2434d53d0d34de35$var$re, b);
    }
}
function $2434d53d0d34de35$var$Ce(a, b, c) {
    "focusin" === a ? ($2434d53d0d34de35$var$Ae(), $2434d53d0d34de35$var$pe = b, $2434d53d0d34de35$var$qe = c, $2434d53d0d34de35$var$pe.attachEvent("onpropertychange", $2434d53d0d34de35$var$Be)) : "focusout" === a && $2434d53d0d34de35$var$Ae();
}
function $2434d53d0d34de35$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $2434d53d0d34de35$var$te($2434d53d0d34de35$var$qe);
}
function $2434d53d0d34de35$var$Ee(a, b) {
    if ("click" === a) return $2434d53d0d34de35$var$te(b);
}
function $2434d53d0d34de35$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $2434d53d0d34de35$var$te(b);
}
function $2434d53d0d34de35$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2434d53d0d34de35$var$He = "function" === typeof Object.is ? Object.is : $2434d53d0d34de35$var$Ge;
function $2434d53d0d34de35$var$Ie(a, b) {
    if ($2434d53d0d34de35$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$2434d53d0d34de35$var$ja.call(b, e) || !$2434d53d0d34de35$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $2434d53d0d34de35$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $2434d53d0d34de35$var$Ke(a, b) {
    var c = $2434d53d0d34de35$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $2434d53d0d34de35$var$Je(c);
    }
}
function $2434d53d0d34de35$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $2434d53d0d34de35$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $2434d53d0d34de35$var$Me() {
    for(var a = window, b = $2434d53d0d34de35$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $2434d53d0d34de35$var$Xa(a.document);
    }
    return b;
}
function $2434d53d0d34de35$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $2434d53d0d34de35$var$Oe(a) {
    var b = $2434d53d0d34de35$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $2434d53d0d34de35$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $2434d53d0d34de35$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $2434d53d0d34de35$var$Ke(c, f);
                var g = $2434d53d0d34de35$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $2434d53d0d34de35$var$Pe = $2434d53d0d34de35$var$ia && "documentMode" in document && 11 >= document.documentMode, $2434d53d0d34de35$var$Qe = null, $2434d53d0d34de35$var$Re = null, $2434d53d0d34de35$var$Se = null, $2434d53d0d34de35$var$Te = !1;
function $2434d53d0d34de35$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $2434d53d0d34de35$var$Te || null == $2434d53d0d34de35$var$Qe || $2434d53d0d34de35$var$Qe !== $2434d53d0d34de35$var$Xa(d) || (d = $2434d53d0d34de35$var$Qe, "selectionStart" in d && $2434d53d0d34de35$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $2434d53d0d34de35$var$Se && $2434d53d0d34de35$var$Ie($2434d53d0d34de35$var$Se, d) || ($2434d53d0d34de35$var$Se = d, d = $2434d53d0d34de35$var$oe($2434d53d0d34de35$var$Re, "onSelect"), 0 < d.length && (b = new $2434d53d0d34de35$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $2434d53d0d34de35$var$Qe)));
}
function $2434d53d0d34de35$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $2434d53d0d34de35$var$We = {
    animationend: $2434d53d0d34de35$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $2434d53d0d34de35$var$Ve("Animation", "AnimationIteration"),
    animationstart: $2434d53d0d34de35$var$Ve("Animation", "AnimationStart"),
    transitionend: $2434d53d0d34de35$var$Ve("Transition", "TransitionEnd")
}, $2434d53d0d34de35$var$Xe = {}, $2434d53d0d34de35$var$Ye = {};
$2434d53d0d34de35$var$ia && ($2434d53d0d34de35$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $2434d53d0d34de35$var$We.animationend.animation, delete $2434d53d0d34de35$var$We.animationiteration.animation, delete $2434d53d0d34de35$var$We.animationstart.animation), "TransitionEvent" in window || delete $2434d53d0d34de35$var$We.transitionend.transition);
function $2434d53d0d34de35$var$Ze(a) {
    if ($2434d53d0d34de35$var$Xe[a]) return $2434d53d0d34de35$var$Xe[a];
    if (!$2434d53d0d34de35$var$We[a]) return a;
    var b = $2434d53d0d34de35$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $2434d53d0d34de35$var$Ye) return $2434d53d0d34de35$var$Xe[a] = b[c];
    return a;
}
var $2434d53d0d34de35$var$$e = $2434d53d0d34de35$var$Ze("animationend"), $2434d53d0d34de35$var$af = $2434d53d0d34de35$var$Ze("animationiteration"), $2434d53d0d34de35$var$bf = $2434d53d0d34de35$var$Ze("animationstart"), $2434d53d0d34de35$var$cf = $2434d53d0d34de35$var$Ze("transitionend"), $2434d53d0d34de35$var$df = new Map, $2434d53d0d34de35$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $2434d53d0d34de35$var$ff(a, b) {
    $2434d53d0d34de35$var$df.set(a, b);
    $2434d53d0d34de35$var$fa(b, [
        a
    ]);
}
for(var $2434d53d0d34de35$var$gf = 0; $2434d53d0d34de35$var$gf < $2434d53d0d34de35$var$ef.length; $2434d53d0d34de35$var$gf++){
    var $2434d53d0d34de35$var$hf = $2434d53d0d34de35$var$ef[$2434d53d0d34de35$var$gf], $2434d53d0d34de35$var$jf = $2434d53d0d34de35$var$hf.toLowerCase(), $2434d53d0d34de35$var$kf = $2434d53d0d34de35$var$hf[0].toUpperCase() + $2434d53d0d34de35$var$hf.slice(1);
    $2434d53d0d34de35$var$ff($2434d53d0d34de35$var$jf, "on" + $2434d53d0d34de35$var$kf);
}
$2434d53d0d34de35$var$ff($2434d53d0d34de35$var$$e, "onAnimationEnd");
$2434d53d0d34de35$var$ff($2434d53d0d34de35$var$af, "onAnimationIteration");
$2434d53d0d34de35$var$ff($2434d53d0d34de35$var$bf, "onAnimationStart");
$2434d53d0d34de35$var$ff("dblclick", "onDoubleClick");
$2434d53d0d34de35$var$ff("focusin", "onFocus");
$2434d53d0d34de35$var$ff("focusout", "onBlur");
$2434d53d0d34de35$var$ff($2434d53d0d34de35$var$cf, "onTransitionEnd");
$2434d53d0d34de35$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$2434d53d0d34de35$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$2434d53d0d34de35$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$2434d53d0d34de35$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$2434d53d0d34de35$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$2434d53d0d34de35$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$2434d53d0d34de35$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$2434d53d0d34de35$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$2434d53d0d34de35$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$2434d53d0d34de35$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $2434d53d0d34de35$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $2434d53d0d34de35$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($2434d53d0d34de35$var$lf));
function $2434d53d0d34de35$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $2434d53d0d34de35$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $2434d53d0d34de35$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $2434d53d0d34de35$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $2434d53d0d34de35$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($2434d53d0d34de35$var$Qb) throw a = $2434d53d0d34de35$var$Rb, $2434d53d0d34de35$var$Qb = !1, $2434d53d0d34de35$var$Rb = null, a;
}
function $2434d53d0d34de35$var$D(a, b) {
    var c = b[$2434d53d0d34de35$var$of];
    void 0 === c && (c = b[$2434d53d0d34de35$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($2434d53d0d34de35$var$pf(b, a, 2, !1), c.add(d));
}
function $2434d53d0d34de35$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $2434d53d0d34de35$var$pf(c, a, d, b);
}
var $2434d53d0d34de35$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $2434d53d0d34de35$var$sf(a) {
    if (!a[$2434d53d0d34de35$var$rf]) {
        a[$2434d53d0d34de35$var$rf] = !0;
        $2434d53d0d34de35$var$da.forEach(function(b) {
            "selectionchange" !== b && ($2434d53d0d34de35$var$mf.has(b) || $2434d53d0d34de35$var$qf(b, !1, a), $2434d53d0d34de35$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$2434d53d0d34de35$var$rf] || (b[$2434d53d0d34de35$var$rf] = !0, $2434d53d0d34de35$var$qf("selectionchange", !1, b));
    }
}
function $2434d53d0d34de35$var$pf(a, b, c, d) {
    switch($2434d53d0d34de35$var$jd(b)){
        case 1:
            var e = $2434d53d0d34de35$var$ed;
            break;
        case 4:
            e = $2434d53d0d34de35$var$gd;
            break;
        default:
            e = $2434d53d0d34de35$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$2434d53d0d34de35$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $2434d53d0d34de35$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $2434d53d0d34de35$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $2434d53d0d34de35$var$Jb(function() {
        var d = f, e = $2434d53d0d34de35$var$xb(c), g = [];
        a: {
            var h = $2434d53d0d34de35$var$df.get(a);
            if (void 0 !== h) {
                var k = $2434d53d0d34de35$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $2434d53d0d34de35$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $2434d53d0d34de35$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $2434d53d0d34de35$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $2434d53d0d34de35$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $2434d53d0d34de35$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $2434d53d0d34de35$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $2434d53d0d34de35$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $2434d53d0d34de35$var$Vd;
                        break;
                    case $2434d53d0d34de35$var$$e:
                    case $2434d53d0d34de35$var$af:
                    case $2434d53d0d34de35$var$bf:
                        k = $2434d53d0d34de35$var$Hd;
                        break;
                    case $2434d53d0d34de35$var$cf:
                        k = $2434d53d0d34de35$var$Xd;
                        break;
                    case "scroll":
                        k = $2434d53d0d34de35$var$vd;
                        break;
                    case "wheel":
                        k = $2434d53d0d34de35$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $2434d53d0d34de35$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $2434d53d0d34de35$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $2434d53d0d34de35$var$Kb(w, x), null != F && t.push($2434d53d0d34de35$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $2434d53d0d34de35$var$wb && (n = c.relatedTarget || c.fromElement) && ($2434d53d0d34de35$var$Wc(n) || n[$2434d53d0d34de35$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $2434d53d0d34de35$var$Wc(n) : null, null !== n && (J = $2434d53d0d34de35$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $2434d53d0d34de35$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $2434d53d0d34de35$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $2434d53d0d34de35$var$ue(k);
                        u = null == n ? h : $2434d53d0d34de35$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $2434d53d0d34de35$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $2434d53d0d34de35$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $2434d53d0d34de35$var$vf(F))u++;
                            for(; 0 < w - u;)t = $2434d53d0d34de35$var$vf(t), w--;
                            for(; 0 < u - w;)x = $2434d53d0d34de35$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $2434d53d0d34de35$var$vf(t);
                                x = $2434d53d0d34de35$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $2434d53d0d34de35$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $2434d53d0d34de35$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $2434d53d0d34de35$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $2434d53d0d34de35$var$ve;
                else if ($2434d53d0d34de35$var$me(h)) {
                    if ($2434d53d0d34de35$var$we) na = $2434d53d0d34de35$var$Fe;
                    else {
                        na = $2434d53d0d34de35$var$De;
                        var xa = $2434d53d0d34de35$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $2434d53d0d34de35$var$Ee);
                if (na && (na = na(a, d))) {
                    $2434d53d0d34de35$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $2434d53d0d34de35$var$cb(h, "number", h.value);
            }
            xa = d ? $2434d53d0d34de35$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($2434d53d0d34de35$var$me(xa) || "true" === xa.contentEditable) $2434d53d0d34de35$var$Qe = xa, $2434d53d0d34de35$var$Re = d, $2434d53d0d34de35$var$Se = null;
                    break;
                case "focusout":
                    $2434d53d0d34de35$var$Se = $2434d53d0d34de35$var$Re = $2434d53d0d34de35$var$Qe = null;
                    break;
                case "mousedown":
                    $2434d53d0d34de35$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $2434d53d0d34de35$var$Te = !1;
                    $2434d53d0d34de35$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($2434d53d0d34de35$var$Pe) break;
                case "keydown":
                case "keyup":
                    $2434d53d0d34de35$var$Ue(g, c, e);
            }
            var $a;
            if ($2434d53d0d34de35$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $2434d53d0d34de35$var$ie ? $2434d53d0d34de35$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($2434d53d0d34de35$var$de && "ko" !== c.locale && ($2434d53d0d34de35$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $2434d53d0d34de35$var$ie && ($a = $2434d53d0d34de35$var$nd()) : ($2434d53d0d34de35$var$kd = e, $2434d53d0d34de35$var$ld = "value" in $2434d53d0d34de35$var$kd ? $2434d53d0d34de35$var$kd.value : $2434d53d0d34de35$var$kd.textContent, $2434d53d0d34de35$var$ie = !0)), xa = $2434d53d0d34de35$var$oe(d, ba), 0 < xa.length && (ba = new $2434d53d0d34de35$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $2434d53d0d34de35$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $2434d53d0d34de35$var$ce ? $2434d53d0d34de35$var$je(a, c) : $2434d53d0d34de35$var$ke(a, c)) d = $2434d53d0d34de35$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $2434d53d0d34de35$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $2434d53d0d34de35$var$se(g, b);
    });
}
function $2434d53d0d34de35$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $2434d53d0d34de35$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $2434d53d0d34de35$var$Kb(a, c), null != f && d.unshift($2434d53d0d34de35$var$tf(a, f, e)), f = $2434d53d0d34de35$var$Kb(a, b), null != f && d.push($2434d53d0d34de35$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $2434d53d0d34de35$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $2434d53d0d34de35$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $2434d53d0d34de35$var$Kb(c, f), null != k && g.unshift($2434d53d0d34de35$var$tf(c, k, h))) : e || (k = $2434d53d0d34de35$var$Kb(c, f), null != k && g.push($2434d53d0d34de35$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $2434d53d0d34de35$var$xf = /\r\n?/g, $2434d53d0d34de35$var$yf = /\u0000|\uFFFD/g;
function $2434d53d0d34de35$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($2434d53d0d34de35$var$xf, "\n").replace($2434d53d0d34de35$var$yf, "");
}
function $2434d53d0d34de35$var$Af(a, b, c) {
    b = $2434d53d0d34de35$var$zf(b);
    if ($2434d53d0d34de35$var$zf(a) !== b && c) throw Error($2434d53d0d34de35$var$p(425));
}
function $2434d53d0d34de35$var$Bf() {}
var $2434d53d0d34de35$var$Cf = null, $2434d53d0d34de35$var$Df = null;
function $2434d53d0d34de35$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $2434d53d0d34de35$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $2434d53d0d34de35$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $2434d53d0d34de35$var$Hf = "function" === typeof Promise ? Promise : void 0, $2434d53d0d34de35$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $2434d53d0d34de35$var$Hf ? function(a) {
    return $2434d53d0d34de35$var$Hf.resolve(null).then(a).catch($2434d53d0d34de35$var$If);
} : $2434d53d0d34de35$var$Ff;
function $2434d53d0d34de35$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $2434d53d0d34de35$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $2434d53d0d34de35$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $2434d53d0d34de35$var$bd(b);
}
function $2434d53d0d34de35$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $2434d53d0d34de35$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $2434d53d0d34de35$var$Nf = Math.random().toString(36).slice(2), $2434d53d0d34de35$var$Of = "__reactFiber$" + $2434d53d0d34de35$var$Nf, $2434d53d0d34de35$var$Pf = "__reactProps$" + $2434d53d0d34de35$var$Nf, $2434d53d0d34de35$var$uf = "__reactContainer$" + $2434d53d0d34de35$var$Nf, $2434d53d0d34de35$var$of = "__reactEvents$" + $2434d53d0d34de35$var$Nf, $2434d53d0d34de35$var$Qf = "__reactListeners$" + $2434d53d0d34de35$var$Nf, $2434d53d0d34de35$var$Rf = "__reactHandles$" + $2434d53d0d34de35$var$Nf;
function $2434d53d0d34de35$var$Wc(a) {
    var b = a[$2434d53d0d34de35$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$2434d53d0d34de35$var$uf] || c[$2434d53d0d34de35$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $2434d53d0d34de35$var$Mf(a); null !== a;){
                if (c = a[$2434d53d0d34de35$var$Of]) return c;
                a = $2434d53d0d34de35$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $2434d53d0d34de35$var$Cb(a) {
    a = a[$2434d53d0d34de35$var$Of] || a[$2434d53d0d34de35$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $2434d53d0d34de35$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($2434d53d0d34de35$var$p(33));
}
function $2434d53d0d34de35$var$Db(a) {
    return a[$2434d53d0d34de35$var$Pf] || null;
}
var $2434d53d0d34de35$var$Sf = [], $2434d53d0d34de35$var$Tf = -1;
function $2434d53d0d34de35$var$Uf(a) {
    return {
        current: a
    };
}
function $2434d53d0d34de35$var$E(a) {
    0 > $2434d53d0d34de35$var$Tf || (a.current = $2434d53d0d34de35$var$Sf[$2434d53d0d34de35$var$Tf], $2434d53d0d34de35$var$Sf[$2434d53d0d34de35$var$Tf] = null, $2434d53d0d34de35$var$Tf--);
}
function $2434d53d0d34de35$var$G(a, b) {
    $2434d53d0d34de35$var$Tf++;
    $2434d53d0d34de35$var$Sf[$2434d53d0d34de35$var$Tf] = a.current;
    a.current = b;
}
var $2434d53d0d34de35$var$Vf = {}, $2434d53d0d34de35$var$H = $2434d53d0d34de35$var$Uf($2434d53d0d34de35$var$Vf), $2434d53d0d34de35$var$Wf = $2434d53d0d34de35$var$Uf(!1), $2434d53d0d34de35$var$Xf = $2434d53d0d34de35$var$Vf;
function $2434d53d0d34de35$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $2434d53d0d34de35$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $2434d53d0d34de35$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $2434d53d0d34de35$var$$f() {
    $2434d53d0d34de35$var$E($2434d53d0d34de35$var$Wf);
    $2434d53d0d34de35$var$E($2434d53d0d34de35$var$H);
}
function $2434d53d0d34de35$var$ag(a, b, c) {
    if ($2434d53d0d34de35$var$H.current !== $2434d53d0d34de35$var$Vf) throw Error($2434d53d0d34de35$var$p(168));
    $2434d53d0d34de35$var$G($2434d53d0d34de35$var$H, b);
    $2434d53d0d34de35$var$G($2434d53d0d34de35$var$Wf, c);
}
function $2434d53d0d34de35$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($2434d53d0d34de35$var$p(108, $2434d53d0d34de35$var$Ra(a) || "Unknown", e));
    return $2434d53d0d34de35$var$A({}, c, d);
}
function $2434d53d0d34de35$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $2434d53d0d34de35$var$Vf;
    $2434d53d0d34de35$var$Xf = $2434d53d0d34de35$var$H.current;
    $2434d53d0d34de35$var$G($2434d53d0d34de35$var$H, a);
    $2434d53d0d34de35$var$G($2434d53d0d34de35$var$Wf, $2434d53d0d34de35$var$Wf.current);
    return !0;
}
function $2434d53d0d34de35$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($2434d53d0d34de35$var$p(169));
    c ? (a = $2434d53d0d34de35$var$bg(a, b, $2434d53d0d34de35$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $2434d53d0d34de35$var$E($2434d53d0d34de35$var$Wf), $2434d53d0d34de35$var$E($2434d53d0d34de35$var$H), $2434d53d0d34de35$var$G($2434d53d0d34de35$var$H, a)) : $2434d53d0d34de35$var$E($2434d53d0d34de35$var$Wf);
    $2434d53d0d34de35$var$G($2434d53d0d34de35$var$Wf, c);
}
var $2434d53d0d34de35$var$eg = null, $2434d53d0d34de35$var$fg = !1, $2434d53d0d34de35$var$gg = !1;
function $2434d53d0d34de35$var$hg(a) {
    null === $2434d53d0d34de35$var$eg ? $2434d53d0d34de35$var$eg = [
        a
    ] : $2434d53d0d34de35$var$eg.push(a);
}
function $2434d53d0d34de35$var$ig(a) {
    $2434d53d0d34de35$var$fg = !0;
    $2434d53d0d34de35$var$hg(a);
}
function $2434d53d0d34de35$var$jg() {
    if (!$2434d53d0d34de35$var$gg && null !== $2434d53d0d34de35$var$eg) {
        $2434d53d0d34de35$var$gg = !0;
        var a = 0, b = $2434d53d0d34de35$var$C;
        try {
            var c = $2434d53d0d34de35$var$eg;
            for($2434d53d0d34de35$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $2434d53d0d34de35$var$eg = null;
            $2434d53d0d34de35$var$fg = !1;
        } catch (e) {
            throw null !== $2434d53d0d34de35$var$eg && ($2434d53d0d34de35$var$eg = $2434d53d0d34de35$var$eg.slice(a + 1)), $2434d53d0d34de35$var$ac($2434d53d0d34de35$var$fc, $2434d53d0d34de35$var$jg), e;
        } finally{
            $2434d53d0d34de35$var$C = b, $2434d53d0d34de35$var$gg = !1;
        }
    }
    return null;
}
var $2434d53d0d34de35$var$kg = [], $2434d53d0d34de35$var$lg = 0, $2434d53d0d34de35$var$mg = null, $2434d53d0d34de35$var$ng = 0, $2434d53d0d34de35$var$og = [], $2434d53d0d34de35$var$pg = 0, $2434d53d0d34de35$var$qg = null, $2434d53d0d34de35$var$rg = 1, $2434d53d0d34de35$var$sg = "";
function $2434d53d0d34de35$var$tg(a, b) {
    $2434d53d0d34de35$var$kg[$2434d53d0d34de35$var$lg++] = $2434d53d0d34de35$var$ng;
    $2434d53d0d34de35$var$kg[$2434d53d0d34de35$var$lg++] = $2434d53d0d34de35$var$mg;
    $2434d53d0d34de35$var$mg = a;
    $2434d53d0d34de35$var$ng = b;
}
function $2434d53d0d34de35$var$ug(a, b, c) {
    $2434d53d0d34de35$var$og[$2434d53d0d34de35$var$pg++] = $2434d53d0d34de35$var$rg;
    $2434d53d0d34de35$var$og[$2434d53d0d34de35$var$pg++] = $2434d53d0d34de35$var$sg;
    $2434d53d0d34de35$var$og[$2434d53d0d34de35$var$pg++] = $2434d53d0d34de35$var$qg;
    $2434d53d0d34de35$var$qg = a;
    var d = $2434d53d0d34de35$var$rg;
    a = $2434d53d0d34de35$var$sg;
    var e = 32 - $2434d53d0d34de35$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $2434d53d0d34de35$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $2434d53d0d34de35$var$rg = 1 << 32 - $2434d53d0d34de35$var$oc(b) + e | c << e | d;
        $2434d53d0d34de35$var$sg = f + a;
    } else $2434d53d0d34de35$var$rg = 1 << f | c << e | d, $2434d53d0d34de35$var$sg = a;
}
function $2434d53d0d34de35$var$vg(a) {
    null !== a.return && ($2434d53d0d34de35$var$tg(a, 1), $2434d53d0d34de35$var$ug(a, 1, 0));
}
function $2434d53d0d34de35$var$wg(a) {
    for(; a === $2434d53d0d34de35$var$mg;)$2434d53d0d34de35$var$mg = $2434d53d0d34de35$var$kg[--$2434d53d0d34de35$var$lg], $2434d53d0d34de35$var$kg[$2434d53d0d34de35$var$lg] = null, $2434d53d0d34de35$var$ng = $2434d53d0d34de35$var$kg[--$2434d53d0d34de35$var$lg], $2434d53d0d34de35$var$kg[$2434d53d0d34de35$var$lg] = null;
    for(; a === $2434d53d0d34de35$var$qg;)$2434d53d0d34de35$var$qg = $2434d53d0d34de35$var$og[--$2434d53d0d34de35$var$pg], $2434d53d0d34de35$var$og[$2434d53d0d34de35$var$pg] = null, $2434d53d0d34de35$var$sg = $2434d53d0d34de35$var$og[--$2434d53d0d34de35$var$pg], $2434d53d0d34de35$var$og[$2434d53d0d34de35$var$pg] = null, $2434d53d0d34de35$var$rg = $2434d53d0d34de35$var$og[--$2434d53d0d34de35$var$pg], $2434d53d0d34de35$var$og[$2434d53d0d34de35$var$pg] = null;
}
var $2434d53d0d34de35$var$xg = null, $2434d53d0d34de35$var$yg = null, $2434d53d0d34de35$var$I = !1, $2434d53d0d34de35$var$zg = null;
function $2434d53d0d34de35$var$Ag(a, b) {
    var c = $2434d53d0d34de35$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $2434d53d0d34de35$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $2434d53d0d34de35$var$xg = a, $2434d53d0d34de35$var$yg = $2434d53d0d34de35$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $2434d53d0d34de35$var$xg = a, $2434d53d0d34de35$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $2434d53d0d34de35$var$qg ? {
                id: $2434d53d0d34de35$var$rg,
                overflow: $2434d53d0d34de35$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $2434d53d0d34de35$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $2434d53d0d34de35$var$xg = a, $2434d53d0d34de35$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $2434d53d0d34de35$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $2434d53d0d34de35$var$Eg(a) {
    if ($2434d53d0d34de35$var$I) {
        var b = $2434d53d0d34de35$var$yg;
        if (b) {
            var c = b;
            if (!$2434d53d0d34de35$var$Cg(a, b)) {
                if ($2434d53d0d34de35$var$Dg(a)) throw Error($2434d53d0d34de35$var$p(418));
                b = $2434d53d0d34de35$var$Lf(c.nextSibling);
                var d = $2434d53d0d34de35$var$xg;
                b && $2434d53d0d34de35$var$Cg(a, b) ? $2434d53d0d34de35$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $2434d53d0d34de35$var$I = !1, $2434d53d0d34de35$var$xg = a);
            }
        } else {
            if ($2434d53d0d34de35$var$Dg(a)) throw Error($2434d53d0d34de35$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $2434d53d0d34de35$var$I = !1;
            $2434d53d0d34de35$var$xg = a;
        }
    }
}
function $2434d53d0d34de35$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $2434d53d0d34de35$var$xg = a;
}
function $2434d53d0d34de35$var$Gg(a) {
    if (a !== $2434d53d0d34de35$var$xg) return !1;
    if (!$2434d53d0d34de35$var$I) return $2434d53d0d34de35$var$Fg(a), $2434d53d0d34de35$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$2434d53d0d34de35$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $2434d53d0d34de35$var$yg)) {
        if ($2434d53d0d34de35$var$Dg(a)) throw $2434d53d0d34de35$var$Hg(), Error($2434d53d0d34de35$var$p(418));
        for(; b;)$2434d53d0d34de35$var$Ag(a, b), b = $2434d53d0d34de35$var$Lf(b.nextSibling);
    }
    $2434d53d0d34de35$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($2434d53d0d34de35$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $2434d53d0d34de35$var$yg = $2434d53d0d34de35$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $2434d53d0d34de35$var$yg = null;
        }
    } else $2434d53d0d34de35$var$yg = $2434d53d0d34de35$var$xg ? $2434d53d0d34de35$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $2434d53d0d34de35$var$Hg() {
    for(var a = $2434d53d0d34de35$var$yg; a;)a = $2434d53d0d34de35$var$Lf(a.nextSibling);
}
function $2434d53d0d34de35$var$Ig() {
    $2434d53d0d34de35$var$yg = $2434d53d0d34de35$var$xg = null;
    $2434d53d0d34de35$var$I = !1;
}
function $2434d53d0d34de35$var$Jg(a) {
    null === $2434d53d0d34de35$var$zg ? $2434d53d0d34de35$var$zg = [
        a
    ] : $2434d53d0d34de35$var$zg.push(a);
}
var $2434d53d0d34de35$var$Kg = $2434d53d0d34de35$var$ua.ReactCurrentBatchConfig;
function $2434d53d0d34de35$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($2434d53d0d34de35$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($2434d53d0d34de35$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($2434d53d0d34de35$var$p(284));
        if (!c._owner) throw Error($2434d53d0d34de35$var$p(290, a));
    }
    return a;
}
function $2434d53d0d34de35$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($2434d53d0d34de35$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $2434d53d0d34de35$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $2434d53d0d34de35$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $2434d53d0d34de35$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $2434d53d0d34de35$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $2434d53d0d34de35$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $2434d53d0d34de35$var$Ha && $2434d53d0d34de35$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $2434d53d0d34de35$var$Lg(a, b, c), d.return = a, d;
        d = $2434d53d0d34de35$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $2434d53d0d34de35$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $2434d53d0d34de35$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $2434d53d0d34de35$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $2434d53d0d34de35$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $2434d53d0d34de35$var$va:
                    return c = $2434d53d0d34de35$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $2434d53d0d34de35$var$Lg(a, null, b), c.return = a, c;
                case $2434d53d0d34de35$var$wa:
                    return b = $2434d53d0d34de35$var$Sg(b, a.mode, c), b.return = a, b;
                case $2434d53d0d34de35$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($2434d53d0d34de35$var$eb(b) || $2434d53d0d34de35$var$Ka(b)) return b = $2434d53d0d34de35$var$Tg(b, a.mode, c, null), b.return = a, b;
            $2434d53d0d34de35$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $2434d53d0d34de35$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $2434d53d0d34de35$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $2434d53d0d34de35$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($2434d53d0d34de35$var$eb(c) || $2434d53d0d34de35$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $2434d53d0d34de35$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $2434d53d0d34de35$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $2434d53d0d34de35$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $2434d53d0d34de35$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($2434d53d0d34de35$var$eb(d) || $2434d53d0d34de35$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $2434d53d0d34de35$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $2434d53d0d34de35$var$I && $2434d53d0d34de35$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $2434d53d0d34de35$var$I && $2434d53d0d34de35$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $2434d53d0d34de35$var$I && $2434d53d0d34de35$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $2434d53d0d34de35$var$Ka(h);
        if ("function" !== typeof l) throw Error($2434d53d0d34de35$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($2434d53d0d34de35$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $2434d53d0d34de35$var$I && $2434d53d0d34de35$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $2434d53d0d34de35$var$I && $2434d53d0d34de35$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $2434d53d0d34de35$var$I && $2434d53d0d34de35$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $2434d53d0d34de35$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $2434d53d0d34de35$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $2434d53d0d34de35$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $2434d53d0d34de35$var$Ha && $2434d53d0d34de35$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $2434d53d0d34de35$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $2434d53d0d34de35$var$ya ? (d = $2434d53d0d34de35$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $2434d53d0d34de35$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $2434d53d0d34de35$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $2434d53d0d34de35$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $2434d53d0d34de35$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $2434d53d0d34de35$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($2434d53d0d34de35$var$eb(f)) return n(a, d, f, h);
            if ($2434d53d0d34de35$var$Ka(f)) return t(a, d, f, h);
            $2434d53d0d34de35$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $2434d53d0d34de35$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $2434d53d0d34de35$var$Ug = $2434d53d0d34de35$var$Og(!0), $2434d53d0d34de35$var$Vg = $2434d53d0d34de35$var$Og(!1), $2434d53d0d34de35$var$Wg = $2434d53d0d34de35$var$Uf(null), $2434d53d0d34de35$var$Xg = null, $2434d53d0d34de35$var$Yg = null, $2434d53d0d34de35$var$Zg = null;
function $2434d53d0d34de35$var$$g() {
    $2434d53d0d34de35$var$Zg = $2434d53d0d34de35$var$Yg = $2434d53d0d34de35$var$Xg = null;
}
function $2434d53d0d34de35$var$ah(a) {
    var b = $2434d53d0d34de35$var$Wg.current;
    $2434d53d0d34de35$var$E($2434d53d0d34de35$var$Wg);
    a._currentValue = b;
}
function $2434d53d0d34de35$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $2434d53d0d34de35$var$ch(a, b) {
    $2434d53d0d34de35$var$Xg = a;
    $2434d53d0d34de35$var$Zg = $2434d53d0d34de35$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($2434d53d0d34de35$var$dh = !0), a.firstContext = null);
}
function $2434d53d0d34de35$var$eh(a) {
    var b = a._currentValue;
    if ($2434d53d0d34de35$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $2434d53d0d34de35$var$Yg) {
            if (null === $2434d53d0d34de35$var$Xg) throw Error($2434d53d0d34de35$var$p(308));
            $2434d53d0d34de35$var$Yg = a;
            $2434d53d0d34de35$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $2434d53d0d34de35$var$Yg = $2434d53d0d34de35$var$Yg.next = a;
    }
    return b;
}
var $2434d53d0d34de35$var$fh = null;
function $2434d53d0d34de35$var$gh(a) {
    null === $2434d53d0d34de35$var$fh ? $2434d53d0d34de35$var$fh = [
        a
    ] : $2434d53d0d34de35$var$fh.push(a);
}
function $2434d53d0d34de35$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $2434d53d0d34de35$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $2434d53d0d34de35$var$ih(a, d);
}
function $2434d53d0d34de35$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $2434d53d0d34de35$var$jh = !1;
function $2434d53d0d34de35$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $2434d53d0d34de35$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $2434d53d0d34de35$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $2434d53d0d34de35$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($2434d53d0d34de35$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $2434d53d0d34de35$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $2434d53d0d34de35$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $2434d53d0d34de35$var$ih(a, c);
}
function $2434d53d0d34de35$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $2434d53d0d34de35$var$Cc(a, c);
    }
}
function $2434d53d0d34de35$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $2434d53d0d34de35$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $2434d53d0d34de35$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $2434d53d0d34de35$var$A({}, q, r);
                            break a;
                        case 2:
                            $2434d53d0d34de35$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $2434d53d0d34de35$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $2434d53d0d34de35$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($2434d53d0d34de35$var$p(191, e));
            e.call(d);
        }
    }
}
var $2434d53d0d34de35$var$th = {}, $2434d53d0d34de35$var$uh = $2434d53d0d34de35$var$Uf($2434d53d0d34de35$var$th), $2434d53d0d34de35$var$vh = $2434d53d0d34de35$var$Uf($2434d53d0d34de35$var$th), $2434d53d0d34de35$var$wh = $2434d53d0d34de35$var$Uf($2434d53d0d34de35$var$th);
function $2434d53d0d34de35$var$xh(a) {
    if (a === $2434d53d0d34de35$var$th) throw Error($2434d53d0d34de35$var$p(174));
    return a;
}
function $2434d53d0d34de35$var$yh(a, b) {
    $2434d53d0d34de35$var$G($2434d53d0d34de35$var$wh, b);
    $2434d53d0d34de35$var$G($2434d53d0d34de35$var$vh, a);
    $2434d53d0d34de35$var$G($2434d53d0d34de35$var$uh, $2434d53d0d34de35$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $2434d53d0d34de35$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $2434d53d0d34de35$var$lb(b, a);
    }
    $2434d53d0d34de35$var$E($2434d53d0d34de35$var$uh);
    $2434d53d0d34de35$var$G($2434d53d0d34de35$var$uh, b);
}
function $2434d53d0d34de35$var$zh() {
    $2434d53d0d34de35$var$E($2434d53d0d34de35$var$uh);
    $2434d53d0d34de35$var$E($2434d53d0d34de35$var$vh);
    $2434d53d0d34de35$var$E($2434d53d0d34de35$var$wh);
}
function $2434d53d0d34de35$var$Ah(a) {
    $2434d53d0d34de35$var$xh($2434d53d0d34de35$var$wh.current);
    var b = $2434d53d0d34de35$var$xh($2434d53d0d34de35$var$uh.current);
    var c = $2434d53d0d34de35$var$lb(b, a.type);
    b !== c && ($2434d53d0d34de35$var$G($2434d53d0d34de35$var$vh, a), $2434d53d0d34de35$var$G($2434d53d0d34de35$var$uh, c));
}
function $2434d53d0d34de35$var$Bh(a) {
    $2434d53d0d34de35$var$vh.current === a && ($2434d53d0d34de35$var$E($2434d53d0d34de35$var$uh), $2434d53d0d34de35$var$E($2434d53d0d34de35$var$vh));
}
var $2434d53d0d34de35$var$L = $2434d53d0d34de35$var$Uf(0);
function $2434d53d0d34de35$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $2434d53d0d34de35$var$Dh = [];
function $2434d53d0d34de35$var$Eh() {
    for(var a = 0; a < $2434d53d0d34de35$var$Dh.length; a++)$2434d53d0d34de35$var$Dh[a]._workInProgressVersionPrimary = null;
    $2434d53d0d34de35$var$Dh.length = 0;
}
var $2434d53d0d34de35$var$Fh = $2434d53d0d34de35$var$ua.ReactCurrentDispatcher, $2434d53d0d34de35$var$Gh = $2434d53d0d34de35$var$ua.ReactCurrentBatchConfig, $2434d53d0d34de35$var$Hh = 0, $2434d53d0d34de35$var$M = null, $2434d53d0d34de35$var$N = null, $2434d53d0d34de35$var$O = null, $2434d53d0d34de35$var$Ih = !1, $2434d53d0d34de35$var$Jh = !1, $2434d53d0d34de35$var$Kh = 0, $2434d53d0d34de35$var$Lh = 0;
function $2434d53d0d34de35$var$P() {
    throw Error($2434d53d0d34de35$var$p(321));
}
function $2434d53d0d34de35$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$2434d53d0d34de35$var$He(a[c], b[c])) return !1;
    return !0;
}
function $2434d53d0d34de35$var$Nh(a, b, c, d, e, f) {
    $2434d53d0d34de35$var$Hh = f;
    $2434d53d0d34de35$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $2434d53d0d34de35$var$Fh.current = null === a || null === a.memoizedState ? $2434d53d0d34de35$var$Oh : $2434d53d0d34de35$var$Ph;
    a = c(d, e);
    if ($2434d53d0d34de35$var$Jh) {
        f = 0;
        do {
            $2434d53d0d34de35$var$Jh = !1;
            $2434d53d0d34de35$var$Kh = 0;
            if (25 <= f) throw Error($2434d53d0d34de35$var$p(301));
            f += 1;
            $2434d53d0d34de35$var$O = $2434d53d0d34de35$var$N = null;
            b.updateQueue = null;
            $2434d53d0d34de35$var$Fh.current = $2434d53d0d34de35$var$Qh;
            a = c(d, e);
        }while ($2434d53d0d34de35$var$Jh);
    }
    $2434d53d0d34de35$var$Fh.current = $2434d53d0d34de35$var$Rh;
    b = null !== $2434d53d0d34de35$var$N && null !== $2434d53d0d34de35$var$N.next;
    $2434d53d0d34de35$var$Hh = 0;
    $2434d53d0d34de35$var$O = $2434d53d0d34de35$var$N = $2434d53d0d34de35$var$M = null;
    $2434d53d0d34de35$var$Ih = !1;
    if (b) throw Error($2434d53d0d34de35$var$p(300));
    return a;
}
function $2434d53d0d34de35$var$Sh() {
    var a = 0 !== $2434d53d0d34de35$var$Kh;
    $2434d53d0d34de35$var$Kh = 0;
    return a;
}
function $2434d53d0d34de35$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $2434d53d0d34de35$var$O ? $2434d53d0d34de35$var$M.memoizedState = $2434d53d0d34de35$var$O = a : $2434d53d0d34de35$var$O = $2434d53d0d34de35$var$O.next = a;
    return $2434d53d0d34de35$var$O;
}
function $2434d53d0d34de35$var$Uh() {
    if (null === $2434d53d0d34de35$var$N) {
        var a = $2434d53d0d34de35$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $2434d53d0d34de35$var$N.next;
    var b = null === $2434d53d0d34de35$var$O ? $2434d53d0d34de35$var$M.memoizedState : $2434d53d0d34de35$var$O.next;
    if (null !== b) $2434d53d0d34de35$var$O = b, $2434d53d0d34de35$var$N = a;
    else {
        if (null === a) throw Error($2434d53d0d34de35$var$p(310));
        $2434d53d0d34de35$var$N = a;
        a = {
            memoizedState: $2434d53d0d34de35$var$N.memoizedState,
            baseState: $2434d53d0d34de35$var$N.baseState,
            baseQueue: $2434d53d0d34de35$var$N.baseQueue,
            queue: $2434d53d0d34de35$var$N.queue,
            next: null
        };
        null === $2434d53d0d34de35$var$O ? $2434d53d0d34de35$var$M.memoizedState = $2434d53d0d34de35$var$O = a : $2434d53d0d34de35$var$O = $2434d53d0d34de35$var$O.next = a;
    }
    return $2434d53d0d34de35$var$O;
}
function $2434d53d0d34de35$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $2434d53d0d34de35$var$Wh(a) {
    var b = $2434d53d0d34de35$var$Uh(), c = b.queue;
    if (null === c) throw Error($2434d53d0d34de35$var$p(311));
    c.lastRenderedReducer = a;
    var d = $2434d53d0d34de35$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($2434d53d0d34de35$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $2434d53d0d34de35$var$M.lanes |= m;
                $2434d53d0d34de35$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $2434d53d0d34de35$var$He(d, b.memoizedState) || ($2434d53d0d34de35$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $2434d53d0d34de35$var$M.lanes |= f, $2434d53d0d34de35$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $2434d53d0d34de35$var$Xh(a) {
    var b = $2434d53d0d34de35$var$Uh(), c = b.queue;
    if (null === c) throw Error($2434d53d0d34de35$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $2434d53d0d34de35$var$He(f, b.memoizedState) || ($2434d53d0d34de35$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $2434d53d0d34de35$var$Yh() {}
function $2434d53d0d34de35$var$Zh(a, b) {
    var c = $2434d53d0d34de35$var$M, d = $2434d53d0d34de35$var$Uh(), e = b(), f = !$2434d53d0d34de35$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $2434d53d0d34de35$var$dh = !0);
    d = d.queue;
    $2434d53d0d34de35$var$$h($2434d53d0d34de35$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $2434d53d0d34de35$var$O && $2434d53d0d34de35$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $2434d53d0d34de35$var$bi(9, $2434d53d0d34de35$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $2434d53d0d34de35$var$Q) throw Error($2434d53d0d34de35$var$p(349));
        0 !== ($2434d53d0d34de35$var$Hh & 30) || $2434d53d0d34de35$var$di(c, b, e);
    }
    return e;
}
function $2434d53d0d34de35$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $2434d53d0d34de35$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $2434d53d0d34de35$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $2434d53d0d34de35$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $2434d53d0d34de35$var$ei(b) && $2434d53d0d34de35$var$fi(a);
}
function $2434d53d0d34de35$var$ai(a, b, c) {
    return c(function() {
        $2434d53d0d34de35$var$ei(b) && $2434d53d0d34de35$var$fi(a);
    });
}
function $2434d53d0d34de35$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$2434d53d0d34de35$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $2434d53d0d34de35$var$fi(a) {
    var b = $2434d53d0d34de35$var$ih(a, 1);
    null !== b && $2434d53d0d34de35$var$gi(b, a, 1, -1);
}
function $2434d53d0d34de35$var$hi(a) {
    var b = $2434d53d0d34de35$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2434d53d0d34de35$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $2434d53d0d34de35$var$ii.bind(null, $2434d53d0d34de35$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $2434d53d0d34de35$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $2434d53d0d34de35$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $2434d53d0d34de35$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $2434d53d0d34de35$var$ji() {
    return $2434d53d0d34de35$var$Uh().memoizedState;
}
function $2434d53d0d34de35$var$ki(a, b, c, d) {
    var e = $2434d53d0d34de35$var$Th();
    $2434d53d0d34de35$var$M.flags |= a;
    e.memoizedState = $2434d53d0d34de35$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $2434d53d0d34de35$var$li(a, b, c, d) {
    var e = $2434d53d0d34de35$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $2434d53d0d34de35$var$N) {
        var g = $2434d53d0d34de35$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $2434d53d0d34de35$var$Mh(d, g.deps)) {
            e.memoizedState = $2434d53d0d34de35$var$bi(b, c, f, d);
            return;
        }
    }
    $2434d53d0d34de35$var$M.flags |= a;
    e.memoizedState = $2434d53d0d34de35$var$bi(1 | b, c, f, d);
}
function $2434d53d0d34de35$var$mi(a, b) {
    return $2434d53d0d34de35$var$ki(8390656, 8, a, b);
}
function $2434d53d0d34de35$var$$h(a, b) {
    return $2434d53d0d34de35$var$li(2048, 8, a, b);
}
function $2434d53d0d34de35$var$ni(a, b) {
    return $2434d53d0d34de35$var$li(4, 2, a, b);
}
function $2434d53d0d34de35$var$oi(a, b) {
    return $2434d53d0d34de35$var$li(4, 4, a, b);
}
function $2434d53d0d34de35$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $2434d53d0d34de35$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $2434d53d0d34de35$var$li(4, 4, $2434d53d0d34de35$var$pi.bind(null, b, a), c);
}
function $2434d53d0d34de35$var$ri() {}
function $2434d53d0d34de35$var$si(a, b) {
    var c = $2434d53d0d34de35$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $2434d53d0d34de35$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2434d53d0d34de35$var$ti(a, b) {
    var c = $2434d53d0d34de35$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $2434d53d0d34de35$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2434d53d0d34de35$var$ui(a, b, c) {
    if (0 === ($2434d53d0d34de35$var$Hh & 21)) return a.baseState && (a.baseState = !1, $2434d53d0d34de35$var$dh = !0), a.memoizedState = c;
    $2434d53d0d34de35$var$He(c, b) || (c = $2434d53d0d34de35$var$yc(), $2434d53d0d34de35$var$M.lanes |= c, $2434d53d0d34de35$var$rh |= c, a.baseState = !0);
    return b;
}
function $2434d53d0d34de35$var$vi(a, b) {
    var c = $2434d53d0d34de35$var$C;
    $2434d53d0d34de35$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $2434d53d0d34de35$var$Gh.transition;
    $2434d53d0d34de35$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $2434d53d0d34de35$var$C = c, $2434d53d0d34de35$var$Gh.transition = d;
    }
}
function $2434d53d0d34de35$var$wi() {
    return $2434d53d0d34de35$var$Uh().memoizedState;
}
function $2434d53d0d34de35$var$xi(a, b, c) {
    var d = $2434d53d0d34de35$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2434d53d0d34de35$var$zi(a)) $2434d53d0d34de35$var$Ai(b, c);
    else if (c = $2434d53d0d34de35$var$hh(a, b, c, d), null !== c) {
        var e = $2434d53d0d34de35$var$R();
        $2434d53d0d34de35$var$gi(c, a, d, e);
        $2434d53d0d34de35$var$Bi(c, b, d);
    }
}
function $2434d53d0d34de35$var$ii(a, b, c) {
    var d = $2434d53d0d34de35$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2434d53d0d34de35$var$zi(a)) $2434d53d0d34de35$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($2434d53d0d34de35$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $2434d53d0d34de35$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $2434d53d0d34de35$var$hh(a, b, e, d);
        null !== c && (e = $2434d53d0d34de35$var$R(), $2434d53d0d34de35$var$gi(c, a, d, e), $2434d53d0d34de35$var$Bi(c, b, d));
    }
}
function $2434d53d0d34de35$var$zi(a) {
    var b = a.alternate;
    return a === $2434d53d0d34de35$var$M || null !== b && b === $2434d53d0d34de35$var$M;
}
function $2434d53d0d34de35$var$Ai(a, b) {
    $2434d53d0d34de35$var$Jh = $2434d53d0d34de35$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $2434d53d0d34de35$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $2434d53d0d34de35$var$Cc(a, c);
    }
}
var $2434d53d0d34de35$var$Rh = {
    readContext: $2434d53d0d34de35$var$eh,
    useCallback: $2434d53d0d34de35$var$P,
    useContext: $2434d53d0d34de35$var$P,
    useEffect: $2434d53d0d34de35$var$P,
    useImperativeHandle: $2434d53d0d34de35$var$P,
    useInsertionEffect: $2434d53d0d34de35$var$P,
    useLayoutEffect: $2434d53d0d34de35$var$P,
    useMemo: $2434d53d0d34de35$var$P,
    useReducer: $2434d53d0d34de35$var$P,
    useRef: $2434d53d0d34de35$var$P,
    useState: $2434d53d0d34de35$var$P,
    useDebugValue: $2434d53d0d34de35$var$P,
    useDeferredValue: $2434d53d0d34de35$var$P,
    useTransition: $2434d53d0d34de35$var$P,
    useMutableSource: $2434d53d0d34de35$var$P,
    useSyncExternalStore: $2434d53d0d34de35$var$P,
    useId: $2434d53d0d34de35$var$P,
    unstable_isNewReconciler: !1
}, $2434d53d0d34de35$var$Oh = {
    readContext: $2434d53d0d34de35$var$eh,
    useCallback: function(a, b) {
        $2434d53d0d34de35$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $2434d53d0d34de35$var$eh,
    useEffect: $2434d53d0d34de35$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $2434d53d0d34de35$var$ki(4194308, 4, $2434d53d0d34de35$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $2434d53d0d34de35$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $2434d53d0d34de35$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $2434d53d0d34de35$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $2434d53d0d34de35$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $2434d53d0d34de35$var$xi.bind(null, $2434d53d0d34de35$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $2434d53d0d34de35$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $2434d53d0d34de35$var$hi,
    useDebugValue: $2434d53d0d34de35$var$ri,
    useDeferredValue: function(a) {
        return $2434d53d0d34de35$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $2434d53d0d34de35$var$hi(!1), b = a[0];
        a = $2434d53d0d34de35$var$vi.bind(null, a[1]);
        $2434d53d0d34de35$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $2434d53d0d34de35$var$M, e = $2434d53d0d34de35$var$Th();
        if ($2434d53d0d34de35$var$I) {
            if (void 0 === c) throw Error($2434d53d0d34de35$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $2434d53d0d34de35$var$Q) throw Error($2434d53d0d34de35$var$p(349));
            0 !== ($2434d53d0d34de35$var$Hh & 30) || $2434d53d0d34de35$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $2434d53d0d34de35$var$mi($2434d53d0d34de35$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $2434d53d0d34de35$var$bi(9, $2434d53d0d34de35$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $2434d53d0d34de35$var$Th(), b = $2434d53d0d34de35$var$Q.identifierPrefix;
        if ($2434d53d0d34de35$var$I) {
            var c = $2434d53d0d34de35$var$sg;
            var d = $2434d53d0d34de35$var$rg;
            c = (d & ~(1 << 32 - $2434d53d0d34de35$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $2434d53d0d34de35$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $2434d53d0d34de35$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $2434d53d0d34de35$var$Ph = {
    readContext: $2434d53d0d34de35$var$eh,
    useCallback: $2434d53d0d34de35$var$si,
    useContext: $2434d53d0d34de35$var$eh,
    useEffect: $2434d53d0d34de35$var$$h,
    useImperativeHandle: $2434d53d0d34de35$var$qi,
    useInsertionEffect: $2434d53d0d34de35$var$ni,
    useLayoutEffect: $2434d53d0d34de35$var$oi,
    useMemo: $2434d53d0d34de35$var$ti,
    useReducer: $2434d53d0d34de35$var$Wh,
    useRef: $2434d53d0d34de35$var$ji,
    useState: function() {
        return $2434d53d0d34de35$var$Wh($2434d53d0d34de35$var$Vh);
    },
    useDebugValue: $2434d53d0d34de35$var$ri,
    useDeferredValue: function(a) {
        var b = $2434d53d0d34de35$var$Uh();
        return $2434d53d0d34de35$var$ui(b, $2434d53d0d34de35$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $2434d53d0d34de35$var$Wh($2434d53d0d34de35$var$Vh)[0], b = $2434d53d0d34de35$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $2434d53d0d34de35$var$Yh,
    useSyncExternalStore: $2434d53d0d34de35$var$Zh,
    useId: $2434d53d0d34de35$var$wi,
    unstable_isNewReconciler: !1
}, $2434d53d0d34de35$var$Qh = {
    readContext: $2434d53d0d34de35$var$eh,
    useCallback: $2434d53d0d34de35$var$si,
    useContext: $2434d53d0d34de35$var$eh,
    useEffect: $2434d53d0d34de35$var$$h,
    useImperativeHandle: $2434d53d0d34de35$var$qi,
    useInsertionEffect: $2434d53d0d34de35$var$ni,
    useLayoutEffect: $2434d53d0d34de35$var$oi,
    useMemo: $2434d53d0d34de35$var$ti,
    useReducer: $2434d53d0d34de35$var$Xh,
    useRef: $2434d53d0d34de35$var$ji,
    useState: function() {
        return $2434d53d0d34de35$var$Xh($2434d53d0d34de35$var$Vh);
    },
    useDebugValue: $2434d53d0d34de35$var$ri,
    useDeferredValue: function(a) {
        var b = $2434d53d0d34de35$var$Uh();
        return null === $2434d53d0d34de35$var$N ? b.memoizedState = a : $2434d53d0d34de35$var$ui(b, $2434d53d0d34de35$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $2434d53d0d34de35$var$Xh($2434d53d0d34de35$var$Vh)[0], b = $2434d53d0d34de35$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $2434d53d0d34de35$var$Yh,
    useSyncExternalStore: $2434d53d0d34de35$var$Zh,
    useId: $2434d53d0d34de35$var$wi,
    unstable_isNewReconciler: !1
};
function $2434d53d0d34de35$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $2434d53d0d34de35$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $2434d53d0d34de35$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $2434d53d0d34de35$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $2434d53d0d34de35$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $2434d53d0d34de35$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $2434d53d0d34de35$var$R(), e = $2434d53d0d34de35$var$yi(a), f = $2434d53d0d34de35$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $2434d53d0d34de35$var$nh(a, f, e);
        null !== b && ($2434d53d0d34de35$var$gi(b, a, e, d), $2434d53d0d34de35$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $2434d53d0d34de35$var$R(), e = $2434d53d0d34de35$var$yi(a), f = $2434d53d0d34de35$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $2434d53d0d34de35$var$nh(a, f, e);
        null !== b && ($2434d53d0d34de35$var$gi(b, a, e, d), $2434d53d0d34de35$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $2434d53d0d34de35$var$R(), d = $2434d53d0d34de35$var$yi(a), e = $2434d53d0d34de35$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $2434d53d0d34de35$var$nh(a, e, d);
        null !== b && ($2434d53d0d34de35$var$gi(b, a, d, c), $2434d53d0d34de35$var$oh(b, a, d));
    }
};
function $2434d53d0d34de35$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$2434d53d0d34de35$var$Ie(c, d) || !$2434d53d0d34de35$var$Ie(e, f) : !0;
}
function $2434d53d0d34de35$var$Gi(a, b, c) {
    var d = !1, e = $2434d53d0d34de35$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $2434d53d0d34de35$var$eh(f) : (e = $2434d53d0d34de35$var$Zf(b) ? $2434d53d0d34de35$var$Xf : $2434d53d0d34de35$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $2434d53d0d34de35$var$Yf(a, e) : $2434d53d0d34de35$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $2434d53d0d34de35$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $2434d53d0d34de35$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $2434d53d0d34de35$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $2434d53d0d34de35$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $2434d53d0d34de35$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $2434d53d0d34de35$var$eh(f) : (f = $2434d53d0d34de35$var$Zf(b) ? $2434d53d0d34de35$var$Xf : $2434d53d0d34de35$var$H.current, e.context = $2434d53d0d34de35$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($2434d53d0d34de35$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $2434d53d0d34de35$var$Ei.enqueueReplaceState(e, e.state, null), $2434d53d0d34de35$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $2434d53d0d34de35$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $2434d53d0d34de35$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $2434d53d0d34de35$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $2434d53d0d34de35$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $2434d53d0d34de35$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $2434d53d0d34de35$var$Ni(a, b, c) {
    c = $2434d53d0d34de35$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $2434d53d0d34de35$var$Oi || ($2434d53d0d34de35$var$Oi = !0, $2434d53d0d34de35$var$Pi = d);
        $2434d53d0d34de35$var$Li(a, b);
    };
    return c;
}
function $2434d53d0d34de35$var$Qi(a, b, c) {
    c = $2434d53d0d34de35$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $2434d53d0d34de35$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $2434d53d0d34de35$var$Li(a, b);
        "function" !== typeof d && (null === $2434d53d0d34de35$var$Ri ? $2434d53d0d34de35$var$Ri = new Set([
            this
        ]) : $2434d53d0d34de35$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $2434d53d0d34de35$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $2434d53d0d34de35$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $2434d53d0d34de35$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $2434d53d0d34de35$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $2434d53d0d34de35$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $2434d53d0d34de35$var$mh(-1, 1), b.tag = 2, $2434d53d0d34de35$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $2434d53d0d34de35$var$Wi = $2434d53d0d34de35$var$ua.ReactCurrentOwner, $2434d53d0d34de35$var$dh = !1;
function $2434d53d0d34de35$var$Xi(a, b, c, d) {
    b.child = null === a ? $2434d53d0d34de35$var$Vg(b, null, c, d) : $2434d53d0d34de35$var$Ug(b, a.child, c, d);
}
function $2434d53d0d34de35$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $2434d53d0d34de35$var$ch(b, e);
    d = $2434d53d0d34de35$var$Nh(a, b, c, d, f, e);
    c = $2434d53d0d34de35$var$Sh();
    if (null !== a && !$2434d53d0d34de35$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $2434d53d0d34de35$var$Zi(a, b, e);
    $2434d53d0d34de35$var$I && c && $2434d53d0d34de35$var$vg(b);
    b.flags |= 1;
    $2434d53d0d34de35$var$Xi(a, b, d, e);
    return b.child;
}
function $2434d53d0d34de35$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$2434d53d0d34de35$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $2434d53d0d34de35$var$bj(a, b, f, d, e);
        a = $2434d53d0d34de35$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $2434d53d0d34de35$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $2434d53d0d34de35$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $2434d53d0d34de35$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $2434d53d0d34de35$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($2434d53d0d34de35$var$Ie(f, d) && a.ref === b.ref) {
            if ($2434d53d0d34de35$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($2434d53d0d34de35$var$dh = !0);
            else return b.lanes = a.lanes, $2434d53d0d34de35$var$Zi(a, b, e);
        }
    }
    return $2434d53d0d34de35$var$cj(a, b, c, d, e);
}
function $2434d53d0d34de35$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $2434d53d0d34de35$var$G($2434d53d0d34de35$var$ej, $2434d53d0d34de35$var$fj), $2434d53d0d34de35$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $2434d53d0d34de35$var$G($2434d53d0d34de35$var$ej, $2434d53d0d34de35$var$fj), $2434d53d0d34de35$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $2434d53d0d34de35$var$G($2434d53d0d34de35$var$ej, $2434d53d0d34de35$var$fj);
            $2434d53d0d34de35$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $2434d53d0d34de35$var$G($2434d53d0d34de35$var$ej, $2434d53d0d34de35$var$fj), $2434d53d0d34de35$var$fj |= d;
    $2434d53d0d34de35$var$Xi(a, b, e, c);
    return b.child;
}
function $2434d53d0d34de35$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $2434d53d0d34de35$var$cj(a, b, c, d, e) {
    var f = $2434d53d0d34de35$var$Zf(c) ? $2434d53d0d34de35$var$Xf : $2434d53d0d34de35$var$H.current;
    f = $2434d53d0d34de35$var$Yf(b, f);
    $2434d53d0d34de35$var$ch(b, e);
    c = $2434d53d0d34de35$var$Nh(a, b, c, d, f, e);
    d = $2434d53d0d34de35$var$Sh();
    if (null !== a && !$2434d53d0d34de35$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $2434d53d0d34de35$var$Zi(a, b, e);
    $2434d53d0d34de35$var$I && d && $2434d53d0d34de35$var$vg(b);
    b.flags |= 1;
    $2434d53d0d34de35$var$Xi(a, b, c, e);
    return b.child;
}
function $2434d53d0d34de35$var$hj(a, b, c, d, e) {
    if ($2434d53d0d34de35$var$Zf(c)) {
        var f = !0;
        $2434d53d0d34de35$var$cg(b);
    } else f = !1;
    $2434d53d0d34de35$var$ch(b, e);
    if (null === b.stateNode) $2434d53d0d34de35$var$ij(a, b), $2434d53d0d34de35$var$Gi(b, c, d), $2434d53d0d34de35$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $2434d53d0d34de35$var$eh(l) : (l = $2434d53d0d34de35$var$Zf(c) ? $2434d53d0d34de35$var$Xf : $2434d53d0d34de35$var$H.current, l = $2434d53d0d34de35$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $2434d53d0d34de35$var$Hi(b, g, d, l);
        $2434d53d0d34de35$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $2434d53d0d34de35$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $2434d53d0d34de35$var$Wf.current || $2434d53d0d34de35$var$jh ? ("function" === typeof m && ($2434d53d0d34de35$var$Di(b, c, m, d), k = b.memoizedState), (h = $2434d53d0d34de35$var$jh || $2434d53d0d34de35$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $2434d53d0d34de35$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $2434d53d0d34de35$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $2434d53d0d34de35$var$eh(k) : (k = $2434d53d0d34de35$var$Zf(c) ? $2434d53d0d34de35$var$Xf : $2434d53d0d34de35$var$H.current, k = $2434d53d0d34de35$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $2434d53d0d34de35$var$Hi(b, g, d, k);
        $2434d53d0d34de35$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $2434d53d0d34de35$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $2434d53d0d34de35$var$Wf.current || $2434d53d0d34de35$var$jh ? ("function" === typeof y && ($2434d53d0d34de35$var$Di(b, c, y, d), n = b.memoizedState), (l = $2434d53d0d34de35$var$jh || $2434d53d0d34de35$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $2434d53d0d34de35$var$jj(a, b, c, d, f, e);
}
function $2434d53d0d34de35$var$jj(a, b, c, d, e, f) {
    $2434d53d0d34de35$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $2434d53d0d34de35$var$dg(b, c, !1), $2434d53d0d34de35$var$Zi(a, b, f);
    d = b.stateNode;
    $2434d53d0d34de35$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $2434d53d0d34de35$var$Ug(b, a.child, null, f), b.child = $2434d53d0d34de35$var$Ug(b, null, h, f)) : $2434d53d0d34de35$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $2434d53d0d34de35$var$dg(b, c, !0);
    return b.child;
}
function $2434d53d0d34de35$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $2434d53d0d34de35$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $2434d53d0d34de35$var$ag(a, b.context, !1);
    $2434d53d0d34de35$var$yh(a, b.containerInfo);
}
function $2434d53d0d34de35$var$lj(a, b, c, d, e) {
    $2434d53d0d34de35$var$Ig();
    $2434d53d0d34de35$var$Jg(e);
    b.flags |= 256;
    $2434d53d0d34de35$var$Xi(a, b, c, d);
    return b.child;
}
var $2434d53d0d34de35$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $2434d53d0d34de35$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $2434d53d0d34de35$var$oj(a, b, c) {
    var d = b.pendingProps, e = $2434d53d0d34de35$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $2434d53d0d34de35$var$G($2434d53d0d34de35$var$L, e & 1);
    if (null === a) {
        $2434d53d0d34de35$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $2434d53d0d34de35$var$pj(g, d, 0, null), a = $2434d53d0d34de35$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $2434d53d0d34de35$var$nj(c), b.memoizedState = $2434d53d0d34de35$var$mj, a) : $2434d53d0d34de35$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $2434d53d0d34de35$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $2434d53d0d34de35$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $2434d53d0d34de35$var$Pg(h, f) : (f = $2434d53d0d34de35$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $2434d53d0d34de35$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $2434d53d0d34de35$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $2434d53d0d34de35$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $2434d53d0d34de35$var$qj(a, b) {
    b = $2434d53d0d34de35$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $2434d53d0d34de35$var$sj(a, b, c, d) {
    null !== d && $2434d53d0d34de35$var$Jg(d);
    $2434d53d0d34de35$var$Ug(b, a.child, null, c);
    a = $2434d53d0d34de35$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $2434d53d0d34de35$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $2434d53d0d34de35$var$Ki(Error($2434d53d0d34de35$var$p(422))), $2434d53d0d34de35$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $2434d53d0d34de35$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $2434d53d0d34de35$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $2434d53d0d34de35$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $2434d53d0d34de35$var$nj(g);
        b.memoizedState = $2434d53d0d34de35$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $2434d53d0d34de35$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($2434d53d0d34de35$var$p(419));
        d = $2434d53d0d34de35$var$Ki(f, d, void 0);
        return $2434d53d0d34de35$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($2434d53d0d34de35$var$dh || h) {
        d = $2434d53d0d34de35$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $2434d53d0d34de35$var$ih(a, e), $2434d53d0d34de35$var$gi(d, a, e, -1));
        }
        $2434d53d0d34de35$var$tj();
        d = $2434d53d0d34de35$var$Ki(Error($2434d53d0d34de35$var$p(421)));
        return $2434d53d0d34de35$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $2434d53d0d34de35$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $2434d53d0d34de35$var$yg = $2434d53d0d34de35$var$Lf(e.nextSibling);
    $2434d53d0d34de35$var$xg = b;
    $2434d53d0d34de35$var$I = !0;
    $2434d53d0d34de35$var$zg = null;
    null !== a && ($2434d53d0d34de35$var$og[$2434d53d0d34de35$var$pg++] = $2434d53d0d34de35$var$rg, $2434d53d0d34de35$var$og[$2434d53d0d34de35$var$pg++] = $2434d53d0d34de35$var$sg, $2434d53d0d34de35$var$og[$2434d53d0d34de35$var$pg++] = $2434d53d0d34de35$var$qg, $2434d53d0d34de35$var$rg = a.id, $2434d53d0d34de35$var$sg = a.overflow, $2434d53d0d34de35$var$qg = b);
    b = $2434d53d0d34de35$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $2434d53d0d34de35$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $2434d53d0d34de35$var$bh(a.return, b, c);
}
function $2434d53d0d34de35$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $2434d53d0d34de35$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $2434d53d0d34de35$var$Xi(a, b, d.children, c);
    d = $2434d53d0d34de35$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $2434d53d0d34de35$var$vj(a, c, b);
            else if (19 === a.tag) $2434d53d0d34de35$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $2434d53d0d34de35$var$G($2434d53d0d34de35$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $2434d53d0d34de35$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $2434d53d0d34de35$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $2434d53d0d34de35$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $2434d53d0d34de35$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $2434d53d0d34de35$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $2434d53d0d34de35$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $2434d53d0d34de35$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $2434d53d0d34de35$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($2434d53d0d34de35$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $2434d53d0d34de35$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $2434d53d0d34de35$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $2434d53d0d34de35$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $2434d53d0d34de35$var$kj(b);
            $2434d53d0d34de35$var$Ig();
            break;
        case 5:
            $2434d53d0d34de35$var$Ah(b);
            break;
        case 1:
            $2434d53d0d34de35$var$Zf(b.type) && $2434d53d0d34de35$var$cg(b);
            break;
        case 4:
            $2434d53d0d34de35$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $2434d53d0d34de35$var$G($2434d53d0d34de35$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $2434d53d0d34de35$var$G($2434d53d0d34de35$var$L, $2434d53d0d34de35$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $2434d53d0d34de35$var$oj(a, b, c);
                $2434d53d0d34de35$var$G($2434d53d0d34de35$var$L, $2434d53d0d34de35$var$L.current & 1);
                a = $2434d53d0d34de35$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $2434d53d0d34de35$var$G($2434d53d0d34de35$var$L, $2434d53d0d34de35$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $2434d53d0d34de35$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $2434d53d0d34de35$var$G($2434d53d0d34de35$var$L, $2434d53d0d34de35$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $2434d53d0d34de35$var$dj(a, b, c);
    }
    return $2434d53d0d34de35$var$Zi(a, b, c);
}
var $2434d53d0d34de35$var$zj, $2434d53d0d34de35$var$Aj, $2434d53d0d34de35$var$Bj, $2434d53d0d34de35$var$Cj;
$2434d53d0d34de35$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$2434d53d0d34de35$var$Aj = function() {};
$2434d53d0d34de35$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $2434d53d0d34de35$var$xh($2434d53d0d34de35$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $2434d53d0d34de35$var$Ya(a, e);
                d = $2434d53d0d34de35$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $2434d53d0d34de35$var$A({}, e, {
                    value: void 0
                });
                d = $2434d53d0d34de35$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $2434d53d0d34de35$var$gb(a, e);
                d = $2434d53d0d34de35$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $2434d53d0d34de35$var$Bf);
        }
        $2434d53d0d34de35$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($2434d53d0d34de35$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($2434d53d0d34de35$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $2434d53d0d34de35$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$2434d53d0d34de35$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $2434d53d0d34de35$var$Dj(a, b) {
    if (!$2434d53d0d34de35$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $2434d53d0d34de35$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $2434d53d0d34de35$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $2434d53d0d34de35$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $2434d53d0d34de35$var$S(b), null;
        case 1:
            return $2434d53d0d34de35$var$Zf(b.type) && $2434d53d0d34de35$var$$f(), $2434d53d0d34de35$var$S(b), null;
        case 3:
            d = b.stateNode;
            $2434d53d0d34de35$var$zh();
            $2434d53d0d34de35$var$E($2434d53d0d34de35$var$Wf);
            $2434d53d0d34de35$var$E($2434d53d0d34de35$var$H);
            $2434d53d0d34de35$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $2434d53d0d34de35$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $2434d53d0d34de35$var$zg && ($2434d53d0d34de35$var$Fj($2434d53d0d34de35$var$zg), $2434d53d0d34de35$var$zg = null));
            $2434d53d0d34de35$var$Aj(a, b);
            $2434d53d0d34de35$var$S(b);
            return null;
        case 5:
            $2434d53d0d34de35$var$Bh(b);
            var e = $2434d53d0d34de35$var$xh($2434d53d0d34de35$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $2434d53d0d34de35$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($2434d53d0d34de35$var$p(166));
                    $2434d53d0d34de35$var$S(b);
                    return null;
                }
                a = $2434d53d0d34de35$var$xh($2434d53d0d34de35$var$uh.current);
                if ($2434d53d0d34de35$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$2434d53d0d34de35$var$Of] = b;
                    d[$2434d53d0d34de35$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $2434d53d0d34de35$var$D("cancel", d);
                            $2434d53d0d34de35$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $2434d53d0d34de35$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $2434d53d0d34de35$var$lf.length; e++)$2434d53d0d34de35$var$D($2434d53d0d34de35$var$lf[e], d);
                            break;
                        case "source":
                            $2434d53d0d34de35$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $2434d53d0d34de35$var$D("error", d);
                            $2434d53d0d34de35$var$D("load", d);
                            break;
                        case "details":
                            $2434d53d0d34de35$var$D("toggle", d);
                            break;
                        case "input":
                            $2434d53d0d34de35$var$Za(d, f);
                            $2434d53d0d34de35$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $2434d53d0d34de35$var$D("invalid", d);
                            break;
                        case "textarea":
                            $2434d53d0d34de35$var$hb(d, f), $2434d53d0d34de35$var$D("invalid", d);
                    }
                    $2434d53d0d34de35$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $2434d53d0d34de35$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $2434d53d0d34de35$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $2434d53d0d34de35$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $2434d53d0d34de35$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $2434d53d0d34de35$var$Va(d);
                            $2434d53d0d34de35$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $2434d53d0d34de35$var$Va(d);
                            $2434d53d0d34de35$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $2434d53d0d34de35$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $2434d53d0d34de35$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$2434d53d0d34de35$var$Of] = b;
                    a[$2434d53d0d34de35$var$Pf] = d;
                    $2434d53d0d34de35$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $2434d53d0d34de35$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $2434d53d0d34de35$var$D("cancel", a);
                                $2434d53d0d34de35$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $2434d53d0d34de35$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $2434d53d0d34de35$var$lf.length; e++)$2434d53d0d34de35$var$D($2434d53d0d34de35$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $2434d53d0d34de35$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $2434d53d0d34de35$var$D("error", a);
                                $2434d53d0d34de35$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $2434d53d0d34de35$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $2434d53d0d34de35$var$Za(a, d);
                                e = $2434d53d0d34de35$var$Ya(a, d);
                                $2434d53d0d34de35$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $2434d53d0d34de35$var$A({}, d, {
                                    value: void 0
                                });
                                $2434d53d0d34de35$var$D("invalid", a);
                                break;
                            case "textarea":
                                $2434d53d0d34de35$var$hb(a, d);
                                e = $2434d53d0d34de35$var$gb(a, d);
                                $2434d53d0d34de35$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $2434d53d0d34de35$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $2434d53d0d34de35$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $2434d53d0d34de35$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $2434d53d0d34de35$var$ob(a, k) : "number" === typeof k && $2434d53d0d34de35$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($2434d53d0d34de35$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $2434d53d0d34de35$var$D("scroll", a) : null != k && $2434d53d0d34de35$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $2434d53d0d34de35$var$Va(a);
                                $2434d53d0d34de35$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $2434d53d0d34de35$var$Va(a);
                                $2434d53d0d34de35$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $2434d53d0d34de35$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $2434d53d0d34de35$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $2434d53d0d34de35$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $2434d53d0d34de35$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $2434d53d0d34de35$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $2434d53d0d34de35$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($2434d53d0d34de35$var$p(166));
                c = $2434d53d0d34de35$var$xh($2434d53d0d34de35$var$wh.current);
                $2434d53d0d34de35$var$xh($2434d53d0d34de35$var$uh.current);
                if ($2434d53d0d34de35$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$2434d53d0d34de35$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $2434d53d0d34de35$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $2434d53d0d34de35$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $2434d53d0d34de35$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$2434d53d0d34de35$var$Of] = b, b.stateNode = d;
            }
            $2434d53d0d34de35$var$S(b);
            return null;
        case 13:
            $2434d53d0d34de35$var$E($2434d53d0d34de35$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($2434d53d0d34de35$var$I && null !== $2434d53d0d34de35$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $2434d53d0d34de35$var$Hg(), $2434d53d0d34de35$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $2434d53d0d34de35$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($2434d53d0d34de35$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($2434d53d0d34de35$var$p(317));
                        f[$2434d53d0d34de35$var$Of] = b;
                    } else $2434d53d0d34de35$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $2434d53d0d34de35$var$S(b);
                    f = !1;
                } else null !== $2434d53d0d34de35$var$zg && ($2434d53d0d34de35$var$Fj($2434d53d0d34de35$var$zg), $2434d53d0d34de35$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($2434d53d0d34de35$var$L.current & 1) ? 0 === $2434d53d0d34de35$var$T && ($2434d53d0d34de35$var$T = 3) : $2434d53d0d34de35$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $2434d53d0d34de35$var$S(b);
            return null;
        case 4:
            return $2434d53d0d34de35$var$zh(), $2434d53d0d34de35$var$Aj(a, b), null === a && $2434d53d0d34de35$var$sf(b.stateNode.containerInfo), $2434d53d0d34de35$var$S(b), null;
        case 10:
            return $2434d53d0d34de35$var$ah(b.type._context), $2434d53d0d34de35$var$S(b), null;
        case 17:
            return $2434d53d0d34de35$var$Zf(b.type) && $2434d53d0d34de35$var$$f(), $2434d53d0d34de35$var$S(b), null;
        case 19:
            $2434d53d0d34de35$var$E($2434d53d0d34de35$var$L);
            f = b.memoizedState;
            if (null === f) return $2434d53d0d34de35$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $2434d53d0d34de35$var$Dj(f, !1);
                else {
                    if (0 !== $2434d53d0d34de35$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $2434d53d0d34de35$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $2434d53d0d34de35$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $2434d53d0d34de35$var$G($2434d53d0d34de35$var$L, $2434d53d0d34de35$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $2434d53d0d34de35$var$B() > $2434d53d0d34de35$var$Gj && (b.flags |= 128, d = !0, $2434d53d0d34de35$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $2434d53d0d34de35$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $2434d53d0d34de35$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$2434d53d0d34de35$var$I) return $2434d53d0d34de35$var$S(b), null;
                    } else 2 * $2434d53d0d34de35$var$B() - f.renderingStartTime > $2434d53d0d34de35$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $2434d53d0d34de35$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $2434d53d0d34de35$var$B(), b.sibling = null, c = $2434d53d0d34de35$var$L.current, $2434d53d0d34de35$var$G($2434d53d0d34de35$var$L, d ? c & 1 | 2 : c & 1), b;
            $2434d53d0d34de35$var$S(b);
            return null;
        case 22:
        case 23:
            return $2434d53d0d34de35$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($2434d53d0d34de35$var$fj & 1073741824) && ($2434d53d0d34de35$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $2434d53d0d34de35$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($2434d53d0d34de35$var$p(156, b.tag));
}
function $2434d53d0d34de35$var$Ij(a, b) {
    $2434d53d0d34de35$var$wg(b);
    switch(b.tag){
        case 1:
            return $2434d53d0d34de35$var$Zf(b.type) && $2434d53d0d34de35$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $2434d53d0d34de35$var$zh(), $2434d53d0d34de35$var$E($2434d53d0d34de35$var$Wf), $2434d53d0d34de35$var$E($2434d53d0d34de35$var$H), $2434d53d0d34de35$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $2434d53d0d34de35$var$Bh(b), null;
        case 13:
            $2434d53d0d34de35$var$E($2434d53d0d34de35$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($2434d53d0d34de35$var$p(340));
                $2434d53d0d34de35$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $2434d53d0d34de35$var$E($2434d53d0d34de35$var$L), null;
        case 4:
            return $2434d53d0d34de35$var$zh(), null;
        case 10:
            return $2434d53d0d34de35$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $2434d53d0d34de35$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $2434d53d0d34de35$var$Jj = !1, $2434d53d0d34de35$var$U = !1, $2434d53d0d34de35$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $2434d53d0d34de35$var$V = null;
function $2434d53d0d34de35$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $2434d53d0d34de35$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $2434d53d0d34de35$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $2434d53d0d34de35$var$W(a, b, d);
    }
}
var $2434d53d0d34de35$var$Nj = !1;
function $2434d53d0d34de35$var$Oj(a, b) {
    $2434d53d0d34de35$var$Cf = $2434d53d0d34de35$var$dd;
    a = $2434d53d0d34de35$var$Me();
    if ($2434d53d0d34de35$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $2434d53d0d34de35$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $2434d53d0d34de35$var$dd = !1;
    for($2434d53d0d34de35$var$V = b; null !== $2434d53d0d34de35$var$V;)if (b = $2434d53d0d34de35$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $2434d53d0d34de35$var$V = a;
    else for(; null !== $2434d53d0d34de35$var$V;){
        b = $2434d53d0d34de35$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $2434d53d0d34de35$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($2434d53d0d34de35$var$p(163));
            }
        } catch (F) {
            $2434d53d0d34de35$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $2434d53d0d34de35$var$V = a;
            break;
        }
        $2434d53d0d34de35$var$V = b.return;
    }
    n = $2434d53d0d34de35$var$Nj;
    $2434d53d0d34de35$var$Nj = !1;
    return n;
}
function $2434d53d0d34de35$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $2434d53d0d34de35$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $2434d53d0d34de35$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $2434d53d0d34de35$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $2434d53d0d34de35$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $2434d53d0d34de35$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$2434d53d0d34de35$var$Of], delete b[$2434d53d0d34de35$var$Pf], delete b[$2434d53d0d34de35$var$of], delete b[$2434d53d0d34de35$var$Qf], delete b[$2434d53d0d34de35$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $2434d53d0d34de35$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $2434d53d0d34de35$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $2434d53d0d34de35$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $2434d53d0d34de35$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $2434d53d0d34de35$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($2434d53d0d34de35$var$Vj(a, b, c), a = a.sibling; null !== a;)$2434d53d0d34de35$var$Vj(a, b, c), a = a.sibling;
}
function $2434d53d0d34de35$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($2434d53d0d34de35$var$Wj(a, b, c), a = a.sibling; null !== a;)$2434d53d0d34de35$var$Wj(a, b, c), a = a.sibling;
}
var $2434d53d0d34de35$var$X = null, $2434d53d0d34de35$var$Xj = !1;
function $2434d53d0d34de35$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$2434d53d0d34de35$var$Zj(a, b, c), c = c.sibling;
}
function $2434d53d0d34de35$var$Zj(a, b, c) {
    if ($2434d53d0d34de35$var$lc && "function" === typeof $2434d53d0d34de35$var$lc.onCommitFiberUnmount) try {
        $2434d53d0d34de35$var$lc.onCommitFiberUnmount($2434d53d0d34de35$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $2434d53d0d34de35$var$U || $2434d53d0d34de35$var$Lj(c, b);
        case 6:
            var d = $2434d53d0d34de35$var$X, e = $2434d53d0d34de35$var$Xj;
            $2434d53d0d34de35$var$X = null;
            $2434d53d0d34de35$var$Yj(a, b, c);
            $2434d53d0d34de35$var$X = d;
            $2434d53d0d34de35$var$Xj = e;
            null !== $2434d53d0d34de35$var$X && ($2434d53d0d34de35$var$Xj ? (a = $2434d53d0d34de35$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $2434d53d0d34de35$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $2434d53d0d34de35$var$X && ($2434d53d0d34de35$var$Xj ? (a = $2434d53d0d34de35$var$X, c = c.stateNode, 8 === a.nodeType ? $2434d53d0d34de35$var$Kf(a.parentNode, c) : 1 === a.nodeType && $2434d53d0d34de35$var$Kf(a, c), $2434d53d0d34de35$var$bd(a)) : $2434d53d0d34de35$var$Kf($2434d53d0d34de35$var$X, c.stateNode));
            break;
        case 4:
            d = $2434d53d0d34de35$var$X;
            e = $2434d53d0d34de35$var$Xj;
            $2434d53d0d34de35$var$X = c.stateNode.containerInfo;
            $2434d53d0d34de35$var$Xj = !0;
            $2434d53d0d34de35$var$Yj(a, b, c);
            $2434d53d0d34de35$var$X = d;
            $2434d53d0d34de35$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$2434d53d0d34de35$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $2434d53d0d34de35$var$Mj(c, b, g) : 0 !== (f & 4) && $2434d53d0d34de35$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $2434d53d0d34de35$var$Yj(a, b, c);
            break;
        case 1:
            if (!$2434d53d0d34de35$var$U && ($2434d53d0d34de35$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $2434d53d0d34de35$var$W(c, b, h);
            }
            $2434d53d0d34de35$var$Yj(a, b, c);
            break;
        case 21:
            $2434d53d0d34de35$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($2434d53d0d34de35$var$U = (d = $2434d53d0d34de35$var$U) || null !== c.memoizedState, $2434d53d0d34de35$var$Yj(a, b, c), $2434d53d0d34de35$var$U = d) : $2434d53d0d34de35$var$Yj(a, b, c);
            break;
        default:
            $2434d53d0d34de35$var$Yj(a, b, c);
    }
}
function $2434d53d0d34de35$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $2434d53d0d34de35$var$Kj);
        b.forEach(function(b) {
            var d = $2434d53d0d34de35$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $2434d53d0d34de35$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $2434d53d0d34de35$var$X = h.stateNode;
                        $2434d53d0d34de35$var$Xj = !1;
                        break a;
                    case 3:
                        $2434d53d0d34de35$var$X = h.stateNode.containerInfo;
                        $2434d53d0d34de35$var$Xj = !0;
                        break a;
                    case 4:
                        $2434d53d0d34de35$var$X = h.stateNode.containerInfo;
                        $2434d53d0d34de35$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $2434d53d0d34de35$var$X) throw Error($2434d53d0d34de35$var$p(160));
            $2434d53d0d34de35$var$Zj(f, g, e);
            $2434d53d0d34de35$var$X = null;
            $2434d53d0d34de35$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $2434d53d0d34de35$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$2434d53d0d34de35$var$dk(b, a), b = b.sibling;
}
function $2434d53d0d34de35$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $2434d53d0d34de35$var$ck(b, a);
            $2434d53d0d34de35$var$ek(a);
            if (d & 4) {
                try {
                    $2434d53d0d34de35$var$Pj(3, a, a.return), $2434d53d0d34de35$var$Qj(3, a);
                } catch (t) {
                    $2434d53d0d34de35$var$W(a, a.return, t);
                }
                try {
                    $2434d53d0d34de35$var$Pj(5, a, a.return);
                } catch (t) {
                    $2434d53d0d34de35$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $2434d53d0d34de35$var$ck(b, a);
            $2434d53d0d34de35$var$ek(a);
            d & 512 && null !== c && $2434d53d0d34de35$var$Lj(c, c.return);
            break;
        case 5:
            $2434d53d0d34de35$var$ck(b, a);
            $2434d53d0d34de35$var$ek(a);
            d & 512 && null !== c && $2434d53d0d34de35$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $2434d53d0d34de35$var$ob(e, "");
                } catch (t) {
                    $2434d53d0d34de35$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $2434d53d0d34de35$var$ab(e, f);
                    $2434d53d0d34de35$var$vb(h, g);
                    var l = $2434d53d0d34de35$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $2434d53d0d34de35$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $2434d53d0d34de35$var$nb(e, q) : "children" === m ? $2434d53d0d34de35$var$ob(e, q) : $2434d53d0d34de35$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $2434d53d0d34de35$var$bb(e, f);
                            break;
                        case "textarea":
                            $2434d53d0d34de35$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $2434d53d0d34de35$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $2434d53d0d34de35$var$fb(e, !!f.multiple, f.defaultValue, !0) : $2434d53d0d34de35$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$2434d53d0d34de35$var$Pf] = f;
                } catch (t) {
                    $2434d53d0d34de35$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $2434d53d0d34de35$var$ck(b, a);
            $2434d53d0d34de35$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($2434d53d0d34de35$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $2434d53d0d34de35$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $2434d53d0d34de35$var$ck(b, a);
            $2434d53d0d34de35$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $2434d53d0d34de35$var$bd(b.containerInfo);
            } catch (t) {
                $2434d53d0d34de35$var$W(a, a.return, t);
            }
            break;
        case 4:
            $2434d53d0d34de35$var$ck(b, a);
            $2434d53d0d34de35$var$ek(a);
            break;
        case 13:
            $2434d53d0d34de35$var$ck(b, a);
            $2434d53d0d34de35$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($2434d53d0d34de35$var$fk = $2434d53d0d34de35$var$B()));
            d & 4 && $2434d53d0d34de35$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($2434d53d0d34de35$var$U = (l = $2434d53d0d34de35$var$U) || m, $2434d53d0d34de35$var$ck(b, a), $2434d53d0d34de35$var$U = l) : $2434d53d0d34de35$var$ck(b, a);
            $2434d53d0d34de35$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($2434d53d0d34de35$var$V = a, m = a.child; null !== m;){
                    for(q = $2434d53d0d34de35$var$V = m; null !== $2434d53d0d34de35$var$V;){
                        r = $2434d53d0d34de35$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $2434d53d0d34de35$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $2434d53d0d34de35$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $2434d53d0d34de35$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $2434d53d0d34de35$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $2434d53d0d34de35$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $2434d53d0d34de35$var$V = y) : $2434d53d0d34de35$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $2434d53d0d34de35$var$rb("display", g));
                            } catch (t) {
                                $2434d53d0d34de35$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $2434d53d0d34de35$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $2434d53d0d34de35$var$ck(b, a);
            $2434d53d0d34de35$var$ek(a);
            d & 4 && $2434d53d0d34de35$var$ak(a);
            break;
        case 21:
            break;
        default:
            $2434d53d0d34de35$var$ck(b, a), $2434d53d0d34de35$var$ek(a);
    }
}
function $2434d53d0d34de35$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($2434d53d0d34de35$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($2434d53d0d34de35$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($2434d53d0d34de35$var$ob(e, ""), d.flags &= -33);
                    var f = $2434d53d0d34de35$var$Uj(a);
                    $2434d53d0d34de35$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $2434d53d0d34de35$var$Uj(a);
                    $2434d53d0d34de35$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($2434d53d0d34de35$var$p(161));
            }
        } catch (k) {
            $2434d53d0d34de35$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $2434d53d0d34de35$var$hk(a, b, c) {
    $2434d53d0d34de35$var$V = a;
    $2434d53d0d34de35$var$ik(a, b, c);
}
function $2434d53d0d34de35$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $2434d53d0d34de35$var$V;){
        var e = $2434d53d0d34de35$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $2434d53d0d34de35$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $2434d53d0d34de35$var$U;
                h = $2434d53d0d34de35$var$Jj;
                var l = $2434d53d0d34de35$var$U;
                $2434d53d0d34de35$var$Jj = g;
                if (($2434d53d0d34de35$var$U = k) && !l) for($2434d53d0d34de35$var$V = e; null !== $2434d53d0d34de35$var$V;)g = $2434d53d0d34de35$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $2434d53d0d34de35$var$jk(e) : null !== k ? (k.return = g, $2434d53d0d34de35$var$V = k) : $2434d53d0d34de35$var$jk(e);
                for(; null !== f;)$2434d53d0d34de35$var$V = f, $2434d53d0d34de35$var$ik(f, b, c), f = f.sibling;
                $2434d53d0d34de35$var$V = e;
                $2434d53d0d34de35$var$Jj = h;
                $2434d53d0d34de35$var$U = l;
            }
            $2434d53d0d34de35$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $2434d53d0d34de35$var$V = f) : $2434d53d0d34de35$var$kk(a, b, c);
    }
}
function $2434d53d0d34de35$var$kk(a) {
    for(; null !== $2434d53d0d34de35$var$V;){
        var b = $2434d53d0d34de35$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $2434d53d0d34de35$var$U || $2434d53d0d34de35$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$2434d53d0d34de35$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $2434d53d0d34de35$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $2434d53d0d34de35$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $2434d53d0d34de35$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $2434d53d0d34de35$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($2434d53d0d34de35$var$p(163));
                }
                $2434d53d0d34de35$var$U || b.flags & 512 && $2434d53d0d34de35$var$Rj(b);
            } catch (r) {
                $2434d53d0d34de35$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $2434d53d0d34de35$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $2434d53d0d34de35$var$V = c;
            break;
        }
        $2434d53d0d34de35$var$V = b.return;
    }
}
function $2434d53d0d34de35$var$gk(a) {
    for(; null !== $2434d53d0d34de35$var$V;){
        var b = $2434d53d0d34de35$var$V;
        if (b === a) {
            $2434d53d0d34de35$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $2434d53d0d34de35$var$V = c;
            break;
        }
        $2434d53d0d34de35$var$V = b.return;
    }
}
function $2434d53d0d34de35$var$jk(a) {
    for(; null !== $2434d53d0d34de35$var$V;){
        var b = $2434d53d0d34de35$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $2434d53d0d34de35$var$Qj(4, b);
                    } catch (k) {
                        $2434d53d0d34de35$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $2434d53d0d34de35$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $2434d53d0d34de35$var$Rj(b);
                    } catch (k) {
                        $2434d53d0d34de35$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $2434d53d0d34de35$var$Rj(b);
                    } catch (k) {
                        $2434d53d0d34de35$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $2434d53d0d34de35$var$W(b, b.return, k);
        }
        if (b === a) {
            $2434d53d0d34de35$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $2434d53d0d34de35$var$V = h;
            break;
        }
        $2434d53d0d34de35$var$V = b.return;
    }
}
var $2434d53d0d34de35$var$lk = Math.ceil, $2434d53d0d34de35$var$mk = $2434d53d0d34de35$var$ua.ReactCurrentDispatcher, $2434d53d0d34de35$var$nk = $2434d53d0d34de35$var$ua.ReactCurrentOwner, $2434d53d0d34de35$var$ok = $2434d53d0d34de35$var$ua.ReactCurrentBatchConfig, $2434d53d0d34de35$var$K = 0, $2434d53d0d34de35$var$Q = null, $2434d53d0d34de35$var$Y = null, $2434d53d0d34de35$var$Z = 0, $2434d53d0d34de35$var$fj = 0, $2434d53d0d34de35$var$ej = $2434d53d0d34de35$var$Uf(0), $2434d53d0d34de35$var$T = 0, $2434d53d0d34de35$var$pk = null, $2434d53d0d34de35$var$rh = 0, $2434d53d0d34de35$var$qk = 0, $2434d53d0d34de35$var$rk = 0, $2434d53d0d34de35$var$sk = null, $2434d53d0d34de35$var$tk = null, $2434d53d0d34de35$var$fk = 0, $2434d53d0d34de35$var$Gj = Infinity, $2434d53d0d34de35$var$uk = null, $2434d53d0d34de35$var$Oi = !1, $2434d53d0d34de35$var$Pi = null, $2434d53d0d34de35$var$Ri = null, $2434d53d0d34de35$var$vk = !1, $2434d53d0d34de35$var$wk = null, $2434d53d0d34de35$var$xk = 0, $2434d53d0d34de35$var$yk = 0, $2434d53d0d34de35$var$zk = null, $2434d53d0d34de35$var$Ak = -1, $2434d53d0d34de35$var$Bk = 0;
function $2434d53d0d34de35$var$R() {
    return 0 !== ($2434d53d0d34de35$var$K & 6) ? $2434d53d0d34de35$var$B() : -1 !== $2434d53d0d34de35$var$Ak ? $2434d53d0d34de35$var$Ak : $2434d53d0d34de35$var$Ak = $2434d53d0d34de35$var$B();
}
function $2434d53d0d34de35$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($2434d53d0d34de35$var$K & 2) && 0 !== $2434d53d0d34de35$var$Z) return $2434d53d0d34de35$var$Z & -$2434d53d0d34de35$var$Z;
    if (null !== $2434d53d0d34de35$var$Kg.transition) return 0 === $2434d53d0d34de35$var$Bk && ($2434d53d0d34de35$var$Bk = $2434d53d0d34de35$var$yc()), $2434d53d0d34de35$var$Bk;
    a = $2434d53d0d34de35$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $2434d53d0d34de35$var$jd(a.type);
    return a;
}
function $2434d53d0d34de35$var$gi(a, b, c, d) {
    if (50 < $2434d53d0d34de35$var$yk) throw $2434d53d0d34de35$var$yk = 0, $2434d53d0d34de35$var$zk = null, Error($2434d53d0d34de35$var$p(185));
    $2434d53d0d34de35$var$Ac(a, c, d);
    if (0 === ($2434d53d0d34de35$var$K & 2) || a !== $2434d53d0d34de35$var$Q) a === $2434d53d0d34de35$var$Q && (0 === ($2434d53d0d34de35$var$K & 2) && ($2434d53d0d34de35$var$qk |= c), 4 === $2434d53d0d34de35$var$T && $2434d53d0d34de35$var$Ck(a, $2434d53d0d34de35$var$Z)), $2434d53d0d34de35$var$Dk(a, d), 1 === c && 0 === $2434d53d0d34de35$var$K && 0 === (b.mode & 1) && ($2434d53d0d34de35$var$Gj = $2434d53d0d34de35$var$B() + 500, $2434d53d0d34de35$var$fg && $2434d53d0d34de35$var$jg());
}
function $2434d53d0d34de35$var$Dk(a, b) {
    var c = a.callbackNode;
    $2434d53d0d34de35$var$wc(a, b);
    var d = $2434d53d0d34de35$var$uc(a, a === $2434d53d0d34de35$var$Q ? $2434d53d0d34de35$var$Z : 0);
    if (0 === d) null !== c && $2434d53d0d34de35$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $2434d53d0d34de35$var$bc(c);
        if (1 === b) 0 === a.tag ? $2434d53d0d34de35$var$ig($2434d53d0d34de35$var$Ek.bind(null, a)) : $2434d53d0d34de35$var$hg($2434d53d0d34de35$var$Ek.bind(null, a)), $2434d53d0d34de35$var$Jf(function() {
            0 === ($2434d53d0d34de35$var$K & 6) && $2434d53d0d34de35$var$jg();
        }), c = null;
        else {
            switch($2434d53d0d34de35$var$Dc(d)){
                case 1:
                    c = $2434d53d0d34de35$var$fc;
                    break;
                case 4:
                    c = $2434d53d0d34de35$var$gc;
                    break;
                case 16:
                    c = $2434d53d0d34de35$var$hc;
                    break;
                case 536870912:
                    c = $2434d53d0d34de35$var$jc;
                    break;
                default:
                    c = $2434d53d0d34de35$var$hc;
            }
            c = $2434d53d0d34de35$var$Fk(c, $2434d53d0d34de35$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $2434d53d0d34de35$var$Gk(a, b) {
    $2434d53d0d34de35$var$Ak = -1;
    $2434d53d0d34de35$var$Bk = 0;
    if (0 !== ($2434d53d0d34de35$var$K & 6)) throw Error($2434d53d0d34de35$var$p(327));
    var c = a.callbackNode;
    if ($2434d53d0d34de35$var$Hk() && a.callbackNode !== c) return null;
    var d = $2434d53d0d34de35$var$uc(a, a === $2434d53d0d34de35$var$Q ? $2434d53d0d34de35$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $2434d53d0d34de35$var$Ik(a, d);
    else {
        b = d;
        var e = $2434d53d0d34de35$var$K;
        $2434d53d0d34de35$var$K |= 2;
        var f = $2434d53d0d34de35$var$Jk();
        if ($2434d53d0d34de35$var$Q !== a || $2434d53d0d34de35$var$Z !== b) $2434d53d0d34de35$var$uk = null, $2434d53d0d34de35$var$Gj = $2434d53d0d34de35$var$B() + 500, $2434d53d0d34de35$var$Kk(a, b);
        for(;;)try {
            $2434d53d0d34de35$var$Lk();
            break;
        } catch (h) {
            $2434d53d0d34de35$var$Mk(a, h);
        }
        $2434d53d0d34de35$var$$g();
        $2434d53d0d34de35$var$mk.current = f;
        $2434d53d0d34de35$var$K = e;
        null !== $2434d53d0d34de35$var$Y ? b = 0 : ($2434d53d0d34de35$var$Q = null, $2434d53d0d34de35$var$Z = 0, b = $2434d53d0d34de35$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $2434d53d0d34de35$var$xc(a), 0 !== e && (d = e, b = $2434d53d0d34de35$var$Nk(a, e)));
        if (1 === b) throw c = $2434d53d0d34de35$var$pk, $2434d53d0d34de35$var$Kk(a, 0), $2434d53d0d34de35$var$Ck(a, d), $2434d53d0d34de35$var$Dk(a, $2434d53d0d34de35$var$B()), c;
        if (6 === b) $2434d53d0d34de35$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$2434d53d0d34de35$var$Ok(e) && (b = $2434d53d0d34de35$var$Ik(a, d), 2 === b && (f = $2434d53d0d34de35$var$xc(a), 0 !== f && (d = f, b = $2434d53d0d34de35$var$Nk(a, f))), 1 === b)) throw c = $2434d53d0d34de35$var$pk, $2434d53d0d34de35$var$Kk(a, 0), $2434d53d0d34de35$var$Ck(a, d), $2434d53d0d34de35$var$Dk(a, $2434d53d0d34de35$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($2434d53d0d34de35$var$p(345));
                case 2:
                    $2434d53d0d34de35$var$Pk(a, $2434d53d0d34de35$var$tk, $2434d53d0d34de35$var$uk);
                    break;
                case 3:
                    $2434d53d0d34de35$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $2434d53d0d34de35$var$fk + 500 - $2434d53d0d34de35$var$B(), 10 < b)) {
                        if (0 !== $2434d53d0d34de35$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $2434d53d0d34de35$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $2434d53d0d34de35$var$Ff($2434d53d0d34de35$var$Pk.bind(null, a, $2434d53d0d34de35$var$tk, $2434d53d0d34de35$var$uk), b);
                        break;
                    }
                    $2434d53d0d34de35$var$Pk(a, $2434d53d0d34de35$var$tk, $2434d53d0d34de35$var$uk);
                    break;
                case 4:
                    $2434d53d0d34de35$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $2434d53d0d34de35$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $2434d53d0d34de35$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $2434d53d0d34de35$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $2434d53d0d34de35$var$Ff($2434d53d0d34de35$var$Pk.bind(null, a, $2434d53d0d34de35$var$tk, $2434d53d0d34de35$var$uk), d);
                        break;
                    }
                    $2434d53d0d34de35$var$Pk(a, $2434d53d0d34de35$var$tk, $2434d53d0d34de35$var$uk);
                    break;
                case 5:
                    $2434d53d0d34de35$var$Pk(a, $2434d53d0d34de35$var$tk, $2434d53d0d34de35$var$uk);
                    break;
                default:
                    throw Error($2434d53d0d34de35$var$p(329));
            }
        }
    }
    $2434d53d0d34de35$var$Dk(a, $2434d53d0d34de35$var$B());
    return a.callbackNode === c ? $2434d53d0d34de35$var$Gk.bind(null, a) : null;
}
function $2434d53d0d34de35$var$Nk(a, b) {
    var c = $2434d53d0d34de35$var$sk;
    a.current.memoizedState.isDehydrated && ($2434d53d0d34de35$var$Kk(a, b).flags |= 256);
    a = $2434d53d0d34de35$var$Ik(a, b);
    2 !== a && (b = $2434d53d0d34de35$var$tk, $2434d53d0d34de35$var$tk = c, null !== b && $2434d53d0d34de35$var$Fj(b));
    return a;
}
function $2434d53d0d34de35$var$Fj(a) {
    null === $2434d53d0d34de35$var$tk ? $2434d53d0d34de35$var$tk = a : $2434d53d0d34de35$var$tk.push.apply($2434d53d0d34de35$var$tk, a);
}
function $2434d53d0d34de35$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$2434d53d0d34de35$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $2434d53d0d34de35$var$Ck(a, b) {
    b &= ~$2434d53d0d34de35$var$rk;
    b &= ~$2434d53d0d34de35$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $2434d53d0d34de35$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $2434d53d0d34de35$var$Ek(a) {
    if (0 !== ($2434d53d0d34de35$var$K & 6)) throw Error($2434d53d0d34de35$var$p(327));
    $2434d53d0d34de35$var$Hk();
    var b = $2434d53d0d34de35$var$uc(a, 0);
    if (0 === (b & 1)) return $2434d53d0d34de35$var$Dk(a, $2434d53d0d34de35$var$B()), null;
    var c = $2434d53d0d34de35$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $2434d53d0d34de35$var$xc(a);
        0 !== d && (b = d, c = $2434d53d0d34de35$var$Nk(a, d));
    }
    if (1 === c) throw c = $2434d53d0d34de35$var$pk, $2434d53d0d34de35$var$Kk(a, 0), $2434d53d0d34de35$var$Ck(a, b), $2434d53d0d34de35$var$Dk(a, $2434d53d0d34de35$var$B()), c;
    if (6 === c) throw Error($2434d53d0d34de35$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $2434d53d0d34de35$var$Pk(a, $2434d53d0d34de35$var$tk, $2434d53d0d34de35$var$uk);
    $2434d53d0d34de35$var$Dk(a, $2434d53d0d34de35$var$B());
    return null;
}
function $2434d53d0d34de35$var$Qk(a, b) {
    var c = $2434d53d0d34de35$var$K;
    $2434d53d0d34de35$var$K |= 1;
    try {
        return a(b);
    } finally{
        $2434d53d0d34de35$var$K = c, 0 === $2434d53d0d34de35$var$K && ($2434d53d0d34de35$var$Gj = $2434d53d0d34de35$var$B() + 500, $2434d53d0d34de35$var$fg && $2434d53d0d34de35$var$jg());
    }
}
function $2434d53d0d34de35$var$Rk(a) {
    null !== $2434d53d0d34de35$var$wk && 0 === $2434d53d0d34de35$var$wk.tag && 0 === ($2434d53d0d34de35$var$K & 6) && $2434d53d0d34de35$var$Hk();
    var b = $2434d53d0d34de35$var$K;
    $2434d53d0d34de35$var$K |= 1;
    var c = $2434d53d0d34de35$var$ok.transition, d = $2434d53d0d34de35$var$C;
    try {
        if ($2434d53d0d34de35$var$ok.transition = null, $2434d53d0d34de35$var$C = 1, a) return a();
    } finally{
        $2434d53d0d34de35$var$C = d, $2434d53d0d34de35$var$ok.transition = c, $2434d53d0d34de35$var$K = b, 0 === ($2434d53d0d34de35$var$K & 6) && $2434d53d0d34de35$var$jg();
    }
}
function $2434d53d0d34de35$var$Hj() {
    $2434d53d0d34de35$var$fj = $2434d53d0d34de35$var$ej.current;
    $2434d53d0d34de35$var$E($2434d53d0d34de35$var$ej);
}
function $2434d53d0d34de35$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $2434d53d0d34de35$var$Gf(c));
    if (null !== $2434d53d0d34de35$var$Y) for(c = $2434d53d0d34de35$var$Y.return; null !== c;){
        var d = c;
        $2434d53d0d34de35$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $2434d53d0d34de35$var$$f();
                break;
            case 3:
                $2434d53d0d34de35$var$zh();
                $2434d53d0d34de35$var$E($2434d53d0d34de35$var$Wf);
                $2434d53d0d34de35$var$E($2434d53d0d34de35$var$H);
                $2434d53d0d34de35$var$Eh();
                break;
            case 5:
                $2434d53d0d34de35$var$Bh(d);
                break;
            case 4:
                $2434d53d0d34de35$var$zh();
                break;
            case 13:
                $2434d53d0d34de35$var$E($2434d53d0d34de35$var$L);
                break;
            case 19:
                $2434d53d0d34de35$var$E($2434d53d0d34de35$var$L);
                break;
            case 10:
                $2434d53d0d34de35$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $2434d53d0d34de35$var$Hj();
        }
        c = c.return;
    }
    $2434d53d0d34de35$var$Q = a;
    $2434d53d0d34de35$var$Y = a = $2434d53d0d34de35$var$Pg(a.current, null);
    $2434d53d0d34de35$var$Z = $2434d53d0d34de35$var$fj = b;
    $2434d53d0d34de35$var$T = 0;
    $2434d53d0d34de35$var$pk = null;
    $2434d53d0d34de35$var$rk = $2434d53d0d34de35$var$qk = $2434d53d0d34de35$var$rh = 0;
    $2434d53d0d34de35$var$tk = $2434d53d0d34de35$var$sk = null;
    if (null !== $2434d53d0d34de35$var$fh) {
        for(b = 0; b < $2434d53d0d34de35$var$fh.length; b++)if (c = $2434d53d0d34de35$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $2434d53d0d34de35$var$fh = null;
    }
    return a;
}
function $2434d53d0d34de35$var$Mk(a, b) {
    do {
        var c = $2434d53d0d34de35$var$Y;
        try {
            $2434d53d0d34de35$var$$g();
            $2434d53d0d34de35$var$Fh.current = $2434d53d0d34de35$var$Rh;
            if ($2434d53d0d34de35$var$Ih) {
                for(var d = $2434d53d0d34de35$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $2434d53d0d34de35$var$Ih = !1;
            }
            $2434d53d0d34de35$var$Hh = 0;
            $2434d53d0d34de35$var$O = $2434d53d0d34de35$var$N = $2434d53d0d34de35$var$M = null;
            $2434d53d0d34de35$var$Jh = !1;
            $2434d53d0d34de35$var$Kh = 0;
            $2434d53d0d34de35$var$nk.current = null;
            if (null === c || null === c.return) {
                $2434d53d0d34de35$var$T = 1;
                $2434d53d0d34de35$var$pk = b;
                $2434d53d0d34de35$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $2434d53d0d34de35$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $2434d53d0d34de35$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $2434d53d0d34de35$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $2434d53d0d34de35$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $2434d53d0d34de35$var$Si(f, l, b);
                            $2434d53d0d34de35$var$tj();
                            break a;
                        }
                        k = Error($2434d53d0d34de35$var$p(426));
                    }
                } else if ($2434d53d0d34de35$var$I && h.mode & 1) {
                    var J = $2434d53d0d34de35$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $2434d53d0d34de35$var$Vi(J, g, h, f, b);
                        $2434d53d0d34de35$var$Jg($2434d53d0d34de35$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $2434d53d0d34de35$var$Ji(k, h);
                4 !== $2434d53d0d34de35$var$T && ($2434d53d0d34de35$var$T = 2);
                null === $2434d53d0d34de35$var$sk ? $2434d53d0d34de35$var$sk = [
                    f
                ] : $2434d53d0d34de35$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $2434d53d0d34de35$var$Ni(f, k, b);
                            $2434d53d0d34de35$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $2434d53d0d34de35$var$Ri || !$2434d53d0d34de35$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $2434d53d0d34de35$var$Qi(f, h, b);
                                $2434d53d0d34de35$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $2434d53d0d34de35$var$Sk(c);
        } catch (na) {
            b = na;
            $2434d53d0d34de35$var$Y === c && null !== c && ($2434d53d0d34de35$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $2434d53d0d34de35$var$Jk() {
    var a = $2434d53d0d34de35$var$mk.current;
    $2434d53d0d34de35$var$mk.current = $2434d53d0d34de35$var$Rh;
    return null === a ? $2434d53d0d34de35$var$Rh : a;
}
function $2434d53d0d34de35$var$tj() {
    if (0 === $2434d53d0d34de35$var$T || 3 === $2434d53d0d34de35$var$T || 2 === $2434d53d0d34de35$var$T) $2434d53d0d34de35$var$T = 4;
    null === $2434d53d0d34de35$var$Q || 0 === ($2434d53d0d34de35$var$rh & 268435455) && 0 === ($2434d53d0d34de35$var$qk & 268435455) || $2434d53d0d34de35$var$Ck($2434d53d0d34de35$var$Q, $2434d53d0d34de35$var$Z);
}
function $2434d53d0d34de35$var$Ik(a, b) {
    var c = $2434d53d0d34de35$var$K;
    $2434d53d0d34de35$var$K |= 2;
    var d = $2434d53d0d34de35$var$Jk();
    if ($2434d53d0d34de35$var$Q !== a || $2434d53d0d34de35$var$Z !== b) $2434d53d0d34de35$var$uk = null, $2434d53d0d34de35$var$Kk(a, b);
    for(;;)try {
        $2434d53d0d34de35$var$Tk();
        break;
    } catch (e) {
        $2434d53d0d34de35$var$Mk(a, e);
    }
    $2434d53d0d34de35$var$$g();
    $2434d53d0d34de35$var$K = c;
    $2434d53d0d34de35$var$mk.current = d;
    if (null !== $2434d53d0d34de35$var$Y) throw Error($2434d53d0d34de35$var$p(261));
    $2434d53d0d34de35$var$Q = null;
    $2434d53d0d34de35$var$Z = 0;
    return $2434d53d0d34de35$var$T;
}
function $2434d53d0d34de35$var$Tk() {
    for(; null !== $2434d53d0d34de35$var$Y;)$2434d53d0d34de35$var$Uk($2434d53d0d34de35$var$Y);
}
function $2434d53d0d34de35$var$Lk() {
    for(; null !== $2434d53d0d34de35$var$Y && !$2434d53d0d34de35$var$cc();)$2434d53d0d34de35$var$Uk($2434d53d0d34de35$var$Y);
}
function $2434d53d0d34de35$var$Uk(a) {
    var b = $2434d53d0d34de35$var$Vk(a.alternate, a, $2434d53d0d34de35$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $2434d53d0d34de35$var$Sk(a) : $2434d53d0d34de35$var$Y = b;
    $2434d53d0d34de35$var$nk.current = null;
}
function $2434d53d0d34de35$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $2434d53d0d34de35$var$Ej(c, b, $2434d53d0d34de35$var$fj), null !== c) {
                $2434d53d0d34de35$var$Y = c;
                return;
            }
        } else {
            c = $2434d53d0d34de35$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $2434d53d0d34de35$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $2434d53d0d34de35$var$T = 6;
                $2434d53d0d34de35$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $2434d53d0d34de35$var$Y = b;
            return;
        }
        $2434d53d0d34de35$var$Y = b = a;
    }while (null !== b);
    0 === $2434d53d0d34de35$var$T && ($2434d53d0d34de35$var$T = 5);
}
function $2434d53d0d34de35$var$Pk(a, b, c) {
    var d = $2434d53d0d34de35$var$C, e = $2434d53d0d34de35$var$ok.transition;
    try {
        $2434d53d0d34de35$var$ok.transition = null, $2434d53d0d34de35$var$C = 1, $2434d53d0d34de35$var$Wk(a, b, c, d);
    } finally{
        $2434d53d0d34de35$var$ok.transition = e, $2434d53d0d34de35$var$C = d;
    }
    return null;
}
function $2434d53d0d34de35$var$Wk(a, b, c, d) {
    do $2434d53d0d34de35$var$Hk();
    while (null !== $2434d53d0d34de35$var$wk);
    if (0 !== ($2434d53d0d34de35$var$K & 6)) throw Error($2434d53d0d34de35$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($2434d53d0d34de35$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $2434d53d0d34de35$var$Bc(a, f);
    a === $2434d53d0d34de35$var$Q && ($2434d53d0d34de35$var$Y = $2434d53d0d34de35$var$Q = null, $2434d53d0d34de35$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $2434d53d0d34de35$var$vk || ($2434d53d0d34de35$var$vk = !0, $2434d53d0d34de35$var$Fk($2434d53d0d34de35$var$hc, function() {
        $2434d53d0d34de35$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $2434d53d0d34de35$var$ok.transition;
        $2434d53d0d34de35$var$ok.transition = null;
        var g = $2434d53d0d34de35$var$C;
        $2434d53d0d34de35$var$C = 1;
        var h = $2434d53d0d34de35$var$K;
        $2434d53d0d34de35$var$K |= 4;
        $2434d53d0d34de35$var$nk.current = null;
        $2434d53d0d34de35$var$Oj(a, c);
        $2434d53d0d34de35$var$dk(c, a);
        $2434d53d0d34de35$var$Oe($2434d53d0d34de35$var$Df);
        $2434d53d0d34de35$var$dd = !!$2434d53d0d34de35$var$Cf;
        $2434d53d0d34de35$var$Df = $2434d53d0d34de35$var$Cf = null;
        a.current = c;
        $2434d53d0d34de35$var$hk(c, a, e);
        $2434d53d0d34de35$var$dc();
        $2434d53d0d34de35$var$K = h;
        $2434d53d0d34de35$var$C = g;
        $2434d53d0d34de35$var$ok.transition = f;
    } else a.current = c;
    $2434d53d0d34de35$var$vk && ($2434d53d0d34de35$var$vk = !1, $2434d53d0d34de35$var$wk = a, $2434d53d0d34de35$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($2434d53d0d34de35$var$Ri = null);
    $2434d53d0d34de35$var$mc(c.stateNode, d);
    $2434d53d0d34de35$var$Dk(a, $2434d53d0d34de35$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($2434d53d0d34de35$var$Oi) throw $2434d53d0d34de35$var$Oi = !1, a = $2434d53d0d34de35$var$Pi, $2434d53d0d34de35$var$Pi = null, a;
    0 !== ($2434d53d0d34de35$var$xk & 1) && 0 !== a.tag && $2434d53d0d34de35$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $2434d53d0d34de35$var$zk ? $2434d53d0d34de35$var$yk++ : ($2434d53d0d34de35$var$yk = 0, $2434d53d0d34de35$var$zk = a) : $2434d53d0d34de35$var$yk = 0;
    $2434d53d0d34de35$var$jg();
    return null;
}
function $2434d53d0d34de35$var$Hk() {
    if (null !== $2434d53d0d34de35$var$wk) {
        var a = $2434d53d0d34de35$var$Dc($2434d53d0d34de35$var$xk), b = $2434d53d0d34de35$var$ok.transition, c = $2434d53d0d34de35$var$C;
        try {
            $2434d53d0d34de35$var$ok.transition = null;
            $2434d53d0d34de35$var$C = 16 > a ? 16 : a;
            if (null === $2434d53d0d34de35$var$wk) var d = !1;
            else {
                a = $2434d53d0d34de35$var$wk;
                $2434d53d0d34de35$var$wk = null;
                $2434d53d0d34de35$var$xk = 0;
                if (0 !== ($2434d53d0d34de35$var$K & 6)) throw Error($2434d53d0d34de35$var$p(331));
                var e = $2434d53d0d34de35$var$K;
                $2434d53d0d34de35$var$K |= 4;
                for($2434d53d0d34de35$var$V = a.current; null !== $2434d53d0d34de35$var$V;){
                    var f = $2434d53d0d34de35$var$V, g = f.child;
                    if (0 !== ($2434d53d0d34de35$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($2434d53d0d34de35$var$V = l; null !== $2434d53d0d34de35$var$V;){
                                    var m = $2434d53d0d34de35$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $2434d53d0d34de35$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $2434d53d0d34de35$var$V = q;
                                    else for(; null !== $2434d53d0d34de35$var$V;){
                                        m = $2434d53d0d34de35$var$V;
                                        var r = m.sibling, y = m.return;
                                        $2434d53d0d34de35$var$Sj(m);
                                        if (m === l) {
                                            $2434d53d0d34de35$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $2434d53d0d34de35$var$V = r;
                                            break;
                                        }
                                        $2434d53d0d34de35$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $2434d53d0d34de35$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $2434d53d0d34de35$var$V = g;
                    else b: for(; null !== $2434d53d0d34de35$var$V;){
                        f = $2434d53d0d34de35$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $2434d53d0d34de35$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $2434d53d0d34de35$var$V = x;
                            break b;
                        }
                        $2434d53d0d34de35$var$V = f.return;
                    }
                }
                var w = a.current;
                for($2434d53d0d34de35$var$V = w; null !== $2434d53d0d34de35$var$V;){
                    g = $2434d53d0d34de35$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $2434d53d0d34de35$var$V = u;
                    else b: for(g = w; null !== $2434d53d0d34de35$var$V;){
                        h = $2434d53d0d34de35$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $2434d53d0d34de35$var$Qj(9, h);
                            }
                        } catch (na) {
                            $2434d53d0d34de35$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $2434d53d0d34de35$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $2434d53d0d34de35$var$V = F;
                            break b;
                        }
                        $2434d53d0d34de35$var$V = h.return;
                    }
                }
                $2434d53d0d34de35$var$K = e;
                $2434d53d0d34de35$var$jg();
                if ($2434d53d0d34de35$var$lc && "function" === typeof $2434d53d0d34de35$var$lc.onPostCommitFiberRoot) try {
                    $2434d53d0d34de35$var$lc.onPostCommitFiberRoot($2434d53d0d34de35$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $2434d53d0d34de35$var$C = c, $2434d53d0d34de35$var$ok.transition = b;
        }
    }
    return !1;
}
function $2434d53d0d34de35$var$Xk(a, b, c) {
    b = $2434d53d0d34de35$var$Ji(c, b);
    b = $2434d53d0d34de35$var$Ni(a, b, 1);
    a = $2434d53d0d34de35$var$nh(a, b, 1);
    b = $2434d53d0d34de35$var$R();
    null !== a && ($2434d53d0d34de35$var$Ac(a, 1, b), $2434d53d0d34de35$var$Dk(a, b));
}
function $2434d53d0d34de35$var$W(a, b, c) {
    if (3 === a.tag) $2434d53d0d34de35$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $2434d53d0d34de35$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $2434d53d0d34de35$var$Ri || !$2434d53d0d34de35$var$Ri.has(d))) {
                a = $2434d53d0d34de35$var$Ji(c, a);
                a = $2434d53d0d34de35$var$Qi(b, a, 1);
                b = $2434d53d0d34de35$var$nh(b, a, 1);
                a = $2434d53d0d34de35$var$R();
                null !== b && ($2434d53d0d34de35$var$Ac(b, 1, a), $2434d53d0d34de35$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $2434d53d0d34de35$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $2434d53d0d34de35$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $2434d53d0d34de35$var$Q === a && ($2434d53d0d34de35$var$Z & c) === c && (4 === $2434d53d0d34de35$var$T || 3 === $2434d53d0d34de35$var$T && ($2434d53d0d34de35$var$Z & 130023424) === $2434d53d0d34de35$var$Z && 500 > $2434d53d0d34de35$var$B() - $2434d53d0d34de35$var$fk ? $2434d53d0d34de35$var$Kk(a, 0) : $2434d53d0d34de35$var$rk |= c);
    $2434d53d0d34de35$var$Dk(a, b);
}
function $2434d53d0d34de35$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $2434d53d0d34de35$var$sc, $2434d53d0d34de35$var$sc <<= 1, 0 === ($2434d53d0d34de35$var$sc & 130023424) && ($2434d53d0d34de35$var$sc = 4194304)));
    var c = $2434d53d0d34de35$var$R();
    a = $2434d53d0d34de35$var$ih(a, b);
    null !== a && ($2434d53d0d34de35$var$Ac(a, b, c), $2434d53d0d34de35$var$Dk(a, c));
}
function $2434d53d0d34de35$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $2434d53d0d34de35$var$Yk(a, c);
}
function $2434d53d0d34de35$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($2434d53d0d34de35$var$p(314));
    }
    null !== d && d.delete(b);
    $2434d53d0d34de35$var$Yk(a, c);
}
var $2434d53d0d34de35$var$Vk;
$2434d53d0d34de35$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $2434d53d0d34de35$var$Wf.current) $2434d53d0d34de35$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $2434d53d0d34de35$var$dh = !1, $2434d53d0d34de35$var$yj(a, b, c);
            $2434d53d0d34de35$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $2434d53d0d34de35$var$dh = !1, $2434d53d0d34de35$var$I && 0 !== (b.flags & 1048576) && $2434d53d0d34de35$var$ug(b, $2434d53d0d34de35$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $2434d53d0d34de35$var$ij(a, b);
            a = b.pendingProps;
            var e = $2434d53d0d34de35$var$Yf(b, $2434d53d0d34de35$var$H.current);
            $2434d53d0d34de35$var$ch(b, c);
            e = $2434d53d0d34de35$var$Nh(null, b, d, a, e, c);
            var f = $2434d53d0d34de35$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $2434d53d0d34de35$var$Zf(d) ? (f = !0, $2434d53d0d34de35$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $2434d53d0d34de35$var$kh(b), e.updater = $2434d53d0d34de35$var$Ei, b.stateNode = e, e._reactInternals = b, $2434d53d0d34de35$var$Ii(b, d, a, c), b = $2434d53d0d34de35$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $2434d53d0d34de35$var$I && f && $2434d53d0d34de35$var$vg(b), $2434d53d0d34de35$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $2434d53d0d34de35$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $2434d53d0d34de35$var$Zk(d);
                a = $2434d53d0d34de35$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $2434d53d0d34de35$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $2434d53d0d34de35$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $2434d53d0d34de35$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $2434d53d0d34de35$var$$i(null, b, d, $2434d53d0d34de35$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($2434d53d0d34de35$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2434d53d0d34de35$var$Ci(d, e), $2434d53d0d34de35$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2434d53d0d34de35$var$Ci(d, e), $2434d53d0d34de35$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $2434d53d0d34de35$var$kj(b);
                if (null === a) throw Error($2434d53d0d34de35$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $2434d53d0d34de35$var$lh(a, b);
                $2434d53d0d34de35$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $2434d53d0d34de35$var$Ji(Error($2434d53d0d34de35$var$p(423)), b);
                        b = $2434d53d0d34de35$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $2434d53d0d34de35$var$Ji(Error($2434d53d0d34de35$var$p(424)), b);
                        b = $2434d53d0d34de35$var$lj(a, b, d, c, e);
                        break a;
                    } else for($2434d53d0d34de35$var$yg = $2434d53d0d34de35$var$Lf(b.stateNode.containerInfo.firstChild), $2434d53d0d34de35$var$xg = b, $2434d53d0d34de35$var$I = !0, $2434d53d0d34de35$var$zg = null, c = $2434d53d0d34de35$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $2434d53d0d34de35$var$Ig();
                    if (d === e) {
                        b = $2434d53d0d34de35$var$Zi(a, b, c);
                        break a;
                    }
                    $2434d53d0d34de35$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $2434d53d0d34de35$var$Ah(b), null === a && $2434d53d0d34de35$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $2434d53d0d34de35$var$Ef(d, e) ? g = null : null !== f && $2434d53d0d34de35$var$Ef(d, f) && (b.flags |= 32), $2434d53d0d34de35$var$gj(a, b), $2434d53d0d34de35$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $2434d53d0d34de35$var$Eg(b), null;
        case 13:
            return $2434d53d0d34de35$var$oj(a, b, c);
        case 4:
            return $2434d53d0d34de35$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $2434d53d0d34de35$var$Ug(b, null, d, c) : $2434d53d0d34de35$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2434d53d0d34de35$var$Ci(d, e), $2434d53d0d34de35$var$Yi(a, b, d, e, c);
        case 7:
            return $2434d53d0d34de35$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $2434d53d0d34de35$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $2434d53d0d34de35$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $2434d53d0d34de35$var$G($2434d53d0d34de35$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($2434d53d0d34de35$var$He(f.value, g)) {
                        if (f.children === e.children && !$2434d53d0d34de35$var$Wf.current) {
                            b = $2434d53d0d34de35$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $2434d53d0d34de35$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $2434d53d0d34de35$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($2434d53d0d34de35$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $2434d53d0d34de35$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $2434d53d0d34de35$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $2434d53d0d34de35$var$ch(b, c), e = $2434d53d0d34de35$var$eh(e), d = d(e), b.flags |= 1, $2434d53d0d34de35$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $2434d53d0d34de35$var$Ci(d, b.pendingProps), e = $2434d53d0d34de35$var$Ci(d.type, e), $2434d53d0d34de35$var$$i(a, b, d, e, c);
        case 15:
            return $2434d53d0d34de35$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2434d53d0d34de35$var$Ci(d, e), $2434d53d0d34de35$var$ij(a, b), b.tag = 1, $2434d53d0d34de35$var$Zf(d) ? (a = !0, $2434d53d0d34de35$var$cg(b)) : a = !1, $2434d53d0d34de35$var$ch(b, c), $2434d53d0d34de35$var$Gi(b, d, e), $2434d53d0d34de35$var$Ii(b, d, e, c), $2434d53d0d34de35$var$jj(null, b, d, !0, a, c);
        case 19:
            return $2434d53d0d34de35$var$xj(a, b, c);
        case 22:
            return $2434d53d0d34de35$var$dj(a, b, c);
    }
    throw Error($2434d53d0d34de35$var$p(156, b.tag));
};
function $2434d53d0d34de35$var$Fk(a, b) {
    return $2434d53d0d34de35$var$ac(a, b);
}
function $2434d53d0d34de35$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $2434d53d0d34de35$var$Bg(a, b, c, d) {
    return new $2434d53d0d34de35$var$$k(a, b, c, d);
}
function $2434d53d0d34de35$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $2434d53d0d34de35$var$Zk(a) {
    if ("function" === typeof a) return $2434d53d0d34de35$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $2434d53d0d34de35$var$Da) return 11;
        if (a === $2434d53d0d34de35$var$Ga) return 14;
    }
    return 2;
}
function $2434d53d0d34de35$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $2434d53d0d34de35$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $2434d53d0d34de35$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $2434d53d0d34de35$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $2434d53d0d34de35$var$ya:
            return $2434d53d0d34de35$var$Tg(c.children, e, f, b);
        case $2434d53d0d34de35$var$za:
            g = 8;
            e |= 8;
            break;
        case $2434d53d0d34de35$var$Aa:
            return a = $2434d53d0d34de35$var$Bg(12, c, b, e | 2), a.elementType = $2434d53d0d34de35$var$Aa, a.lanes = f, a;
        case $2434d53d0d34de35$var$Ea:
            return a = $2434d53d0d34de35$var$Bg(13, c, b, e), a.elementType = $2434d53d0d34de35$var$Ea, a.lanes = f, a;
        case $2434d53d0d34de35$var$Fa:
            return a = $2434d53d0d34de35$var$Bg(19, c, b, e), a.elementType = $2434d53d0d34de35$var$Fa, a.lanes = f, a;
        case $2434d53d0d34de35$var$Ia:
            return $2434d53d0d34de35$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $2434d53d0d34de35$var$Ba:
                    g = 10;
                    break a;
                case $2434d53d0d34de35$var$Ca:
                    g = 9;
                    break a;
                case $2434d53d0d34de35$var$Da:
                    g = 11;
                    break a;
                case $2434d53d0d34de35$var$Ga:
                    g = 14;
                    break a;
                case $2434d53d0d34de35$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($2434d53d0d34de35$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $2434d53d0d34de35$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $2434d53d0d34de35$var$Tg(a, b, c, d) {
    a = $2434d53d0d34de35$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $2434d53d0d34de35$var$pj(a, b, c, d) {
    a = $2434d53d0d34de35$var$Bg(22, a, d, b);
    a.elementType = $2434d53d0d34de35$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $2434d53d0d34de35$var$Qg(a, b, c) {
    a = $2434d53d0d34de35$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $2434d53d0d34de35$var$Sg(a, b, c) {
    b = $2434d53d0d34de35$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $2434d53d0d34de35$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $2434d53d0d34de35$var$zc(0);
    this.expirationTimes = $2434d53d0d34de35$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $2434d53d0d34de35$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $2434d53d0d34de35$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $2434d53d0d34de35$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $2434d53d0d34de35$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $2434d53d0d34de35$var$kh(f);
    return a;
}
function $2434d53d0d34de35$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $2434d53d0d34de35$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $2434d53d0d34de35$var$dl(a) {
    if (!a) return $2434d53d0d34de35$var$Vf;
    a = a._reactInternals;
    a: {
        if ($2434d53d0d34de35$var$Vb(a) !== a || 1 !== a.tag) throw Error($2434d53d0d34de35$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($2434d53d0d34de35$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($2434d53d0d34de35$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($2434d53d0d34de35$var$Zf(c)) return $2434d53d0d34de35$var$bg(a, c, b);
    }
    return b;
}
function $2434d53d0d34de35$var$el(a, b, c, d, e, f, g, h, k) {
    a = $2434d53d0d34de35$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $2434d53d0d34de35$var$dl(null);
    c = a.current;
    d = $2434d53d0d34de35$var$R();
    e = $2434d53d0d34de35$var$yi(c);
    f = $2434d53d0d34de35$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $2434d53d0d34de35$var$nh(c, f, e);
    a.current.lanes = e;
    $2434d53d0d34de35$var$Ac(a, e, d);
    $2434d53d0d34de35$var$Dk(a, d);
    return a;
}
function $2434d53d0d34de35$var$fl(a, b, c, d) {
    var e = b.current, f = $2434d53d0d34de35$var$R(), g = $2434d53d0d34de35$var$yi(e);
    c = $2434d53d0d34de35$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $2434d53d0d34de35$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $2434d53d0d34de35$var$nh(e, b, g);
    null !== a && ($2434d53d0d34de35$var$gi(a, e, g, f), $2434d53d0d34de35$var$oh(a, e, g));
    return g;
}
function $2434d53d0d34de35$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $2434d53d0d34de35$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $2434d53d0d34de35$var$il(a, b) {
    $2434d53d0d34de35$var$hl(a, b);
    (a = a.alternate) && $2434d53d0d34de35$var$hl(a, b);
}
function $2434d53d0d34de35$var$jl() {
    return null;
}
var $2434d53d0d34de35$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $2434d53d0d34de35$var$ll(a) {
    this._internalRoot = a;
}
$2434d53d0d34de35$var$ml.prototype.render = $2434d53d0d34de35$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($2434d53d0d34de35$var$p(409));
    $2434d53d0d34de35$var$fl(a, b, null, null);
};
$2434d53d0d34de35$var$ml.prototype.unmount = $2434d53d0d34de35$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $2434d53d0d34de35$var$Rk(function() {
            $2434d53d0d34de35$var$fl(null, a, null, null);
        });
        b[$2434d53d0d34de35$var$uf] = null;
    }
};
function $2434d53d0d34de35$var$ml(a) {
    this._internalRoot = a;
}
$2434d53d0d34de35$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $2434d53d0d34de35$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $2434d53d0d34de35$var$Qc.length && 0 !== b && b < $2434d53d0d34de35$var$Qc[c].priority; c++);
        $2434d53d0d34de35$var$Qc.splice(c, 0, a);
        0 === c && $2434d53d0d34de35$var$Vc(a);
    }
};
function $2434d53d0d34de35$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $2434d53d0d34de35$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $2434d53d0d34de35$var$pl() {}
function $2434d53d0d34de35$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $2434d53d0d34de35$var$gl(g);
                f.call(a);
            };
        }
        var g = $2434d53d0d34de35$var$el(b, d, a, 0, null, !1, !1, "", $2434d53d0d34de35$var$pl);
        a._reactRootContainer = g;
        a[$2434d53d0d34de35$var$uf] = g.current;
        $2434d53d0d34de35$var$sf(8 === a.nodeType ? a.parentNode : a);
        $2434d53d0d34de35$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $2434d53d0d34de35$var$gl(k);
            h.call(a);
        };
    }
    var k = $2434d53d0d34de35$var$bl(a, 0, !1, null, null, !1, !1, "", $2434d53d0d34de35$var$pl);
    a._reactRootContainer = k;
    a[$2434d53d0d34de35$var$uf] = k.current;
    $2434d53d0d34de35$var$sf(8 === a.nodeType ? a.parentNode : a);
    $2434d53d0d34de35$var$Rk(function() {
        $2434d53d0d34de35$var$fl(b, k, c, d);
    });
    return k;
}
function $2434d53d0d34de35$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $2434d53d0d34de35$var$gl(g);
                h.call(a);
            };
        }
        $2434d53d0d34de35$var$fl(b, g, a, e);
    } else g = $2434d53d0d34de35$var$ql(c, b, a, e, d);
    return $2434d53d0d34de35$var$gl(g);
}
$2434d53d0d34de35$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $2434d53d0d34de35$var$tc(b.pendingLanes);
                0 !== c && ($2434d53d0d34de35$var$Cc(b, c | 1), $2434d53d0d34de35$var$Dk(b, $2434d53d0d34de35$var$B()), 0 === ($2434d53d0d34de35$var$K & 6) && ($2434d53d0d34de35$var$Gj = $2434d53d0d34de35$var$B() + 500, $2434d53d0d34de35$var$jg()));
            }
            break;
        case 13:
            $2434d53d0d34de35$var$Rk(function() {
                var b = $2434d53d0d34de35$var$ih(a, 1);
                if (null !== b) {
                    var c = $2434d53d0d34de35$var$R();
                    $2434d53d0d34de35$var$gi(b, a, 1, c);
                }
            }), $2434d53d0d34de35$var$il(a, 1);
    }
};
$2434d53d0d34de35$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $2434d53d0d34de35$var$ih(a, 134217728);
        if (null !== b) {
            var c = $2434d53d0d34de35$var$R();
            $2434d53d0d34de35$var$gi(b, a, 134217728, c);
        }
        $2434d53d0d34de35$var$il(a, 134217728);
    }
};
$2434d53d0d34de35$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $2434d53d0d34de35$var$yi(a), c = $2434d53d0d34de35$var$ih(a, b);
        if (null !== c) {
            var d = $2434d53d0d34de35$var$R();
            $2434d53d0d34de35$var$gi(c, a, b, d);
        }
        $2434d53d0d34de35$var$il(a, b);
    }
};
$2434d53d0d34de35$var$Hc = function() {
    return $2434d53d0d34de35$var$C;
};
$2434d53d0d34de35$var$Ic = function(a, b) {
    var c = $2434d53d0d34de35$var$C;
    try {
        return $2434d53d0d34de35$var$C = a, b();
    } finally{
        $2434d53d0d34de35$var$C = c;
    }
};
$2434d53d0d34de35$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $2434d53d0d34de35$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $2434d53d0d34de35$var$Db(d);
                        if (!e) throw Error($2434d53d0d34de35$var$p(90));
                        $2434d53d0d34de35$var$Wa(d);
                        $2434d53d0d34de35$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $2434d53d0d34de35$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $2434d53d0d34de35$var$fb(a, !!c.multiple, b, !1);
    }
};
$2434d53d0d34de35$var$Gb = $2434d53d0d34de35$var$Qk;
$2434d53d0d34de35$var$Hb = $2434d53d0d34de35$var$Rk;
var $2434d53d0d34de35$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $2434d53d0d34de35$var$Cb,
        $2434d53d0d34de35$var$ue,
        $2434d53d0d34de35$var$Db,
        $2434d53d0d34de35$var$Eb,
        $2434d53d0d34de35$var$Fb,
        $2434d53d0d34de35$var$Qk
    ]
}, $2434d53d0d34de35$var$tl = {
    findFiberByHostInstance: $2434d53d0d34de35$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $2434d53d0d34de35$var$ul = {
    bundleType: $2434d53d0d34de35$var$tl.bundleType,
    version: $2434d53d0d34de35$var$tl.version,
    rendererPackageName: $2434d53d0d34de35$var$tl.rendererPackageName,
    rendererConfig: $2434d53d0d34de35$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $2434d53d0d34de35$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $2434d53d0d34de35$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $2434d53d0d34de35$var$tl.findFiberByHostInstance || $2434d53d0d34de35$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $2434d53d0d34de35$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$2434d53d0d34de35$var$vl.isDisabled && $2434d53d0d34de35$var$vl.supportsFiber) try {
        $2434d53d0d34de35$var$kc = $2434d53d0d34de35$var$vl.inject($2434d53d0d34de35$var$ul), $2434d53d0d34de35$var$lc = $2434d53d0d34de35$var$vl;
    } catch (a) {}
}
$2434d53d0d34de35$export$ae55be85d98224ed = $2434d53d0d34de35$var$sl;
$2434d53d0d34de35$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$2434d53d0d34de35$var$nl(b)) throw Error($2434d53d0d34de35$var$p(200));
    return $2434d53d0d34de35$var$cl(a, b, null, c);
};
$2434d53d0d34de35$export$882461b6382ed46c = function(a, b) {
    if (!$2434d53d0d34de35$var$nl(a)) throw Error($2434d53d0d34de35$var$p(299));
    var c = !1, d = "", e = $2434d53d0d34de35$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $2434d53d0d34de35$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$2434d53d0d34de35$var$uf] = b.current;
    $2434d53d0d34de35$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $2434d53d0d34de35$var$ll(b);
};
$2434d53d0d34de35$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($2434d53d0d34de35$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($2434d53d0d34de35$var$p(268, a));
    }
    a = $2434d53d0d34de35$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$2434d53d0d34de35$export$cd75ccfd720a3cd4 = function(a) {
    return $2434d53d0d34de35$var$Rk(a);
};
$2434d53d0d34de35$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$2434d53d0d34de35$var$ol(b)) throw Error($2434d53d0d34de35$var$p(200));
    return $2434d53d0d34de35$var$rl(null, a, b, !0, c);
};
$2434d53d0d34de35$export$757ceba2d55c277e = function(a, b, c) {
    if (!$2434d53d0d34de35$var$nl(a)) throw Error($2434d53d0d34de35$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $2434d53d0d34de35$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $2434d53d0d34de35$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$2434d53d0d34de35$var$uf] = b.current;
    $2434d53d0d34de35$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $2434d53d0d34de35$var$ml(b);
};
$2434d53d0d34de35$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$2434d53d0d34de35$var$ol(b)) throw Error($2434d53d0d34de35$var$p(200));
    return $2434d53d0d34de35$var$rl(null, a, b, !1, c);
};
$2434d53d0d34de35$export$502457920280e6be = function(a) {
    if (!$2434d53d0d34de35$var$ol(a)) throw Error($2434d53d0d34de35$var$p(40));
    return a._reactRootContainer ? ($2434d53d0d34de35$var$Rk(function() {
        $2434d53d0d34de35$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$2434d53d0d34de35$var$uf] = null;
        });
    }), !0) : !1;
};
$2434d53d0d34de35$export$c78a37762a8d58e1 = $2434d53d0d34de35$var$Qk;
$2434d53d0d34de35$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$2434d53d0d34de35$var$ol(c)) throw Error($2434d53d0d34de35$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($2434d53d0d34de35$var$p(38));
    return $2434d53d0d34de35$var$rl(a, b, c, !1, d);
};
$2434d53d0d34de35$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("gaQTF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6vE2d"));

});
parcelRegister("6vE2d", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $4bd4b160f282b4c6$export$c4744153514ff05d; }, function (v) { return $4bd4b160f282b4c6$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $4bd4b160f282b4c6$export$3e506c1ccc9cc1a7; }, function (v) { return $4bd4b160f282b4c6$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $4bd4b160f282b4c6$export$e26fe2ed2fa76875; }, function (v) { return $4bd4b160f282b4c6$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $4bd4b160f282b4c6$export$502329bbf4b505b1; }, function (v) { return $4bd4b160f282b4c6$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $4bd4b160f282b4c6$export$6e3807111c4874c4; }, function (v) { return $4bd4b160f282b4c6$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $4bd4b160f282b4c6$export$c27134553091fb3a; }, function (v) { return $4bd4b160f282b4c6$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $4bd4b160f282b4c6$export$33ee1acdc04fd2a2; }, function (v) { return $4bd4b160f282b4c6$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $4bd4b160f282b4c6$export$b00a404bbd5edef2; }, function (v) { return $4bd4b160f282b4c6$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $4bd4b160f282b4c6$export$8352ce38b91d0c62; }, function (v) { return $4bd4b160f282b4c6$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $4bd4b160f282b4c6$export$d66a1c1c77bd778b; }, function (v) { return $4bd4b160f282b4c6$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $4bd4b160f282b4c6$export$d3dfb8e4810cb555; }, function (v) { return $4bd4b160f282b4c6$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $4bd4b160f282b4c6$export$839f9183b0465a69; }, function (v) { return $4bd4b160f282b4c6$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $4bd4b160f282b4c6$export$72fdf0e06517287b; }, function (v) { return $4bd4b160f282b4c6$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $4bd4b160f282b4c6$export$4b844e58a3e414b4; }, function (v) { return $4bd4b160f282b4c6$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $4bd4b160f282b4c6$export$816d2913ae6b83b1; }, function (v) { return $4bd4b160f282b4c6$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $4bd4b160f282b4c6$export$61bcfe829111a1d0; }, function (v) { return $4bd4b160f282b4c6$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $4bd4b160f282b4c6$export$7ee8c9beb337bc3f; }, function (v) { return $4bd4b160f282b4c6$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $4bd4b160f282b4c6$export$b5836b71941fa3ed; }, function (v) { return $4bd4b160f282b4c6$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $4bd4b160f282b4c6$export$cf845f2c119da08a; }, function (v) { return $4bd4b160f282b4c6$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4bd4b160f282b4c6$export$c4744153514ff05d;
var $4bd4b160f282b4c6$export$3e506c1ccc9cc1a7;
var $4bd4b160f282b4c6$export$e26fe2ed2fa76875;
var $4bd4b160f282b4c6$export$502329bbf4b505b1;
var $4bd4b160f282b4c6$export$6e3807111c4874c4;
var $4bd4b160f282b4c6$export$c27134553091fb3a;
var $4bd4b160f282b4c6$export$33ee1acdc04fd2a2;
var $4bd4b160f282b4c6$export$b00a404bbd5edef2;
var $4bd4b160f282b4c6$export$8352ce38b91d0c62;
var $4bd4b160f282b4c6$export$d66a1c1c77bd778b;
var $4bd4b160f282b4c6$export$d3dfb8e4810cb555;
var $4bd4b160f282b4c6$export$839f9183b0465a69;
var $4bd4b160f282b4c6$export$72fdf0e06517287b;
var $4bd4b160f282b4c6$export$4b844e58a3e414b4;
var $4bd4b160f282b4c6$export$816d2913ae6b83b1;
var $4bd4b160f282b4c6$export$61bcfe829111a1d0;
var $4bd4b160f282b4c6$export$7ee8c9beb337bc3f;
var $4bd4b160f282b4c6$export$b5836b71941fa3ed;
var $4bd4b160f282b4c6$export$cf845f2c119da08a;
'use strict';
function $4bd4b160f282b4c6$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $4bd4b160f282b4c6$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $4bd4b160f282b4c6$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $4bd4b160f282b4c6$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $4bd4b160f282b4c6$var$g(C, c)) n < e && 0 > $4bd4b160f282b4c6$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $4bd4b160f282b4c6$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $4bd4b160f282b4c6$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $4bd4b160f282b4c6$var$l = performance;
    $4bd4b160f282b4c6$export$c4744153514ff05d = function() {
        return $4bd4b160f282b4c6$var$l.now();
    };
} else {
    var $4bd4b160f282b4c6$var$p = Date, $4bd4b160f282b4c6$var$q = $4bd4b160f282b4c6$var$p.now();
    $4bd4b160f282b4c6$export$c4744153514ff05d = function() {
        return $4bd4b160f282b4c6$var$p.now() - $4bd4b160f282b4c6$var$q;
    };
}
var $4bd4b160f282b4c6$var$r = [], $4bd4b160f282b4c6$var$t = [], $4bd4b160f282b4c6$var$u = 1, $4bd4b160f282b4c6$var$v = null, $4bd4b160f282b4c6$var$y = 3, $4bd4b160f282b4c6$var$z = !1, $4bd4b160f282b4c6$var$A = !1, $4bd4b160f282b4c6$var$B = !1, $4bd4b160f282b4c6$var$D = "function" === typeof setTimeout ? setTimeout : null, $4bd4b160f282b4c6$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $4bd4b160f282b4c6$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $4bd4b160f282b4c6$var$G(a) {
    for(var b = $4bd4b160f282b4c6$var$h($4bd4b160f282b4c6$var$t); null !== b;){
        if (null === b.callback) $4bd4b160f282b4c6$var$k($4bd4b160f282b4c6$var$t);
        else if (b.startTime <= a) $4bd4b160f282b4c6$var$k($4bd4b160f282b4c6$var$t), b.sortIndex = b.expirationTime, $4bd4b160f282b4c6$var$f($4bd4b160f282b4c6$var$r, b);
        else break;
        b = $4bd4b160f282b4c6$var$h($4bd4b160f282b4c6$var$t);
    }
}
function $4bd4b160f282b4c6$var$H(a) {
    $4bd4b160f282b4c6$var$B = !1;
    $4bd4b160f282b4c6$var$G(a);
    if (!$4bd4b160f282b4c6$var$A) {
        if (null !== $4bd4b160f282b4c6$var$h($4bd4b160f282b4c6$var$r)) $4bd4b160f282b4c6$var$A = !0, $4bd4b160f282b4c6$var$I($4bd4b160f282b4c6$var$J);
        else {
            var b = $4bd4b160f282b4c6$var$h($4bd4b160f282b4c6$var$t);
            null !== b && $4bd4b160f282b4c6$var$K($4bd4b160f282b4c6$var$H, b.startTime - a);
        }
    }
}
function $4bd4b160f282b4c6$var$J(a, b) {
    $4bd4b160f282b4c6$var$A = !1;
    $4bd4b160f282b4c6$var$B && ($4bd4b160f282b4c6$var$B = !1, $4bd4b160f282b4c6$var$E($4bd4b160f282b4c6$var$L), $4bd4b160f282b4c6$var$L = -1);
    $4bd4b160f282b4c6$var$z = !0;
    var c = $4bd4b160f282b4c6$var$y;
    try {
        $4bd4b160f282b4c6$var$G(b);
        for($4bd4b160f282b4c6$var$v = $4bd4b160f282b4c6$var$h($4bd4b160f282b4c6$var$r); null !== $4bd4b160f282b4c6$var$v && (!($4bd4b160f282b4c6$var$v.expirationTime > b) || a && !$4bd4b160f282b4c6$var$M());){
            var d = $4bd4b160f282b4c6$var$v.callback;
            if ("function" === typeof d) {
                $4bd4b160f282b4c6$var$v.callback = null;
                $4bd4b160f282b4c6$var$y = $4bd4b160f282b4c6$var$v.priorityLevel;
                var e = d($4bd4b160f282b4c6$var$v.expirationTime <= b);
                b = $4bd4b160f282b4c6$export$c4744153514ff05d();
                "function" === typeof e ? $4bd4b160f282b4c6$var$v.callback = e : $4bd4b160f282b4c6$var$v === $4bd4b160f282b4c6$var$h($4bd4b160f282b4c6$var$r) && $4bd4b160f282b4c6$var$k($4bd4b160f282b4c6$var$r);
                $4bd4b160f282b4c6$var$G(b);
            } else $4bd4b160f282b4c6$var$k($4bd4b160f282b4c6$var$r);
            $4bd4b160f282b4c6$var$v = $4bd4b160f282b4c6$var$h($4bd4b160f282b4c6$var$r);
        }
        if (null !== $4bd4b160f282b4c6$var$v) var w = !0;
        else {
            var m = $4bd4b160f282b4c6$var$h($4bd4b160f282b4c6$var$t);
            null !== m && $4bd4b160f282b4c6$var$K($4bd4b160f282b4c6$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $4bd4b160f282b4c6$var$v = null, $4bd4b160f282b4c6$var$y = c, $4bd4b160f282b4c6$var$z = !1;
    }
}
var $4bd4b160f282b4c6$var$N = !1, $4bd4b160f282b4c6$var$O = null, $4bd4b160f282b4c6$var$L = -1, $4bd4b160f282b4c6$var$P = 5, $4bd4b160f282b4c6$var$Q = -1;
function $4bd4b160f282b4c6$var$M() {
    return $4bd4b160f282b4c6$export$c4744153514ff05d() - $4bd4b160f282b4c6$var$Q < $4bd4b160f282b4c6$var$P ? !1 : !0;
}
function $4bd4b160f282b4c6$var$R() {
    if (null !== $4bd4b160f282b4c6$var$O) {
        var a = $4bd4b160f282b4c6$export$c4744153514ff05d();
        $4bd4b160f282b4c6$var$Q = a;
        var b = !0;
        try {
            b = $4bd4b160f282b4c6$var$O(!0, a);
        } finally{
            b ? $4bd4b160f282b4c6$var$S() : ($4bd4b160f282b4c6$var$N = !1, $4bd4b160f282b4c6$var$O = null);
        }
    } else $4bd4b160f282b4c6$var$N = !1;
}
var $4bd4b160f282b4c6$var$S;
if ("function" === typeof $4bd4b160f282b4c6$var$F) $4bd4b160f282b4c6$var$S = function() {
    $4bd4b160f282b4c6$var$F($4bd4b160f282b4c6$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $4bd4b160f282b4c6$var$T = new MessageChannel, $4bd4b160f282b4c6$var$U = $4bd4b160f282b4c6$var$T.port2;
    $4bd4b160f282b4c6$var$T.port1.onmessage = $4bd4b160f282b4c6$var$R;
    $4bd4b160f282b4c6$var$S = function() {
        $4bd4b160f282b4c6$var$U.postMessage(null);
    };
} else $4bd4b160f282b4c6$var$S = function() {
    $4bd4b160f282b4c6$var$D($4bd4b160f282b4c6$var$R, 0);
};
function $4bd4b160f282b4c6$var$I(a) {
    $4bd4b160f282b4c6$var$O = a;
    $4bd4b160f282b4c6$var$N || ($4bd4b160f282b4c6$var$N = !0, $4bd4b160f282b4c6$var$S());
}
function $4bd4b160f282b4c6$var$K(a, b) {
    $4bd4b160f282b4c6$var$L = $4bd4b160f282b4c6$var$D(function() {
        a($4bd4b160f282b4c6$export$c4744153514ff05d());
    }, b);
}
$4bd4b160f282b4c6$export$3e506c1ccc9cc1a7 = 5;
$4bd4b160f282b4c6$export$e26fe2ed2fa76875 = 1;
$4bd4b160f282b4c6$export$502329bbf4b505b1 = 4;
$4bd4b160f282b4c6$export$6e3807111c4874c4 = 3;
$4bd4b160f282b4c6$export$c27134553091fb3a = null;
$4bd4b160f282b4c6$export$33ee1acdc04fd2a2 = 2;
$4bd4b160f282b4c6$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$4bd4b160f282b4c6$export$8352ce38b91d0c62 = function() {
    $4bd4b160f282b4c6$var$A || $4bd4b160f282b4c6$var$z || ($4bd4b160f282b4c6$var$A = !0, $4bd4b160f282b4c6$var$I($4bd4b160f282b4c6$var$J));
};
$4bd4b160f282b4c6$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $4bd4b160f282b4c6$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$4bd4b160f282b4c6$export$d3dfb8e4810cb555 = function() {
    return $4bd4b160f282b4c6$var$y;
};
$4bd4b160f282b4c6$export$839f9183b0465a69 = function() {
    return $4bd4b160f282b4c6$var$h($4bd4b160f282b4c6$var$r);
};
$4bd4b160f282b4c6$export$72fdf0e06517287b = function(a) {
    switch($4bd4b160f282b4c6$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $4bd4b160f282b4c6$var$y;
    }
    var c = $4bd4b160f282b4c6$var$y;
    $4bd4b160f282b4c6$var$y = b;
    try {
        return a();
    } finally{
        $4bd4b160f282b4c6$var$y = c;
    }
};
$4bd4b160f282b4c6$export$4b844e58a3e414b4 = function() {};
$4bd4b160f282b4c6$export$816d2913ae6b83b1 = function() {};
$4bd4b160f282b4c6$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $4bd4b160f282b4c6$var$y;
    $4bd4b160f282b4c6$var$y = a;
    try {
        return b();
    } finally{
        $4bd4b160f282b4c6$var$y = c;
    }
};
$4bd4b160f282b4c6$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $4bd4b160f282b4c6$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $4bd4b160f282b4c6$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $4bd4b160f282b4c6$var$f($4bd4b160f282b4c6$var$t, a), null === $4bd4b160f282b4c6$var$h($4bd4b160f282b4c6$var$r) && a === $4bd4b160f282b4c6$var$h($4bd4b160f282b4c6$var$t) && ($4bd4b160f282b4c6$var$B ? ($4bd4b160f282b4c6$var$E($4bd4b160f282b4c6$var$L), $4bd4b160f282b4c6$var$L = -1) : $4bd4b160f282b4c6$var$B = !0, $4bd4b160f282b4c6$var$K($4bd4b160f282b4c6$var$H, c - d))) : (a.sortIndex = e, $4bd4b160f282b4c6$var$f($4bd4b160f282b4c6$var$r, a), $4bd4b160f282b4c6$var$A || $4bd4b160f282b4c6$var$z || ($4bd4b160f282b4c6$var$A = !0, $4bd4b160f282b4c6$var$I($4bd4b160f282b4c6$var$J)));
    return a;
};
$4bd4b160f282b4c6$export$b5836b71941fa3ed = $4bd4b160f282b4c6$var$M;
$4bd4b160f282b4c6$export$cf845f2c119da08a = function(a) {
    var b = $4bd4b160f282b4c6$var$y;
    return function() {
        var c = $4bd4b160f282b4c6$var$y;
        $4bd4b160f282b4c6$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $4bd4b160f282b4c6$var$y = c;
        }
    };
};

});



var $1b19c28e316f1f45$exports = {};
'use strict';

$1b19c28e316f1f45$exports = (parcelRequire("2gL4C"));


parcelRequire("7K7RB");
var $230a54606033faee$export$882461b6382ed46c;
var $230a54606033faee$export$757ceba2d55c277e;
'use strict';
var $9828203bfeafb7fc$exports = {};
'use strict';
function $9828203bfeafb7fc$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9828203bfeafb7fc$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9828203bfeafb7fc$var$checkDCE();

$9828203bfeafb7fc$exports = (parcelRequire("36IZB"));


var $230a54606033faee$var$i;
$230a54606033faee$export$882461b6382ed46c = $9828203bfeafb7fc$exports.createRoot;
$230a54606033faee$export$757ceba2d55c277e = $9828203bfeafb7fc$exports.hydrateRoot;




var $7K7RB = parcelRequire("7K7RB");


var $7K7RB = parcelRequire("7K7RB");
/** Generated from config/web-app-version at image build. */ const $d27d8a753b6b0dc7$export$2d14b6c4c4fbcd8f = "7";


function $f06c00e1b618c2d8$export$a2b3065b9188b50a() {
    if (typeof window === 'undefined') return '';
    return window.location.pathname === '/dev' || window.location.pathname.startsWith('/dev/') ? '/dev' : '';
}
const $f06c00e1b618c2d8$var$WEB_APP_VERSION_HEADER = 'X-Riddler-Web-App-Version';
const $f06c00e1b618c2d8$var$WEB_APP_RELOAD_KEY = 'riddler_web_version_reload';
function $f06c00e1b618c2d8$export$39ae6b9c5db76154(response) {
    if (typeof window === 'undefined' || !response?.headers?.get) return;
    const expected = (response.headers.get($f06c00e1b618c2d8$var$WEB_APP_VERSION_HEADER) || '').trim();
    if (!expected) return;
    if (expected === (0, $d27d8a753b6b0dc7$export$2d14b6c4c4fbcd8f)) {
        try {
            sessionStorage.removeItem($f06c00e1b618c2d8$var$WEB_APP_RELOAD_KEY);
        } catch  {
        /* ignore */ }
        return;
    }
    let alreadyTried = null;
    try {
        alreadyTried = sessionStorage.getItem($f06c00e1b618c2d8$var$WEB_APP_RELOAD_KEY);
    } catch  {
        alreadyTried = null;
    }
    if (alreadyTried === expected) return;
    try {
        sessionStorage.setItem($f06c00e1b618c2d8$var$WEB_APP_RELOAD_KEY, expected);
    } catch  {
    /* ignore */ }
    window.location.reload();
}
function $f06c00e1b618c2d8$export$e06e23d45d0add48() {
    if (typeof window === 'undefined') return false;
    const host = window.location.hostname;
    return host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
}
function $f06c00e1b618c2d8$export$b2bdec05e4a3fb3e(envName) {
    return $f06c00e1b618c2d8$export$e06e23d45d0add48() || Boolean($f06c00e1b618c2d8$export$a2b3065b9188b50a()) || envName === 'dev';
}
function $f06c00e1b618c2d8$export$54c2ba5a02b4cf87() {
    return `${$f06c00e1b618c2d8$export$a2b3065b9188b50a()}/api/v1`;
}
const $f06c00e1b618c2d8$var$AUTH_FAILURE_EVENT = 'riddler:auth-failure';
function $f06c00e1b618c2d8$export$6412e56640736d7b(detail) {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent($f06c00e1b618c2d8$var$AUTH_FAILURE_EVENT, {
        detail: detail || 'Not authenticated'
    }));
}
function $f06c00e1b618c2d8$export$f0f3afeffe711d31(handler) {
    if (typeof window === 'undefined') return ()=>{};
    const listener = (event)=>handler(event?.detail);
    window.addEventListener($f06c00e1b618c2d8$var$AUTH_FAILURE_EVENT, listener);
    return ()=>window.removeEventListener($f06c00e1b618c2d8$var$AUTH_FAILURE_EVENT, listener);
}
function $f06c00e1b618c2d8$var$ReadToken() {
    if (typeof localStorage === 'undefined') return null;
    return localStorage.getItem('riddler_token');
}
function $f06c00e1b618c2d8$var$PersistToken(accessToken) {
    if (accessToken) localStorage.setItem('riddler_token', accessToken);
}
let $f06c00e1b618c2d8$var$refreshInFlight = null;
async function $f06c00e1b618c2d8$export$e29745dfda64d6b0() {
    const token = $f06c00e1b618c2d8$var$ReadToken();
    if (!token) return null;
    if ($f06c00e1b618c2d8$var$refreshInFlight) return $f06c00e1b618c2d8$var$refreshInFlight;
    $f06c00e1b618c2d8$var$refreshInFlight = (async ()=>{
        const response = await fetch(`${$f06c00e1b618c2d8$export$54c2ba5a02b4cf87()}/auth/refresh`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        });
        $f06c00e1b618c2d8$export$39ae6b9c5db76154(response);
        if (!response.ok) return null;
        const data = await response.json().catch(()=>null);
        if (!data?.access_token) return null;
        $f06c00e1b618c2d8$var$PersistToken(data.access_token);
        return data;
    })().finally(()=>{
        $f06c00e1b618c2d8$var$refreshInFlight = null;
    });
    return $f06c00e1b618c2d8$var$refreshInFlight;
}
async function $f06c00e1b618c2d8$export$2326914acec6fbba(path, options = {}) {
    const token = $f06c00e1b618c2d8$var$ReadToken();
    const headers = {
        'Content-Type': 'application/json',
        ...options.headers || {}
    };
    if (token) headers.Authorization = `Bearer ${token}`;
    const response = await fetch(`${$f06c00e1b618c2d8$export$54c2ba5a02b4cf87()}${path}`, {
        ...options,
        headers: headers
    });
    $f06c00e1b618c2d8$export$39ae6b9c5db76154(response);
    let data = null;
    const text = await response.text();
    if (text) try {
        data = JSON.parse(text);
    } catch  {
        data = {
            detail: text
        };
    }
    if (response.status === 401) {
        const detail = typeof data?.detail === 'string' ? data.detail : 'Not authenticated';
        const isCredentialCall = path.startsWith('/auth/login') || path.startsWith('/auth/register') || path.startsWith('/auth/allocate-username');
        if (!isCredentialCall) {
            const canTryRefresh = Boolean(token) && !options._authRetry;
            if (canTryRefresh) {
                const refreshed = await $f06c00e1b618c2d8$export$e29745dfda64d6b0();
                if (refreshed?.access_token) return $f06c00e1b618c2d8$export$2326914acec6fbba(path, {
                    ...options,
                    _authRetry: true
                });
            }
            $f06c00e1b618c2d8$export$6412e56640736d7b(detail);
        }
        throw new Error(detail);
    }
    if (!response.ok) {
        const detail = data?.detail;
        const message = typeof detail === 'string' ? detail : Array.isArray(detail) ? detail.map((d)=>d.msg || JSON.stringify(d)).join(', ') : `Request failed (${response.status})`;
        throw new Error(message);
    }
    return data;
}
async function $f06c00e1b618c2d8$export$c85a396169429cad(path, { body: body, onEvent: onEvent, _authRetry: _authRetry = false } = {}) {
    const token = $f06c00e1b618c2d8$var$ReadToken();
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'text/event-stream'
    };
    if (token) headers.Authorization = `Bearer ${token}`;
    const response = await fetch(`${$f06c00e1b618c2d8$export$54c2ba5a02b4cf87()}${path}`, {
        method: 'POST',
        headers: headers,
        body: typeof body === 'string' ? body : JSON.stringify(body ?? {})
    });
    $f06c00e1b618c2d8$export$39ae6b9c5db76154(response);
    if (response.status === 401) {
        const detail = 'Not authenticated';
        const canTryRefresh = Boolean(token) && !_authRetry;
        if (canTryRefresh) {
            const refreshed = await $f06c00e1b618c2d8$export$e29745dfda64d6b0();
            if (refreshed?.access_token) return $f06c00e1b618c2d8$export$c85a396169429cad(path, {
                body: body,
                onEvent: onEvent,
                _authRetry: true
            });
        }
        $f06c00e1b618c2d8$export$6412e56640736d7b(detail);
        throw new Error(detail);
    }
    if (!response.ok) {
        let data = null;
        const text = await response.text();
        if (text) try {
            data = JSON.parse(text);
        } catch  {
            data = {
                detail: text
            };
        }
        const detail = data?.detail;
        const message = typeof detail === 'string' ? detail : Array.isArray(detail) ? detail.map((d)=>d.msg || JSON.stringify(d)).join(', ') : `Request failed (${response.status})`;
        throw new Error(message);
    }
    if (!response.body) throw new Error('Stream unavailable');
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let donePayload = null;
    while(true){
        const { done: done, value: value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, {
            stream: true
        });
        const chunks = buffer.split('\n\n');
        buffer = chunks.pop() || '';
        chunks.forEach((chunk)=>{
            const lines = chunk.split('\n');
            const dataLine = lines.find((line)=>line.startsWith('data:'));
            if (!dataLine) return;
            const raw = dataLine.slice(5).trim();
            if (!raw || raw === '[DONE]') return;
            let event;
            try {
                event = JSON.parse(raw);
            } catch  {
                return;
            }
            if (event?.type === 'done') donePayload = event;
            if (event?.type === 'error') throw new Error(typeof event.detail === 'string' ? event.detail : 'Stream failed');
            if (typeof onEvent === 'function') onEvent(event);
        });
    }
    return donePayload;
}



function $9cb8443fe4694d7b$var$UrlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; i += 1)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
}
function $9cb8443fe4694d7b$var$Uint8ArraysEqual(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for(let i = 0; i < a.length; i += 1){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $9cb8443fe4694d7b$var$SubscriptionMatchesVapid(subscription, vapidPublicKey) {
    const key = subscription?.options?.applicationServerKey;
    if (!key) return true;
    return $9cb8443fe4694d7b$var$Uint8ArraysEqual(new Uint8Array(key), $9cb8443fe4694d7b$var$UrlBase64ToUint8Array(vapidPublicKey));
}
function $9cb8443fe4694d7b$export$f951eecc1ff65a0a() {
    const prefix = (0, $f06c00e1b618c2d8$export$a2b3065b9188b50a)();
    return `${prefix}/chat` || '/chat';
}
function $9cb8443fe4694d7b$export$768b3b73588437cb() {
    return typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}
async function $9cb8443fe4694d7b$export$f3ff6e18ee6b1629() {
    if (!('serviceWorker' in navigator)) return null;
    const prefix = (0, $f06c00e1b618c2d8$export$a2b3065b9188b50a)();
    const swPath = `${prefix}/sw.js`;
    const registration = await navigator.serviceWorker.register(swPath, {
        scope: `${prefix}/` || '/'
    });
    await navigator.serviceWorker.ready;
    return registration;
}
function $9cb8443fe4694d7b$export$cebf4d0eadbf6f23({ title: title, body: body, tag: tag = 'riddler-funhouse' } = {}) {
    if (typeof document === 'undefined' || typeof window === 'undefined') return false;
    if (!document.hidden) return false;
    if (!('Notification' in window) || Notification.permission !== 'granted') return false;
    try {
        const note = new Notification(title || "Riddler's Funhouse", {
            body: body || '',
            tag: tag,
            renotify: true,
            icon: `${(0, $f06c00e1b618c2d8$export$a2b3065b9188b50a)()}/icon-192.png`
        });
        note.onclick = ()=>{
            window.focus();
            note.close();
        };
        return true;
    } catch  {
        return false;
    }
}
async function $9cb8443fe4694d7b$export$b3d460dbb760aac2() {
    if (!$9cb8443fe4694d7b$export$768b3b73588437cb()) return 'unsupported';
    if (Notification.permission === 'denied') return 'denied';
    if (Notification.permission === 'granted') try {
        const registration = await $9cb8443fe4694d7b$export$f3ff6e18ee6b1629();
        const sub = await registration?.pushManager?.getSubscription();
        return sub ? 'subscribed' : 'granted';
    } catch  {
        return 'granted';
    }
    return 'default';
}
async function $9cb8443fe4694d7b$export$be349678359e1b69({ sendTest: sendTest = false } = {}) {
    if (!$9cb8443fe4694d7b$export$768b3b73588437cb()) throw new Error('Push notifications are not supported in this browser');
    if (Notification.permission !== 'granted') throw new Error('Notification permission was not granted');
    const vapid = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/push/vapid-public-key');
    if (!vapid.configured || !vapid.public_key) throw new Error('Push is not configured on the server yet (missing VAPID keys)');
    const registration = await $9cb8443fe4694d7b$export$f3ff6e18ee6b1629();
    if (!registration?.pushManager) throw new Error('Push manager unavailable');
    let subscription = await registration.pushManager.getSubscription();
    if (subscription && !$9cb8443fe4694d7b$var$SubscriptionMatchesVapid(subscription, vapid.public_key)) {
        await subscription.unsubscribe();
        subscription = null;
    }
    if (!subscription) subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: $9cb8443fe4694d7b$var$UrlBase64ToUint8Array(vapid.public_key)
    });
    await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/push/subscribe', {
        method: 'POST',
        body: JSON.stringify({
            subscription: subscription.toJSON()
        })
    });
    if (sendTest) await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/push/test', {
        method: 'POST'
    });
    return subscription;
}
async function $9cb8443fe4694d7b$export$d28caf7ba2908246() {
    if (!$9cb8443fe4694d7b$export$768b3b73588437cb()) throw new Error('Push notifications are not supported in this browser');
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') throw new Error('Notification permission was not granted');
    return $9cb8443fe4694d7b$export$be349678359e1b69({
        sendTest: true
    });
}


const $1c591ca8e849d56b$var$AuthContext = /*#__PURE__*/ (0, $7K7RB.createContext)(null);
function $1c591ca8e849d56b$export$1d39dc5b47e56ff0() {
    const ctx = (0, $7K7RB.useContext)($1c591ca8e849d56b$var$AuthContext);
    if (!ctx) throw new Error('useAuth must be used within AuthProvider');
    return ctx;
}
function $1c591ca8e849d56b$export$87091915187a1a85({ children: children }) {
    const [user, setUser] = (0, $7K7RB.useState)(null);
    const [loading, setLoading] = (0, $7K7RB.useState)(true);
    const [error, setError] = (0, $7K7RB.useState)(null);
    const [testMode, setTestMode] = (0, $7K7RB.useState)(false);
    const [envName, setEnvName] = (0, $7K7RB.useState)(null);
    const ClearSession = ({ keepUsername: keepUsername = false } = {})=>{
        localStorage.removeItem('riddler_token');
        if (!keepUsername) localStorage.removeItem('riddler_username');
        setUser(null);
    };
    const GoAuth = ()=>{
        const prefix = (0, $f06c00e1b618c2d8$export$a2b3065b9188b50a)();
        window.location.assign(prefix ? `${prefix}/auth` : '/auth');
    };
    const GoHome = ()=>{
        const prefix = (0, $f06c00e1b618c2d8$export$a2b3065b9188b50a)();
        window.location.assign(prefix ? `${prefix}/` : '/');
    };
    (0, $7K7RB.useEffect)(()=>{
        (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/health').then((health)=>{
            setTestMode(Boolean(health?.test));
            if (health?.env) setEnvName(String(health.env));
        }).catch(()=>{
            setTestMode(false);
        });
        const token = localStorage.getItem('riddler_token');
        if (!token) {
            setLoading(false);
            return;
        }
        (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/auth/me').then((me)=>setUser(me)).catch(()=>{
            ClearSession({
                keepUsername: true
            });
        }).finally(()=>setLoading(false));
    }, []);
    // Force login if JWT is gone or rejected mid-session (covers "Not authenticated").
    (0, $7K7RB.useEffect)(()=>{
        const off = (0, $f06c00e1b618c2d8$export$f0f3afeffe711d31)(()=>{
            ClearSession({
                keepUsername: true
            });
            GoAuth();
        });
        return off;
    }, []);
    // Sliding refresh while the tab stays open (token is 72h; renew early anyway).
    (0, $7K7RB.useEffect)(()=>{
        if (!user) return undefined;
        const Tick = ()=>{
            (0, $f06c00e1b618c2d8$export$e29745dfda64d6b0)().catch(()=>{});
        };
        Tick();
        const id = window.setInterval(Tick, 1200000);
        return ()=>clearInterval(id);
    }, [
        user?.id
    ]);
    // Warm the service worker so Web Push can deliver while another tab is focused.
    (0, $7K7RB.useEffect)(()=>{
        if (!user) return undefined;
        (0, $9cb8443fe4694d7b$export$f3ff6e18ee6b1629)().catch(()=>{});
        return undefined;
    }, [
        user?.id
    ]);
    // Recover "user in React, token missing from storage" ghosts.
    (0, $7K7RB.useEffect)(()=>{
        if (!user) return undefined;
        const id = window.setInterval(()=>{
            if (!localStorage.getItem('riddler_token')) {
                ClearSession({
                    keepUsername: true
                });
                GoAuth();
            }
        }, 5000);
        return ()=>clearInterval(id);
    }, [
        user?.id
    ]);
    const PersistSession = (data)=>{
        localStorage.setItem('riddler_token', data.access_token);
        localStorage.setItem('riddler_username', data.user.username);
        setUser(data.user);
        setError(null);
        return data;
    };
    /** Adopt a JWT minted outside /auth/login (e.g. Edward gate) without a full reload. */ const AdoptToken = async (accessToken, usernameHint = '')=>{
        const token = String(accessToken || '').trim();
        if (!token) throw new Error('Missing session token');
        localStorage.setItem('riddler_token', token);
        if (usernameHint) localStorage.setItem('riddler_username', String(usernameHint).trim());
        const me = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/auth/me');
        setUser(me);
        setError(null);
        if (me?.username) localStorage.setItem('riddler_username', me.username);
        return me;
    };
    const register = async (pin, username, email)=>{
        setError(null);
        try {
            const data = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/auth/register', {
                method: 'POST',
                body: JSON.stringify({
                    pin: pin,
                    username: username,
                    email: email
                })
            });
            return PersistSession(data);
        } catch (err) {
            setError(err.message);
            throw err;
        }
    };
    const login = async (username, pin)=>{
        setError(null);
        try {
            const data = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/auth/login', {
                method: 'POST',
                body: JSON.stringify({
                    username: username,
                    pin: pin
                })
            });
            return PersistSession(data);
        } catch (err) {
            setError(err.message);
            throw err;
        }
    };
    const logout = ()=>{
        ClearSession({
            keepUsername: true
        });
    };
    const resetAccount = async ()=>{
        try {
            await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/auth/me', {
                method: 'DELETE'
            });
        } catch  {
        /* best-effort: still clear local session */ }
        ClearSession({
            keepUsername: false
        });
        GoHome();
    };
    const nukeAllUsers = async ()=>{
        await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/admin/nuke', {
            method: 'POST'
        });
        ClearSession({
            keepUsername: false
        });
        GoHome();
    };
    return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)($1c591ca8e849d56b$var$AuthContext.Provider, {
        value: {
            user: user,
            loading: loading,
            error: error,
            testMode: testMode,
            envName: envName,
            isDevEnv: (0, $f06c00e1b618c2d8$export$b2bdec05e4a3fb3e)(envName),
            register: register,
            login: login,
            AdoptToken: AdoptToken,
            logout: logout,
            resetAccount: resetAccount,
            nukeAllUsers: nukeAllUsers,
            setError: setError
        },
        children: children
    });
}




var $7K7RB = parcelRequire("7K7RB");
/**
 * React Router DOM v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7K7RB = parcelRequire("7K7RB");

/**
 * @remix-run/router v1.23.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $a3b197e5ed11632f$var$_extends() {
    return $a3b197e5ed11632f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a3b197e5ed11632f$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $a3b197e5ed11632f$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($a3b197e5ed11632f$export$e19cd5f9376f8cee || ($a3b197e5ed11632f$export$e19cd5f9376f8cee = {}));
const $a3b197e5ed11632f$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $a3b197e5ed11632f$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $a3b197e5ed11632f$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $a3b197e5ed11632f$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $a3b197e5ed11632f$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $a3b197e5ed11632f$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $a3b197e5ed11632f$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $a3b197e5ed11632f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $a3b197e5ed11632f$export$fe53371bee54353d(to);
    }
    return $a3b197e5ed11632f$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $a3b197e5ed11632f$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $a3b197e5ed11632f$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $a3b197e5ed11632f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $a3b197e5ed11632f$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $a3b197e5ed11632f$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $a3b197e5ed11632f$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $a3b197e5ed11632f$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $a3b197e5ed11632f$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $a3b197e5ed11632f$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $a3b197e5ed11632f$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $a3b197e5ed11632f$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $a3b197e5ed11632f$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $a3b197e5ed11632f$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $a3b197e5ed11632f$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $a3b197e5ed11632f$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $a3b197e5ed11632f$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $a3b197e5ed11632f$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($a3b197e5ed11632f$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Push;
        let location = $a3b197e5ed11632f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $a3b197e5ed11632f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Replace;
        let location = $a3b197e5ed11632f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $a3b197e5ed11632f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $a3b197e5ed11632f$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $a3b197e5ed11632f$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($a3b197e5ed11632f$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($a3b197e5ed11632f$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $a3b197e5ed11632f$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($a3b197e5ed11632f$var$ResultType || ($a3b197e5ed11632f$var$ResultType = {}));
const $a3b197e5ed11632f$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $a3b197e5ed11632f$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $a3b197e5ed11632f$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $a3b197e5ed11632f$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $a3b197e5ed11632f$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($a3b197e5ed11632f$var$isIndexRoute(route)) {
            let indexRoute = $a3b197e5ed11632f$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $a3b197e5ed11632f$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $a3b197e5ed11632f$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $a3b197e5ed11632f$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $a3b197e5ed11632f$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $a3b197e5ed11632f$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $a3b197e5ed11632f$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $a3b197e5ed11632f$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $a3b197e5ed11632f$var$flattenRoutes(routes);
    $a3b197e5ed11632f$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $a3b197e5ed11632f$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $a3b197e5ed11632f$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $a3b197e5ed11632f$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $a3b197e5ed11632f$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $a3b197e5ed11632f$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $a3b197e5ed11632f$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $a3b197e5ed11632f$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $a3b197e5ed11632f$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $a3b197e5ed11632f$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $a3b197e5ed11632f$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $a3b197e5ed11632f$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $a3b197e5ed11632f$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $a3b197e5ed11632f$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $a3b197e5ed11632f$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $a3b197e5ed11632f$var$paramRe = /^:[\w-]+$/;
const $a3b197e5ed11632f$var$dynamicSegmentValue = 3;
const $a3b197e5ed11632f$var$indexRouteValue = 2;
const $a3b197e5ed11632f$var$emptySegmentValue = 1;
const $a3b197e5ed11632f$var$staticSegmentValue = 10;
const $a3b197e5ed11632f$var$splatPenalty = -2;
const $a3b197e5ed11632f$var$isSplat = (s)=>s === "*";
function $a3b197e5ed11632f$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($a3b197e5ed11632f$var$isSplat)) initialScore += $a3b197e5ed11632f$var$splatPenalty;
    if (index) initialScore += $a3b197e5ed11632f$var$indexRouteValue;
    return segments.filter((s)=>!$a3b197e5ed11632f$var$isSplat(s)).reduce((score, segment)=>score + ($a3b197e5ed11632f$var$paramRe.test(segment) ? $a3b197e5ed11632f$var$dynamicSegmentValue : segment === "" ? $a3b197e5ed11632f$var$emptySegmentValue : $a3b197e5ed11632f$var$staticSegmentValue), initialScore);
}
function $a3b197e5ed11632f$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $a3b197e5ed11632f$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $a3b197e5ed11632f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $a3b197e5ed11632f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $a3b197e5ed11632f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $a3b197e5ed11632f$export$a5c6d149b50c1d86($a3b197e5ed11632f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $a3b197e5ed11632f$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $a3b197e5ed11632f$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $a3b197e5ed11632f$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $a3b197e5ed11632f$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $a3b197e5ed11632f$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $a3b197e5ed11632f$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $a3b197e5ed11632f$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $a3b197e5ed11632f$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $a3b197e5ed11632f$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $a3b197e5ed11632f$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $a3b197e5ed11632f$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $a3b197e5ed11632f$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $a3b197e5ed11632f$var$isAbsoluteUrl = (url)=>$a3b197e5ed11632f$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $a3b197e5ed11632f$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $a3b197e5ed11632f$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($a3b197e5ed11632f$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = $a3b197e5ed11632f$var$removeDoubleSlashes(toPathname);
                $a3b197e5ed11632f$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $a3b197e5ed11632f$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $a3b197e5ed11632f$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $a3b197e5ed11632f$var$normalizeSearch(search),
        hash: $a3b197e5ed11632f$var$normalizeHash(hash)
    };
}
function $a3b197e5ed11632f$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $a3b197e5ed11632f$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $a3b197e5ed11632f$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $a3b197e5ed11632f$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $a3b197e5ed11632f$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $a3b197e5ed11632f$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $a3b197e5ed11632f$export$8ccf933b0513f8d0(toArg);
    else {
        to = $a3b197e5ed11632f$var$_extends({}, toArg);
        $a3b197e5ed11632f$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $a3b197e5ed11632f$var$getInvalidPathError("?", "pathname", "search", to));
        $a3b197e5ed11632f$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $a3b197e5ed11632f$var$getInvalidPathError("#", "pathname", "hash", to));
        $a3b197e5ed11632f$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $a3b197e5ed11632f$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $a3b197e5ed11632f$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $a3b197e5ed11632f$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $a3b197e5ed11632f$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $a3b197e5ed11632f$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $a3b197e5ed11632f$export$86d9a7913e44197e = (paths)=>$a3b197e5ed11632f$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $a3b197e5ed11632f$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $a3b197e5ed11632f$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $a3b197e5ed11632f$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $a3b197e5ed11632f$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $a3b197e5ed11632f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $a3b197e5ed11632f$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $a3b197e5ed11632f$export$4051a07651545597(data, init) {
    return new $a3b197e5ed11632f$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $a3b197e5ed11632f$export$42a99a7a4bc0e76a extends Error {
}
class $a3b197e5ed11632f$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $a3b197e5ed11632f$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $a3b197e5ed11632f$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $a3b197e5ed11632f$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $a3b197e5ed11632f$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $a3b197e5ed11632f$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $a3b197e5ed11632f$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $a3b197e5ed11632f$var$unwrapTrackedPromise(value) {
    if (!$a3b197e5ed11632f$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $a3b197e5ed11632f$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $a3b197e5ed11632f$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a3b197e5ed11632f$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $a3b197e5ed11632f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a3b197e5ed11632f$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $a3b197e5ed11632f$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a3b197e5ed11632f$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $a3b197e5ed11632f$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $a3b197e5ed11632f$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $a3b197e5ed11632f$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $a3b197e5ed11632f$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $a3b197e5ed11632f$var$validMutationMethods = new Set($a3b197e5ed11632f$var$validMutationMethodsArr);
const $a3b197e5ed11632f$var$validRequestMethodsArr = [
    "get",
    ...$a3b197e5ed11632f$var$validMutationMethodsArr
];
const $a3b197e5ed11632f$var$validRequestMethods = new Set($a3b197e5ed11632f$var$validRequestMethodsArr);
const $a3b197e5ed11632f$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $a3b197e5ed11632f$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $a3b197e5ed11632f$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a3b197e5ed11632f$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $a3b197e5ed11632f$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $a3b197e5ed11632f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $a3b197e5ed11632f$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $a3b197e5ed11632f$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $a3b197e5ed11632f$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $a3b197e5ed11632f$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a3b197e5ed11632f$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $a3b197e5ed11632f$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $a3b197e5ed11632f$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $a3b197e5ed11632f$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $a3b197e5ed11632f$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $a3b197e5ed11632f$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $a3b197e5ed11632f$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$a3b197e5ed11632f$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$a3b197e5ed11632f$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $a3b197e5ed11632f$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $a3b197e5ed11632f$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $a3b197e5ed11632f$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $a3b197e5ed11632f$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$a3b197e5ed11632f$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($a3b197e5ed11632f$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $a3b197e5ed11632f$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $a3b197e5ed11632f$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $a3b197e5ed11632f$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $a3b197e5ed11632f$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $a3b197e5ed11632f$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $a3b197e5ed11632f$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $a3b197e5ed11632f$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $a3b197e5ed11632f$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $a3b197e5ed11632f$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($a3b197e5ed11632f$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $a3b197e5ed11632f$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $a3b197e5ed11632f$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $a3b197e5ed11632f$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $a3b197e5ed11632f$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $a3b197e5ed11632f$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $a3b197e5ed11632f$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $a3b197e5ed11632f$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $a3b197e5ed11632f$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $a3b197e5ed11632f$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $a3b197e5ed11632f$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $a3b197e5ed11632f$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $a3b197e5ed11632f$var$findNearestBoundary(matches).route.id,
            {
                type: $a3b197e5ed11632f$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $a3b197e5ed11632f$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($a3b197e5ed11632f$var$isErrorResult(result) && $a3b197e5ed11632f$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $a3b197e5ed11632f$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $a3b197e5ed11632f$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $a3b197e5ed11632f$var$_extends({
            matches: updatedMatches || matches
        }, $a3b197e5ed11632f$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $a3b197e5ed11632f$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $a3b197e5ed11632f$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $a3b197e5ed11632f$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $a3b197e5ed11632f$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $a3b197e5ed11632f$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $a3b197e5ed11632f$var$ResultType.error,
            error: $a3b197e5ed11632f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($a3b197e5ed11632f$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $a3b197e5ed11632f$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($a3b197e5ed11632f$var$isDeferredResult(result)) throw $a3b197e5ed11632f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($a3b197e5ed11632f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $a3b197e5ed11632f$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $a3b197e5ed11632f$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $a3b197e5ed11632f$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $a3b197e5ed11632f$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($a3b197e5ed11632f$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $a3b197e5ed11632f$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $a3b197e5ed11632f$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $a3b197e5ed11632f$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $a3b197e5ed11632f$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $a3b197e5ed11632f$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $a3b197e5ed11632f$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $a3b197e5ed11632f$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a3b197e5ed11632f$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $a3b197e5ed11632f$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $a3b197e5ed11632f$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$a3b197e5ed11632f$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $a3b197e5ed11632f$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $a3b197e5ed11632f$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $a3b197e5ed11632f$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $a3b197e5ed11632f$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $a3b197e5ed11632f$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $a3b197e5ed11632f$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $a3b197e5ed11632f$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $a3b197e5ed11632f$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a3b197e5ed11632f$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $a3b197e5ed11632f$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a3b197e5ed11632f$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $a3b197e5ed11632f$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($a3b197e5ed11632f$var$isRedirectResult(actionResult) || $a3b197e5ed11632f$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $a3b197e5ed11632f$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($a3b197e5ed11632f$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $a3b197e5ed11632f$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $a3b197e5ed11632f$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($a3b197e5ed11632f$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($a3b197e5ed11632f$var$isDeferredResult(actionResult)) throw $a3b197e5ed11632f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $a3b197e5ed11632f$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $a3b197e5ed11632f$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $a3b197e5ed11632f$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $a3b197e5ed11632f$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $a3b197e5ed11632f$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $a3b197e5ed11632f$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $a3b197e5ed11632f$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $a3b197e5ed11632f$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a3b197e5ed11632f$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $a3b197e5ed11632f$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $a3b197e5ed11632f$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $a3b197e5ed11632f$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $a3b197e5ed11632f$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $a3b197e5ed11632f$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $a3b197e5ed11632f$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $a3b197e5ed11632f$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($a3b197e5ed11632f$var$isDeferredResult(result)) result = await $a3b197e5ed11632f$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $a3b197e5ed11632f$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($a3b197e5ed11632f$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $a3b197e5ed11632f$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($a3b197e5ed11632f$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $a3b197e5ed11632f$export$3e9cee6b33872309(!$a3b197e5ed11632f$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $a3b197e5ed11632f$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $a3b197e5ed11632f$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $a3b197e5ed11632f$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $a3b197e5ed11632f$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($a3b197e5ed11632f$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $a3b197e5ed11632f$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $a3b197e5ed11632f$export$e19cd5f9376f8cee.Replace : $a3b197e5ed11632f$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $a3b197e5ed11632f$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($a3b197e5ed11632f$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $a3b197e5ed11632f$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $a3b197e5ed11632f$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $a3b197e5ed11632f$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $a3b197e5ed11632f$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $a3b197e5ed11632f$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($a3b197e5ed11632f$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $a3b197e5ed11632f$var$ResultType.redirect,
                response: $a3b197e5ed11632f$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $a3b197e5ed11632f$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $a3b197e5ed11632f$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $a3b197e5ed11632f$var$ResultType.error,
                    error: $a3b197e5ed11632f$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $a3b197e5ed11632f$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $a3b197e5ed11632f$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $a3b197e5ed11632f$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $a3b197e5ed11632f$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $a3b197e5ed11632f$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $a3b197e5ed11632f$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $a3b197e5ed11632f$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $a3b197e5ed11632f$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $a3b197e5ed11632f$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $a3b197e5ed11632f$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $a3b197e5ed11632f$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $a3b197e5ed11632f$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $a3b197e5ed11632f$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $a3b197e5ed11632f$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$a3b197e5ed11632f$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $a3b197e5ed11632f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $a3b197e5ed11632f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $a3b197e5ed11632f$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $a3b197e5ed11632f$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $a3b197e5ed11632f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $a3b197e5ed11632f$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $a3b197e5ed11632f$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $a3b197e5ed11632f$export$4d0306f8f6a4585b = Symbol("deferred");
function $a3b197e5ed11632f$export$3336b097a6fbc59a(routes, opts) {
    $a3b197e5ed11632f$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a3b197e5ed11632f$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $a3b197e5ed11632f$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $a3b197e5ed11632f$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a3b197e5ed11632f$var$createLocation("", $a3b197e5ed11632f$export$fe53371bee54353d(url), null, "default");
        let matches = $a3b197e5ed11632f$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a3b197e5ed11632f$var$isValidMethod(method) && method !== "HEAD") {
            let error = $a3b197e5ed11632f$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $a3b197e5ed11632f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $a3b197e5ed11632f$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $a3b197e5ed11632f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($a3b197e5ed11632f$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $a3b197e5ed11632f$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a3b197e5ed11632f$var$createLocation("", $a3b197e5ed11632f$export$fe53371bee54353d(url), null, "default");
        let matches = $a3b197e5ed11632f$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$a3b197e5ed11632f$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $a3b197e5ed11632f$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $a3b197e5ed11632f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $a3b197e5ed11632f$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $a3b197e5ed11632f$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $a3b197e5ed11632f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($a3b197e5ed11632f$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$a3b197e5ed11632f$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $a3b197e5ed11632f$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($a3b197e5ed11632f$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $a3b197e5ed11632f$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $a3b197e5ed11632f$var$isResponse(result) ? result : $a3b197e5ed11632f$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($a3b197e5ed11632f$var$isDataStrategyResult(e) && $a3b197e5ed11632f$var$isResponse(e.result)) {
                if (e.type === $a3b197e5ed11632f$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($a3b197e5ed11632f$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $a3b197e5ed11632f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a3b197e5ed11632f$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $a3b197e5ed11632f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($a3b197e5ed11632f$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($a3b197e5ed11632f$var$isDeferredResult(result)) {
            let error = $a3b197e5ed11632f$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a3b197e5ed11632f$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($a3b197e5ed11632f$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($a3b197e5ed11632f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $a3b197e5ed11632f$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $a3b197e5ed11632f$var$_extends({}, context, {
                statusCode: $a3b197e5ed11632f$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $a3b197e5ed11632f$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $a3b197e5ed11632f$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $a3b197e5ed11632f$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $a3b197e5ed11632f$var$isErrorResult(pendingActionResult[1]) ? $a3b197e5ed11632f$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $a3b197e5ed11632f$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $a3b197e5ed11632f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $a3b197e5ed11632f$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $a3b197e5ed11632f$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $a3b197e5ed11632f$var$callDataStrategyImpl(dataStrategy || $a3b197e5ed11632f$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($a3b197e5ed11632f$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $a3b197e5ed11632f$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($a3b197e5ed11632f$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $a3b197e5ed11632f$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $a3b197e5ed11632f$export$fec11da027c70692(routes, context, error) {
    let newContext = $a3b197e5ed11632f$var$_extends({}, context, {
        statusCode: $a3b197e5ed11632f$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $a3b197e5ed11632f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $a3b197e5ed11632f$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $a3b197e5ed11632f$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $a3b197e5ed11632f$export$cae722b0cc860f13(to ? to : ".", $a3b197e5ed11632f$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $a3b197e5ed11632f$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $a3b197e5ed11632f$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $a3b197e5ed11632f$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $a3b197e5ed11632f$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $a3b197e5ed11632f$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$a3b197e5ed11632f$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$a3b197e5ed11632f$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $a3b197e5ed11632f$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $a3b197e5ed11632f$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $a3b197e5ed11632f$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$a3b197e5ed11632f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$a3b197e5ed11632f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $a3b197e5ed11632f$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $a3b197e5ed11632f$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $a3b197e5ed11632f$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $a3b197e5ed11632f$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $a3b197e5ed11632f$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($a3b197e5ed11632f$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $a3b197e5ed11632f$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $a3b197e5ed11632f$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $a3b197e5ed11632f$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $a3b197e5ed11632f$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $a3b197e5ed11632f$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $a3b197e5ed11632f$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $a3b197e5ed11632f$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $a3b197e5ed11632f$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $a3b197e5ed11632f$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $a3b197e5ed11632f$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($a3b197e5ed11632f$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $a3b197e5ed11632f$var$shouldRevalidateLoader(match, $a3b197e5ed11632f$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $a3b197e5ed11632f$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $a3b197e5ed11632f$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $a3b197e5ed11632f$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $a3b197e5ed11632f$var$shouldRevalidateLoader(fetcherMatch, $a3b197e5ed11632f$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $a3b197e5ed11632f$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $a3b197e5ed11632f$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $a3b197e5ed11632f$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $a3b197e5ed11632f$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $a3b197e5ed11632f$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $a3b197e5ed11632f$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$a3b197e5ed11632f$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $a3b197e5ed11632f$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $a3b197e5ed11632f$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$a3b197e5ed11632f$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $a3b197e5ed11632f$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $a3b197e5ed11632f$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $a3b197e5ed11632f$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$a3b197e5ed11632f$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $a3b197e5ed11632f$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $a3b197e5ed11632f$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $a3b197e5ed11632f$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $a3b197e5ed11632f$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $a3b197e5ed11632f$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $a3b197e5ed11632f$var$ResultType.data,
                result: undefined
            });
        };
        return $a3b197e5ed11632f$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $a3b197e5ed11632f$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $a3b197e5ed11632f$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $a3b197e5ed11632f$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $a3b197e5ed11632f$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $a3b197e5ed11632f$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $a3b197e5ed11632f$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $a3b197e5ed11632f$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($a3b197e5ed11632f$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $a3b197e5ed11632f$var$ResultType.error,
                error: e
            };
        }
        if (type === $a3b197e5ed11632f$var$ResultType.error) return {
            type: $a3b197e5ed11632f$var$ResultType.error,
            error: new $a3b197e5ed11632f$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $a3b197e5ed11632f$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $a3b197e5ed11632f$var$ResultType.error) {
        if ($a3b197e5ed11632f$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $a3b197e5ed11632f$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $a3b197e5ed11632f$var$ResultType.error,
                error: new $a3b197e5ed11632f$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $a3b197e5ed11632f$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $a3b197e5ed11632f$var$ResultType.error,
            error: result,
            statusCode: $a3b197e5ed11632f$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($a3b197e5ed11632f$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $a3b197e5ed11632f$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($a3b197e5ed11632f$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $a3b197e5ed11632f$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $a3b197e5ed11632f$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $a3b197e5ed11632f$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $a3b197e5ed11632f$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$a3b197e5ed11632f$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $a3b197e5ed11632f$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $a3b197e5ed11632f$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($a3b197e5ed11632f$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $a3b197e5ed11632f$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $a3b197e5ed11632f$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $a3b197e5ed11632f$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($a3b197e5ed11632f$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $a3b197e5ed11632f$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $a3b197e5ed11632f$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $a3b197e5ed11632f$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $a3b197e5ed11632f$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $a3b197e5ed11632f$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $a3b197e5ed11632f$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $a3b197e5ed11632f$export$3e9cee6b33872309(!$a3b197e5ed11632f$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($a3b197e5ed11632f$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $a3b197e5ed11632f$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $a3b197e5ed11632f$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($a3b197e5ed11632f$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $a3b197e5ed11632f$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $a3b197e5ed11632f$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $a3b197e5ed11632f$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($a3b197e5ed11632f$var$isErrorResult(result)) {
            let boundaryMatch = $a3b197e5ed11632f$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $a3b197e5ed11632f$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($a3b197e5ed11632f$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $a3b197e5ed11632f$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($a3b197e5ed11632f$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $a3b197e5ed11632f$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $a3b197e5ed11632f$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $a3b197e5ed11632f$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $a3b197e5ed11632f$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $a3b197e5ed11632f$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $a3b197e5ed11632f$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $a3b197e5ed11632f$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $a3b197e5ed11632f$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $a3b197e5ed11632f$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $a3b197e5ed11632f$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $a3b197e5ed11632f$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($a3b197e5ed11632f$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $a3b197e5ed11632f$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $a3b197e5ed11632f$export$8ccf933b0513f8d0(path) : path;
    return $a3b197e5ed11632f$export$fe53371bee54353d($a3b197e5ed11632f$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $a3b197e5ed11632f$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $a3b197e5ed11632f$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $a3b197e5ed11632f$var$ResultType.data || result.type === $a3b197e5ed11632f$var$ResultType.error);
}
function $a3b197e5ed11632f$var$isRedirectDataStrategyResultResult(result) {
    return $a3b197e5ed11632f$var$isResponse(result.result) && $a3b197e5ed11632f$var$redirectStatusCodes.has(result.result.status);
}
function $a3b197e5ed11632f$var$isDeferredResult(result) {
    return result.type === $a3b197e5ed11632f$var$ResultType.deferred;
}
function $a3b197e5ed11632f$var$isErrorResult(result) {
    return result.type === $a3b197e5ed11632f$var$ResultType.error;
}
function $a3b197e5ed11632f$var$isRedirectResult(result) {
    return (result && result.type) === $a3b197e5ed11632f$var$ResultType.redirect;
}
function $a3b197e5ed11632f$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $a3b197e5ed11632f$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $a3b197e5ed11632f$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $a3b197e5ed11632f$var$isRedirectResponse(result) {
    if (!$a3b197e5ed11632f$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $a3b197e5ed11632f$var$isValidMethod(method) {
    return $a3b197e5ed11632f$var$validRequestMethods.has(method.toLowerCase());
}
function $a3b197e5ed11632f$var$isMutationMethod(method) {
    return $a3b197e5ed11632f$var$validMutationMethods.has(method.toLowerCase());
}
async function $a3b197e5ed11632f$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$a3b197e5ed11632f$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($a3b197e5ed11632f$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $a3b197e5ed11632f$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $a3b197e5ed11632f$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($a3b197e5ed11632f$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $a3b197e5ed11632f$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $a3b197e5ed11632f$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $a3b197e5ed11632f$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $a3b197e5ed11632f$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $a3b197e5ed11632f$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $a3b197e5ed11632f$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $a3b197e5ed11632f$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $a3b197e5ed11632f$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $a3b197e5ed11632f$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $a3b197e5ed11632f$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $a3b197e5ed11632f$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $a3b197e5ed11632f$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $a3b197e5ed11632f$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $a3b197e5ed11632f$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $a3b197e5ed11632f$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $a3b197e5ed11632f$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $a3b197e5ed11632f$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $a3b197e5ed11632f$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($a3b197e5ed11632f$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $a3b197e5ed11632f$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($a3b197e5ed11632f$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $a3b197e5ed11632f$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7K7RB = parcelRequire("7K7RB");

function $efbd7c66e1977cc3$var$_extends() {
    return $efbd7c66e1977cc3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $efbd7c66e1977cc3$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $efbd7c66e1977cc3$export$3add0d5dce533e2e = /*#__PURE__*/ $7K7RB.createContext(null);
const $efbd7c66e1977cc3$export$145dfa71566a64dc = /*#__PURE__*/ $7K7RB.createContext(null);
const $efbd7c66e1977cc3$var$AwaitContext = /*#__PURE__*/ $7K7RB.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $efbd7c66e1977cc3$export$26749e8557646306 = /*#__PURE__*/ $7K7RB.createContext(null);
const $efbd7c66e1977cc3$export$c7914228fb69b0f5 = /*#__PURE__*/ $7K7RB.createContext(null);
const $efbd7c66e1977cc3$export$9072aa6dd1f93057 = /*#__PURE__*/ $7K7RB.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $efbd7c66e1977cc3$var$RouteErrorContext = /*#__PURE__*/ $7K7RB.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $efbd7c66e1977cc3$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$efbd7c66e1977cc3$export$9c954a9d03d32f4a() && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $7K7RB.useContext($efbd7c66e1977cc3$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $efbd7c66e1977cc3$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $a3b197e5ed11632f$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $efbd7c66e1977cc3$export$9c954a9d03d32f4a() {
    return $7K7RB.useContext($efbd7c66e1977cc3$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $efbd7c66e1977cc3$export$45d76561a5302f2b() {
    !$efbd7c66e1977cc3$export$9c954a9d03d32f4a() && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    return $7K7RB.useContext($efbd7c66e1977cc3$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $efbd7c66e1977cc3$export$1b3f31771c5d07c() {
    return $7K7RB.useContext($efbd7c66e1977cc3$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $efbd7c66e1977cc3$export$6c330e8992e8a295(pattern) {
    !$efbd7c66e1977cc3$export$9c954a9d03d32f4a() && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $efbd7c66e1977cc3$export$45d76561a5302f2b();
    return $7K7RB.useMemo(()=>(0, $a3b197e5ed11632f$export$81336c211d5ff295)(pattern, (0, $a3b197e5ed11632f$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $efbd7c66e1977cc3$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $efbd7c66e1977cc3$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7K7RB.useContext($efbd7c66e1977cc3$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7K7RB.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $efbd7c66e1977cc3$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7K7RB.useContext($efbd7c66e1977cc3$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $efbd7c66e1977cc3$var$useNavigateStable() : $efbd7c66e1977cc3$var$useNavigateUnstable();
}
function $efbd7c66e1977cc3$var$useNavigateUnstable() {
    !$efbd7c66e1977cc3$export$9c954a9d03d32f4a() && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    let dataRouterContext = $7K7RB.useContext($efbd7c66e1977cc3$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $7K7RB.useContext($efbd7c66e1977cc3$export$26749e8557646306);
    let { matches: matches } = $7K7RB.useContext($efbd7c66e1977cc3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $efbd7c66e1977cc3$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a3b197e5ed11632f$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $7K7RB.useRef(false);
    $efbd7c66e1977cc3$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7K7RB.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $a3b197e5ed11632f$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a3b197e5ed11632f$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $efbd7c66e1977cc3$var$OutletContext = /*#__PURE__*/ $7K7RB.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $efbd7c66e1977cc3$export$4138103a3ae699cc() {
    return $7K7RB.useContext($efbd7c66e1977cc3$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $efbd7c66e1977cc3$export$a3be3530d8e40d0b(context) {
    let outlet = $7K7RB.useContext($efbd7c66e1977cc3$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $efbd7c66e1977cc3$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7K7RB.useContext($efbd7c66e1977cc3$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $efbd7c66e1977cc3$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $7K7RB.useContext($efbd7c66e1977cc3$export$26749e8557646306);
    let { matches: matches } = $7K7RB.useContext($efbd7c66e1977cc3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $efbd7c66e1977cc3$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a3b197e5ed11632f$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $7K7RB.useMemo(()=>(0, $a3b197e5ed11632f$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $efbd7c66e1977cc3$export$5d3fca4a98652595(routes, locationArg) {
    return $efbd7c66e1977cc3$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $efbd7c66e1977cc3$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$efbd7c66e1977cc3$export$9c954a9d03d32f4a() && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $7K7RB.useContext($efbd7c66e1977cc3$export$26749e8557646306);
    let { matches: parentMatches } = $7K7RB.useContext($efbd7c66e1977cc3$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $efbd7c66e1977cc3$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $a3b197e5ed11632f$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $a3b197e5ed11632f$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $efbd7c66e1977cc3$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $a3b197e5ed11632f$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $a3b197e5ed11632f$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $efbd7c66e1977cc3$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $a3b197e5ed11632f$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $efbd7c66e1977cc3$var$DefaultErrorComponent() {
    let error = $efbd7c66e1977cc3$export$ed527bf60f6e05f2();
    let message = (0, $a3b197e5ed11632f$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7K7RB.createElement($7K7RB.Fragment, null, /*#__PURE__*/ $7K7RB.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7K7RB.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7K7RB.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $efbd7c66e1977cc3$var$defaultErrorElement = /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$var$DefaultErrorComponent, null);
class $efbd7c66e1977cc3$var$RenderErrorBoundary extends $7K7RB.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $efbd7c66e1977cc3$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7K7RB.useContext($efbd7c66e1977cc3$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $efbd7c66e1977cc3$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $efbd7c66e1977cc3$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $efbd7c66e1977cc3$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7K7RB.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $efbd7c66e1977cc3$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($efbd7c66e1977cc3$var$DataRouterHook || {});
var $efbd7c66e1977cc3$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($efbd7c66e1977cc3$var$DataRouterStateHook || {});
function $efbd7c66e1977cc3$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $efbd7c66e1977cc3$var$useDataRouterContext(hookName) {
    let ctx = $7K7RB.useContext($efbd7c66e1977cc3$export$3add0d5dce533e2e);
    !ctx && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    return ctx;
}
function $efbd7c66e1977cc3$var$useDataRouterState(hookName) {
    let state = $7K7RB.useContext($efbd7c66e1977cc3$export$145dfa71566a64dc);
    !state && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    return state;
}
function $efbd7c66e1977cc3$var$useRouteContext(hookName) {
    let route = $7K7RB.useContext($efbd7c66e1977cc3$export$9072aa6dd1f93057);
    !route && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $efbd7c66e1977cc3$var$useCurrentRouteId(hookName) {
    let route = $efbd7c66e1977cc3$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $efbd7c66e1977cc3$export$5fc8298006ad9e58() {
    return $efbd7c66e1977cc3$var$useCurrentRouteId($efbd7c66e1977cc3$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $efbd7c66e1977cc3$export$d0fd4b7106de2769() {
    let state = $efbd7c66e1977cc3$var$useDataRouterState($efbd7c66e1977cc3$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $efbd7c66e1977cc3$export$600dc272ed516c15() {
    let dataRouterContext = $efbd7c66e1977cc3$var$useDataRouterContext($efbd7c66e1977cc3$var$DataRouterHook.UseRevalidator);
    let state = $efbd7c66e1977cc3$var$useDataRouterState($efbd7c66e1977cc3$var$DataRouterStateHook.UseRevalidator);
    return $7K7RB.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $efbd7c66e1977cc3$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $efbd7c66e1977cc3$var$useDataRouterState($efbd7c66e1977cc3$var$DataRouterStateHook.UseMatches);
    return $7K7RB.useMemo(()=>matches.map((m)=>(0, $a3b197e5ed11632f$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $efbd7c66e1977cc3$export$1448a5050d252c4d() {
    let state = $efbd7c66e1977cc3$var$useDataRouterState($efbd7c66e1977cc3$var$DataRouterStateHook.UseLoaderData);
    let routeId = $efbd7c66e1977cc3$var$useCurrentRouteId($efbd7c66e1977cc3$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $efbd7c66e1977cc3$export$fd5d37484eab868d(routeId) {
    let state = $efbd7c66e1977cc3$var$useDataRouterState($efbd7c66e1977cc3$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $efbd7c66e1977cc3$export$fdc00f3f26066d5e() {
    let state = $efbd7c66e1977cc3$var$useDataRouterState($efbd7c66e1977cc3$var$DataRouterStateHook.UseActionData);
    let routeId = $efbd7c66e1977cc3$var$useCurrentRouteId($efbd7c66e1977cc3$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $efbd7c66e1977cc3$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7K7RB.useContext($efbd7c66e1977cc3$var$RouteErrorContext);
    let state = $efbd7c66e1977cc3$var$useDataRouterState($efbd7c66e1977cc3$var$DataRouterStateHook.UseRouteError);
    let routeId = $efbd7c66e1977cc3$var$useCurrentRouteId($efbd7c66e1977cc3$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $efbd7c66e1977cc3$export$78a72ddb39bdd145() {
    let value = $7K7RB.useContext($efbd7c66e1977cc3$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $efbd7c66e1977cc3$export$17f53340677d5831() {
    let value = $7K7RB.useContext($efbd7c66e1977cc3$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $efbd7c66e1977cc3$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $efbd7c66e1977cc3$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $efbd7c66e1977cc3$var$useDataRouterContext($efbd7c66e1977cc3$var$DataRouterHook.UseBlocker);
    let state = $efbd7c66e1977cc3$var$useDataRouterState($efbd7c66e1977cc3$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7K7RB.useState("");
    let blockerFunction = $7K7RB.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $efbd7c66e1977cc3$var$_extends({}, currentLocation, {
                pathname: (0, $a3b197e5ed11632f$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $efbd7c66e1977cc3$var$_extends({}, nextLocation, {
                pathname: (0, $a3b197e5ed11632f$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7K7RB.useEffect(()=>{
        let key = String(++$efbd7c66e1977cc3$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7K7RB.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $a3b197e5ed11632f$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $efbd7c66e1977cc3$var$useNavigateStable() {
    let { router: router } = $efbd7c66e1977cc3$var$useDataRouterContext($efbd7c66e1977cc3$var$DataRouterHook.UseNavigateStable);
    let id = $efbd7c66e1977cc3$var$useCurrentRouteId($efbd7c66e1977cc3$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7K7RB.useRef(false);
    $efbd7c66e1977cc3$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7K7RB.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $efbd7c66e1977cc3$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $efbd7c66e1977cc3$var$alreadyWarned$1 = {};
function $efbd7c66e1977cc3$var$warningOnce(key, cond, message) {
    if (!cond && !$efbd7c66e1977cc3$var$alreadyWarned$1[key]) $efbd7c66e1977cc3$var$alreadyWarned$1[key] = true;
}
const $efbd7c66e1977cc3$var$alreadyWarned = {};
function $efbd7c66e1977cc3$var$warnOnce(key, message) {}
const $efbd7c66e1977cc3$var$logDeprecation = (flag, msg, link)=>$efbd7c66e1977cc3$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $efbd7c66e1977cc3$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $efbd7c66e1977cc3$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $efbd7c66e1977cc3$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $efbd7c66e1977cc3$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $efbd7c66e1977cc3$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $efbd7c66e1977cc3$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $efbd7c66e1977cc3$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $efbd7c66e1977cc3$var$START_TRANSITION = "startTransition";
const $efbd7c66e1977cc3$var$startTransitionImpl = $7K7RB[$efbd7c66e1977cc3$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $efbd7c66e1977cc3$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7K7RB.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7K7RB.useCallback((newState)=>{
        if (v7_startTransition && $efbd7c66e1977cc3$var$startTransitionImpl) $efbd7c66e1977cc3$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7K7RB.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7K7RB.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7K7RB.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7K7RB.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $7K7RB.useEffect(()=>$efbd7c66e1977cc3$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7K7RB.createElement($7K7RB.Fragment, null, /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $efbd7c66e1977cc3$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $efbd7c66e1977cc3$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $efbd7c66e1977cc3$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7K7RB.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a3b197e5ed11632f$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7K7RB.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7K7RB.useCallback((newState)=>{
        v7_startTransition && $efbd7c66e1977cc3$var$startTransitionImpl ? $efbd7c66e1977cc3$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7K7RB.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7K7RB.useEffect(()=>$efbd7c66e1977cc3$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $efbd7c66e1977cc3$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$efbd7c66e1977cc3$export$9c954a9d03d32f4a() && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $7K7RB.useContext($efbd7c66e1977cc3$export$26749e8557646306);
    let { matches: matches } = $7K7RB.useContext($efbd7c66e1977cc3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $efbd7c66e1977cc3$export$45d76561a5302f2b();
    let navigate = $efbd7c66e1977cc3$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $a3b197e5ed11632f$export$cae722b0cc860f13)(to, (0, $a3b197e5ed11632f$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7K7RB.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $efbd7c66e1977cc3$export$910ae8079b2c2852(props) {
    return $efbd7c66e1977cc3$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $efbd7c66e1977cc3$export$e7b0ac011bb776c6(_props) {
    (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $efbd7c66e1977cc3$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $a3b197e5ed11632f$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$efbd7c66e1977cc3$export$9c954a9d03d32f4a() && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7K7RB.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $efbd7c66e1977cc3$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $a3b197e5ed11632f$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7K7RB.useMemo(()=>{
        let trailingPathname = (0, $a3b197e5ed11632f$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $efbd7c66e1977cc3$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $efbd7c66e1977cc3$export$5d3fca4a98652595($efbd7c66e1977cc3$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $efbd7c66e1977cc3$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$var$ResolveAwait, null, children));
}
var $efbd7c66e1977cc3$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($efbd7c66e1977cc3$var$AwaitRenderStatus || {});
const $efbd7c66e1977cc3$var$neverSettledPromise = new Promise(()=>{});
class $efbd7c66e1977cc3$var$AwaitErrorBoundary extends $7K7RB.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $efbd7c66e1977cc3$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $efbd7c66e1977cc3$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $efbd7c66e1977cc3$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $efbd7c66e1977cc3$var$AwaitRenderStatus.error : "_data" in promise ? $efbd7c66e1977cc3$var$AwaitRenderStatus.success : $efbd7c66e1977cc3$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $efbd7c66e1977cc3$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $efbd7c66e1977cc3$var$AwaitRenderStatus.error && promise._error instanceof (0, $a3b197e5ed11632f$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $efbd7c66e1977cc3$var$neverSettledPromise;
        if (status === $efbd7c66e1977cc3$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $efbd7c66e1977cc3$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $efbd7c66e1977cc3$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7K7RB.createElement($efbd7c66e1977cc3$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $efbd7c66e1977cc3$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $efbd7c66e1977cc3$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7K7RB.createElement($7K7RB.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $efbd7c66e1977cc3$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7K7RB.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7K7RB.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7K7RB.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $efbd7c66e1977cc3$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $efbd7c66e1977cc3$export$e7b0ac011bb776c6) && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $efbd7c66e1977cc3$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $efbd7c66e1977cc3$export$daf73786167a7f72(matches) {
    return $efbd7c66e1977cc3$var$_renderMatches(matches);
}
function $efbd7c66e1977cc3$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7K7RB.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $7K7RB.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7K7RB.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $efbd7c66e1977cc3$export$f30f7e456d254e83(routes, opts) {
    return (0, $a3b197e5ed11632f$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $efbd7c66e1977cc3$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a3b197e5ed11632f$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $efbd7c66e1977cc3$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $d6cecb671eac0ab9$var$_extends() {
    return $d6cecb671eac0ab9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d6cecb671eac0ab9$var$_extends.apply(null, arguments);
}
function $d6cecb671eac0ab9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $d6cecb671eac0ab9$var$defaultMethod = "get";
const $d6cecb671eac0ab9$var$defaultEncType = "application/x-www-form-urlencoded";
function $d6cecb671eac0ab9$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $d6cecb671eac0ab9$var$isButtonElement(object) {
    return $d6cecb671eac0ab9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $d6cecb671eac0ab9$var$isFormElement(object) {
    return $d6cecb671eac0ab9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $d6cecb671eac0ab9$var$isInputElement(object) {
    return $d6cecb671eac0ab9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $d6cecb671eac0ab9$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $d6cecb671eac0ab9$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$d6cecb671eac0ab9$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $d6cecb671eac0ab9$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $d6cecb671eac0ab9$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $d6cecb671eac0ab9$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $d6cecb671eac0ab9$var$_formDataSupportsSubmitter = null;
function $d6cecb671eac0ab9$var$isFormDataSubmitterSupported() {
    if ($d6cecb671eac0ab9$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $d6cecb671eac0ab9$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $d6cecb671eac0ab9$var$_formDataSupportsSubmitter = true;
    }
    return $d6cecb671eac0ab9$var$_formDataSupportsSubmitter;
}
const $d6cecb671eac0ab9$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $d6cecb671eac0ab9$var$getFormEncType(encType) {
    if (encType != null && !$d6cecb671eac0ab9$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $d6cecb671eac0ab9$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($d6cecb671eac0ab9$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $a3b197e5ed11632f$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $d6cecb671eac0ab9$var$defaultMethod;
        encType = $d6cecb671eac0ab9$var$getFormEncType(target.getAttribute("enctype")) || $d6cecb671eac0ab9$var$defaultEncType;
        formData = new FormData(target);
    } else if ($d6cecb671eac0ab9$var$isButtonElement(target) || $d6cecb671eac0ab9$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $a3b197e5ed11632f$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $d6cecb671eac0ab9$var$defaultMethod;
        encType = $d6cecb671eac0ab9$var$getFormEncType(target.getAttribute("formenctype")) || $d6cecb671eac0ab9$var$getFormEncType(form.getAttribute("enctype")) || $d6cecb671eac0ab9$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$d6cecb671eac0ab9$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($d6cecb671eac0ab9$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $d6cecb671eac0ab9$var$defaultMethod;
        action = null;
        encType = $d6cecb671eac0ab9$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $d6cecb671eac0ab9$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $d6cecb671eac0ab9$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $d6cecb671eac0ab9$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $d6cecb671eac0ab9$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $d6cecb671eac0ab9$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $d6cecb671eac0ab9$export$1f3f55432a00e06d(routes, opts) {
    return (0, $a3b197e5ed11632f$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d6cecb671eac0ab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a3b197e5ed11632f$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d6cecb671eac0ab9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $efbd7c66e1977cc3$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $d6cecb671eac0ab9$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $a3b197e5ed11632f$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d6cecb671eac0ab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a3b197e5ed11632f$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d6cecb671eac0ab9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $efbd7c66e1977cc3$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $d6cecb671eac0ab9$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $d6cecb671eac0ab9$var$_extends({}, state, {
        errors: $d6cecb671eac0ab9$var$deserializeErrors(state.errors)
    });
    return state;
}
function $d6cecb671eac0ab9$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $a3b197e5ed11632f$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $d6cecb671eac0ab9$export$7ad602f0e94e62d1 = /*#__PURE__*/ $7K7RB.createContext({
    isTransitioning: false
});
const $d6cecb671eac0ab9$export$148fd98d095596d4 = /*#__PURE__*/ $7K7RB.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d6cecb671eac0ab9$var$START_TRANSITION = "startTransition";
const $d6cecb671eac0ab9$var$startTransitionImpl = $7K7RB[$d6cecb671eac0ab9$var$START_TRANSITION];
const $d6cecb671eac0ab9$var$FLUSH_SYNC = "flushSync";
const $d6cecb671eac0ab9$var$flushSyncImpl = $9828203bfeafb7fc$exports[$d6cecb671eac0ab9$var$FLUSH_SYNC];
const $d6cecb671eac0ab9$var$USE_ID = "useId";
const $d6cecb671eac0ab9$var$useIdImpl = $7K7RB[$d6cecb671eac0ab9$var$USE_ID];
function $d6cecb671eac0ab9$var$startTransitionSafe(cb) {
    if ($d6cecb671eac0ab9$var$startTransitionImpl) $d6cecb671eac0ab9$var$startTransitionImpl(cb);
    else cb();
}
function $d6cecb671eac0ab9$var$flushSyncSafe(cb) {
    if ($d6cecb671eac0ab9$var$flushSyncImpl) $d6cecb671eac0ab9$var$flushSyncImpl(cb);
    else cb();
}
class $d6cecb671eac0ab9$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d6cecb671eac0ab9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7K7RB.useState(router.state);
    let [pendingState, setPendingState] = $7K7RB.useState();
    let [vtContext, setVtContext] = $7K7RB.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7K7RB.useState();
    let [transition, setTransition] = $7K7RB.useState();
    let [interruption, setInterruption] = $7K7RB.useState();
    let fetcherData = $7K7RB.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $7K7RB.useCallback((cb)=>{
        if (v7_startTransition) $d6cecb671eac0ab9$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $7K7RB.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $d6cecb671eac0ab9$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $d6cecb671eac0ab9$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $d6cecb671eac0ab9$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $d6cecb671eac0ab9$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $d6cecb671eac0ab9$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7K7RB.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $7K7RB.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $d6cecb671eac0ab9$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $7K7RB.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $7K7RB.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $7K7RB.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $7K7RB.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7K7RB.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7K7RB.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $7K7RB.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $7K7RB.useEffect(()=>(0, $efbd7c66e1977cc3$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7K7RB.createElement($7K7RB.Fragment, null, /*#__PURE__*/ $7K7RB.createElement((0, $efbd7c66e1977cc3$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7K7RB.createElement((0, $efbd7c66e1977cc3$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $7K7RB.createElement($d6cecb671eac0ab9$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $7K7RB.createElement($d6cecb671eac0ab9$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $7K7RB.createElement((0, $efbd7c66e1977cc3$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7K7RB.createElement($d6cecb671eac0ab9$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $d6cecb671eac0ab9$var$MemoizedDataRoutes = /*#__PURE__*/ $7K7RB.memo($d6cecb671eac0ab9$var$DataRoutes);
function $d6cecb671eac0ab9$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $efbd7c66e1977cc3$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $d6cecb671eac0ab9$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $7K7RB.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a3b197e5ed11632f$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7K7RB.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7K7RB.useCallback((newState)=>{
        v7_startTransition && $d6cecb671eac0ab9$var$startTransitionImpl ? $d6cecb671eac0ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7K7RB.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7K7RB.useEffect(()=>(0, $efbd7c66e1977cc3$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7K7RB.createElement((0, $efbd7c66e1977cc3$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $d6cecb671eac0ab9$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $7K7RB.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a3b197e5ed11632f$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7K7RB.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7K7RB.useCallback((newState)=>{
        v7_startTransition && $d6cecb671eac0ab9$var$startTransitionImpl ? $d6cecb671eac0ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7K7RB.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7K7RB.useEffect(()=>(0, $efbd7c66e1977cc3$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7K7RB.createElement((0, $efbd7c66e1977cc3$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $d6cecb671eac0ab9$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $7K7RB.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7K7RB.useCallback((newState)=>{
        v7_startTransition && $d6cecb671eac0ab9$var$startTransitionImpl ? $d6cecb671eac0ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7K7RB.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7K7RB.useEffect(()=>(0, $efbd7c66e1977cc3$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7K7RB.createElement((0, $efbd7c66e1977cc3$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $d6cecb671eac0ab9$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $d6cecb671eac0ab9$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $d6cecb671eac0ab9$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7K7RB.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $d6cecb671eac0ab9$var$_objectWithoutPropertiesLoose(_ref7, $d6cecb671eac0ab9$var$_excluded);
    let { basename: basename } = $7K7RB.useContext((0, $efbd7c66e1977cc3$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $d6cecb671eac0ab9$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($d6cecb671eac0ab9$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $a3b197e5ed11632f$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $efbd7c66e1977cc3$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $d6cecb671eac0ab9$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7K7RB.createElement("a", $d6cecb671eac0ab9$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $d6cecb671eac0ab9$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7K7RB.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $d6cecb671eac0ab9$var$_objectWithoutPropertiesLoose(_ref8, $d6cecb671eac0ab9$var$_excluded2);
    let path = (0, $efbd7c66e1977cc3$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $efbd7c66e1977cc3$export$45d76561a5302f2b)();
    let routerState = $7K7RB.useContext((0, $efbd7c66e1977cc3$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $7K7RB.useContext((0, $efbd7c66e1977cc3$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $d6cecb671eac0ab9$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $a3b197e5ed11632f$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $7K7RB.createElement($d6cecb671eac0ab9$export$a6c7ac8248d6e38a, $d6cecb671eac0ab9$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $d6cecb671eac0ab9$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7K7RB.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $d6cecb671eac0ab9$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $d6cecb671eac0ab9$var$_objectWithoutPropertiesLoose(_ref9, $d6cecb671eac0ab9$var$_excluded3);
    let submit = $d6cecb671eac0ab9$export$47c85c6e3a081d3();
    let formAction = $d6cecb671eac0ab9$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $7K7RB.createElement("form", $d6cecb671eac0ab9$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $d6cecb671eac0ab9$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $d6cecb671eac0ab9$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $d6cecb671eac0ab9$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($d6cecb671eac0ab9$var$DataRouterHook || ($d6cecb671eac0ab9$var$DataRouterHook = {}));
var $d6cecb671eac0ab9$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($d6cecb671eac0ab9$var$DataRouterStateHook || ($d6cecb671eac0ab9$var$DataRouterStateHook = {}));
// Internal hooks
function $d6cecb671eac0ab9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $d6cecb671eac0ab9$var$useDataRouterContext(hookName) {
    let ctx = $7K7RB.useContext((0, $efbd7c66e1977cc3$export$3add0d5dce533e2e));
    !ctx && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d6cecb671eac0ab9$var$useDataRouterState(hookName) {
    let state = $7K7RB.useContext((0, $efbd7c66e1977cc3$export$145dfa71566a64dc));
    !state && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $d6cecb671eac0ab9$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $efbd7c66e1977cc3$export$9770f232ac06a008)();
    let location = (0, $efbd7c66e1977cc3$export$45d76561a5302f2b)();
    let path = (0, $efbd7c66e1977cc3$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7K7RB.useCallback((event)=>{
        if ($d6cecb671eac0ab9$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $a3b197e5ed11632f$export$fe53371bee54353d)(location) === (0, $a3b197e5ed11632f$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $d6cecb671eac0ab9$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7K7RB.useRef($d6cecb671eac0ab9$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7K7RB.useRef(false);
    let location = (0, $efbd7c66e1977cc3$export$45d76561a5302f2b)();
    let searchParams = $7K7RB.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $d6cecb671eac0ab9$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $efbd7c66e1977cc3$export$9770f232ac06a008)();
    let setSearchParams = $7K7RB.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $d6cecb671eac0ab9$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $d6cecb671eac0ab9$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $d6cecb671eac0ab9$var$fetcherId = 0;
let $d6cecb671eac0ab9$var$getUniqueFetcherId = ()=>"__" + String(++$d6cecb671eac0ab9$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $d6cecb671eac0ab9$export$47c85c6e3a081d3() {
    let { router: router } = $d6cecb671eac0ab9$var$useDataRouterContext($d6cecb671eac0ab9$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7K7RB.useContext((0, $efbd7c66e1977cc3$export$26749e8557646306));
    let currentRouteId = (0, $efbd7c66e1977cc3$export$5fc8298006ad9e58)();
    return $7K7RB.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $d6cecb671eac0ab9$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $d6cecb671eac0ab9$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $d6cecb671eac0ab9$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $d6cecb671eac0ab9$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7K7RB.useContext((0, $efbd7c66e1977cc3$export$26749e8557646306));
    let routeContext = $7K7RB.useContext((0, $efbd7c66e1977cc3$export$9072aa6dd1f93057));
    !routeContext && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $d6cecb671eac0ab9$var$_extends({}, (0, $efbd7c66e1977cc3$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $efbd7c66e1977cc3$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a3b197e5ed11632f$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $a3b197e5ed11632f$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $d6cecb671eac0ab9$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $d6cecb671eac0ab9$var$useDataRouterContext($d6cecb671eac0ab9$var$DataRouterHook.UseFetcher);
    let state = $d6cecb671eac0ab9$var$useDataRouterState($d6cecb671eac0ab9$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $7K7RB.useContext($d6cecb671eac0ab9$export$148fd98d095596d4);
    let route = $7K7RB.useContext((0, $efbd7c66e1977cc3$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    !route && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $d6cecb671eac0ab9$var$useIdImpl ? $d6cecb671eac0ab9$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $7K7RB.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($d6cecb671eac0ab9$var$getUniqueFetcherId());
    // Registration/cleanup
    $7K7RB.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $7K7RB.useCallback((href, opts)=>{
        !routeId && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $d6cecb671eac0ab9$export$47c85c6e3a081d3();
    let submit = $7K7RB.useCallback((target, opts)=>{
        submitImpl(target, $d6cecb671eac0ab9$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $7K7RB.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $7K7RB.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $7K7RB.createElement($d6cecb671eac0ab9$export$a7fed597f4b8afd8, $d6cecb671eac0ab9$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $a3b197e5ed11632f$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7K7RB.useMemo(()=>$d6cecb671eac0ab9$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $d6cecb671eac0ab9$export$fa996778a3a31087() {
    let state = $d6cecb671eac0ab9$var$useDataRouterState($d6cecb671eac0ab9$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $d6cecb671eac0ab9$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $d6cecb671eac0ab9$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $d6cecb671eac0ab9$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $d6cecb671eac0ab9$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $d6cecb671eac0ab9$var$useDataRouterContext($d6cecb671eac0ab9$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $d6cecb671eac0ab9$var$useDataRouterState($d6cecb671eac0ab9$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7K7RB.useContext((0, $efbd7c66e1977cc3$export$26749e8557646306));
    let location = (0, $efbd7c66e1977cc3$export$45d76561a5302f2b)();
    let matches = (0, $efbd7c66e1977cc3$export$2378eb7f5ff86053)();
    let navigation = (0, $efbd7c66e1977cc3$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $7K7RB.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $d6cecb671eac0ab9$var$usePageHide($7K7RB.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $d6cecb671eac0ab9$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $d6cecb671eac0ab9$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($d6cecb671eac0ab9$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7K7RB.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $d6cecb671eac0ab9$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $d6cecb671eac0ab9$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7K7RB.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($d6cecb671eac0ab9$var$_extends({}, location, {
                    pathname: (0, $a3b197e5ed11632f$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($d6cecb671eac0ab9$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7K7RB.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d6cecb671eac0ab9$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7K7RB.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d6cecb671eac0ab9$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7K7RB.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $d6cecb671eac0ab9$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $efbd7c66e1977cc3$export$b273b3273281a049)(when);
    $7K7RB.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7K7RB.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $d6cecb671eac0ab9$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $7K7RB.useContext($d6cecb671eac0ab9$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $a3b197e5ed11632f$export$3e9cee6b33872309)(false);
    let { basename: basename } = $d6cecb671eac0ab9$var$useDataRouterContext($d6cecb671eac0ab9$var$DataRouterHook.useViewTransitionState);
    let path = (0, $efbd7c66e1977cc3$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $a3b197e5ed11632f$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $a3b197e5ed11632f$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $a3b197e5ed11632f$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $a3b197e5ed11632f$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}





parcelRequire("7K7RB");

function $43758a5d264acf46$export$2e2bcd8739ae039() {
    const navigate = (0, $efbd7c66e1977cc3$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
        className: "disclosure-screen",
        children: [
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                className: "disclosure-glow",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                className: "disclosure-pattern",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("main", {
                className: "disclosure-panel",
                children: [
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "brand-eyebrow",
                        children: "Nutanix \xd7 KubeCon"
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("h1", {
                        className: "brand-title",
                        children: [
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                className: "brand-q",
                                "aria-hidden": "true",
                                children: "?"
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                className: "brand-title-text",
                                children: "Riddler's Funhouse"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "disclosure-lead",
                        children: "Pass all four challenges and earn a custom Challenge Coin."
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("p", {
                        className: "disclosure-powered",
                        children: [
                            "Powered by ",
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("strong", {
                                children: "Nutanix Kubernetes Platform"
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("br", {}),
                            "and ",
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("strong", {
                                children: "Nutanix Enterprise AI"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                        type: "button",
                        className: "btn-primary btn-play",
                        onClick: ()=>navigate('/setup'),
                        children: "Play"
                    })
                ]
            })
        ]
    });
}




var $7K7RB = parcelRequire("7K7RB");

/** Client capability helpers for the post-disclosure setup tips. */ function $9a9e10fed1e3d711$export$93913f1ed9cb0d13() {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(display-mode: standalone)').matches || window.matchMedia('(display-mode: fullscreen)').matches || window.navigator.standalone === true;
}
function $9a9e10fed1e3d711$export$bb6cbb303d9d5a10() {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent || '';
    if (/iPad|iPhone|iPod/i.test(ua)) return true;
    // iPadOS desktop UA still needs Home Screen for Web Push.
    return navigator.platform === 'MacIntel' && Number(navigator.maxTouchPoints || 0) > 1;
}
function $9a9e10fed1e3d711$export$10a6ecd1479fce3a() {
    if (typeof navigator === 'undefined') return false;
    return /Android/i.test(navigator.userAgent || '');
}
function $9a9e10fed1e3d711$export$ecddb6bd54c79a9e() {
    return typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}
function $9a9e10fed1e3d711$export$6f9c1fd16713ccfd() {
    const standalone = $9a9e10fed1e3d711$export$93913f1ed9cb0d13();
    const ios = $9a9e10fed1e3d711$export$bb6cbb303d9d5a10();
    const android = $9a9e10fed1e3d711$export$10a6ecd1479fce3a();
    const push = $9a9e10fed1e3d711$export$ecddb6bd54c79a9e();
    if (standalone) return {
        id: 'standalone',
        title: 'Home Screen mode',
        ios: ios,
        android: android,
        push: push,
        standalone: standalone
    };
    if (ios && !push) return {
        id: 'ios-needs-homescreen',
        title: 'iPhone setup',
        ios: ios,
        android: android,
        push: push,
        standalone: standalone
    };
    if (android) return {
        id: 'android-chrome',
        title: 'Android setup',
        ios: ios,
        android: android,
        push: push,
        standalone: standalone
    };
    if (push) return {
        id: 'desktop-push',
        title: 'Desktop setup',
        ios: ios,
        android: android,
        push: push,
        standalone: standalone
    };
    return {
        id: 'limited',
        title: 'Quick setup',
        ios: ios,
        android: android,
        push: push,
        standalone: standalone
    };
}


function $6a1a7746e79fed54$var$TipsForProfile(profile) {
    if (profile.id === 'standalone') return {
        lead: 'Nice. You are already in Home Screen mode.',
        steps: [
            'After you create your codename, tap Enable alerts in chat.',
            'That is how Conga and sleeping gas poke this phone when Funhouse needs you.'
        ],
        footnote: 'Keep this icon. Safari tabs on iPhone cannot keep the line alive the same way.'
    };
    if (profile.id === 'ios-needs-homescreen') return {
        lead: 'Best booth experience on iPhone: play from the Home Screen.',
        steps: [
            'Tap Share in Safari (the square with the arrow).',
            'Scroll and tap Add to Home Screen, then Add.',
            'Open Riddler from the new icon (not the Safari tab).',
            'After sign-in, tap Enable alerts so Conga can reach you.'
        ],
        footnote: 'Without Home Screen mode, iPhone will not show Funhouse push alerts.'
    };
    if (profile.id === 'android-chrome') return {
        lead: 'Chrome on Android can alert you from a normal tab.',
        steps: [
            "Optional: Add to Home Screen (Chrome menu \u2192 Install app / Add to Home screen) for a cleaner booth layout.",
            'After you sign in, tap Enable alerts when Funhouse offers it.',
            'Allow notifications when Chrome asks. Leave the app when you join the Conga so pokes can land.'
        ],
        footnote: 'You do not need Home Screen mode for Android push, but it feels better at the booth.'
    };
    if (profile.id === 'desktop-push') return {
        lead: 'This browser can do Funhouse alerts.',
        steps: [
            'After you sign in, tap Enable alerts in chat.',
            'Allow notifications when the browser asks.',
            'Keep the Funhouse tab open in the background while you wait in line.'
        ],
        footnote: 'Phone Home Screen mode is still best if you walk the floor.'
    };
    return {
        lead: 'You can still play. Conga shoulder-taps may not work on this browser.',
        steps: [
            'Create a codename and keep Funhouse in front when your ticket is up.',
            'If you have an iPhone or Android, open this site there for a smoother booth run.'
        ],
        footnote: null
    };
}
function $6a1a7746e79fed54$export$2e2bcd8739ae039() {
    const navigate = (0, $efbd7c66e1977cc3$export$9770f232ac06a008)();
    const [profile, setProfile] = (0, $7K7RB.useState)(()=>(0, $9a9e10fed1e3d711$export$6f9c1fd16713ccfd)());
    const [installEvent, setInstallEvent] = (0, $7K7RB.useState)(null);
    const [installBusy, setInstallBusy] = (0, $7K7RB.useState)(false);
    const tips = $6a1a7746e79fed54$var$TipsForProfile(profile);
    (0, $7K7RB.useEffect)(()=>{
        const RefreshProfile = ()=>setProfile((0, $9a9e10fed1e3d711$export$6f9c1fd16713ccfd)());
        const OnVisibility = ()=>{
            if (document.visibilityState === 'visible') RefreshProfile();
        };
        window.addEventListener('focus', RefreshProfile);
        document.addEventListener('visibilitychange', OnVisibility);
        return ()=>{
            window.removeEventListener('focus', RefreshProfile);
            document.removeEventListener('visibilitychange', OnVisibility);
        };
    }, []);
    (0, $7K7RB.useEffect)(()=>{
        const OnPrompt = (event)=>{
            event.preventDefault();
            setInstallEvent(event);
        };
        window.addEventListener('beforeinstallprompt', OnPrompt);
        return ()=>window.removeEventListener('beforeinstallprompt', OnPrompt);
    }, []);
    const handleInstall = async ()=>{
        if (!installEvent || installBusy) return;
        setInstallBusy(true);
        try {
            await installEvent.prompt();
            await installEvent.userChoice;
        } catch  {
        /* player dismissed / unsupported */ } finally{
            setInstallEvent(null);
            setInstallBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
        className: "disclosure-screen",
        children: [
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                className: "disclosure-glow",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                className: "disclosure-pattern",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("main", {
                className: "disclosure-panel setup-panel",
                children: [
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "brand-eyebrow",
                        children: "Before the Funhouse"
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("h1", {
                        className: "setup-title",
                        children: profile.title
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "disclosure-lead",
                        children: tips.lead
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("ol", {
                        className: "setup-steps",
                        children: tips.steps.map((step)=>/*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("li", {
                                children: step
                            }, step))
                    }),
                    tips.footnote && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "setup-footnote",
                        children: tips.footnote
                    }),
                    installEvent && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                        type: "button",
                        className: "btn-primary",
                        onClick: handleInstall,
                        disabled: installBusy,
                        children: installBusy ? "Opening install\u2026" : 'Install Funhouse'
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                        type: "button",
                        className: "btn-primary btn-play",
                        onClick: ()=>navigate('/auth'),
                        children: "Continue"
                    })
                ]
            })
        ]
    });
}




var $7K7RB = parcelRequire("7K7RB");




parcelRequire("7K7RB");
function $a2d74aa0b20e7071$export$2e2bcd8739ae039({ value: value, onChange: onChange, maxLength: maxLength = 10, disabled: disabled = false }) {
    const AppendDigit = (digit)=>{
        if (disabled || value.length >= maxLength) return;
        onChange(value + digit);
    };
    const Backspace = ()=>{
        if (disabled || !value.length) return;
        onChange(value.slice(0, -1));
    };
    const Clear = ()=>{
        if (disabled) return;
        onChange('');
    };
    const keys = [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'clear',
        '0',
        'back'
    ];
    return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
        className: "pin-keypad",
        children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
            className: "pin-grid",
            role: "group",
            "aria-label": "PIN keypad",
            children: keys.map((key)=>{
                if (key === 'clear') return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                    type: "button",
                    className: "pin-key pin-key-action",
                    onClick: Clear,
                    disabled: disabled || value.length === 0,
                    "aria-label": "Clear PIN",
                    children: "Clear"
                }, key);
                if (key === 'back') return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                    type: "button",
                    className: "pin-key pin-key-action",
                    onClick: Backspace,
                    disabled: disabled || value.length === 0,
                    "aria-label": "Delete last digit",
                    children: "\u232B"
                }, key);
                return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                    type: "button",
                    className: "pin-key",
                    onClick: ()=>AppendDigit(key),
                    disabled: disabled || value.length >= maxLength,
                    children: key
                }, key);
            })
        })
    });
}


const $b31dc677b481ad1e$var$MIN_PIN = 4;
const $b31dc677b481ad1e$var$MAX_PIN = 10;
function $b31dc677b481ad1e$var$HasStoredUsername() {
    return Boolean((localStorage.getItem('riddler_username') || '').trim());
}
function $b31dc677b481ad1e$var$DigitsOnly(value, maxLength = $b31dc677b481ad1e$var$MAX_PIN) {
    return (value || '').replace(/\D/g, '').slice(0, maxLength);
}
function $b31dc677b481ad1e$export$2e2bcd8739ae039() {
    const { login: login, register: register, error: error, setError: setError, isDevEnv: isDevEnv } = (0, $1c591ca8e849d56b$export$1d39dc5b47e56ff0)();
    const navigate = (0, $efbd7c66e1977cc3$export$9770f232ac06a008)();
    const deviceRegistered = $b31dc677b481ad1e$var$HasStoredUsername();
    // Booth/prod: one phone → one codename (Sign-in only after first register).
    // Dev: always allow Register tab for easier multi-account testing.
    const lockToLogin = deviceRegistered && !isDevEnv;
    const [mode, setMode] = (0, $7K7RB.useState)(()=>deviceRegistered ? 'login' : 'register');
    const [username, setUsername] = (0, $7K7RB.useState)(()=>localStorage.getItem('riddler_username') || '');
    const [allocatedUsername, setAllocatedUsername] = (0, $7K7RB.useState)('');
    const [allocating, setAllocating] = (0, $7K7RB.useState)(false);
    const [pin, setPin] = (0, $7K7RB.useState)('');
    const [email, setEmail] = (0, $7K7RB.useState)('');
    const [submitting, setSubmitting] = (0, $7K7RB.useState)(false);
    const [mintedUsername, setMintedUsername] = (0, $7K7RB.useState)(null);
    const [topExpanded, setTopExpanded] = (0, $7K7RB.useState)(()=>!deviceRegistered);
    const pinReady = pin.length >= $b31dc677b481ad1e$var$MIN_PIN && pin.length <= $b31dc677b481ad1e$var$MAX_PIN;
    const usernameReady = Boolean(username.trim());
    // Prefetch a unique codename into the register form so username+PIN are filled together for PMs.
    (0, $7K7RB.useEffect)(()=>{
        if (lockToLogin || mode !== 'register' || mintedUsername) return undefined;
        let cancelled = false;
        setAllocating(true);
        (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/auth/allocate-username', {
            method: 'POST',
            body: '{}'
        }).then((data)=>{
            if (!cancelled) setAllocatedUsername(data.username || '');
        }).catch((err)=>{
            if (!cancelled) setError(err.message);
        }).finally(()=>{
            if (!cancelled) setAllocating(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        lockToLogin,
        mode,
        mintedUsername,
        setError
    ]);
    const switchMode = (next)=>{
        if (lockToLogin && next === 'register') return;
        setMode(next);
        setError(null);
        setPin('');
        setMintedUsername(null);
        if (next === 'login') setTopExpanded(false);
        else {
            setTopExpanded(true);
            setAllocatedUsername('');
        }
    };
    const handleRegister = async (e)=>{
        e.preventDefault();
        if (!pinReady || submitting || !allocatedUsername || !email.trim()) return;
        setSubmitting(true);
        setError(null);
        try {
            const data = await register(pin, allocatedUsername, email.trim());
            setMintedUsername(data.user.username);
            setPin('');
            setEmail('');
        } catch  {
        // error on context
        } finally{
            setSubmitting(false);
        }
    };
    const handleLogin = async (e)=>{
        e.preventDefault();
        if (submitting) return;
        if (!usernameReady || !pinReady) {
            setError('Enter your username/email and PIN to sign in');
            return;
        }
        setSubmitting(true);
        setError(null);
        try {
            await login(username.trim(), pin);
            navigate('/chat', {
                replace: true
            });
        } catch  {
        // error on context
        } finally{
            setSubmitting(false);
        }
    };
    if (mintedUsername) return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
        className: "auth-screen",
        children: [
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                className: "disclosure-glow",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("main", {
                className: "auth-panel codename-panel",
                children: [
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "brand-eyebrow",
                        children: "Your codename"
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("h1", {
                        className: "codename-reveal",
                        children: mintedUsername
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "auth-sub",
                        children: "You're in. Remember this name with your PIN for sign-in later."
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                        type: "button",
                        className: "btn-primary",
                        onClick: ()=>navigate('/chat', {
                                replace: true
                            }),
                        children: "Enter the puzzle box"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
        className: "auth-screen",
        children: [
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                className: "disclosure-glow",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("main", {
                className: "auth-panel",
                children: [
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                        type: "button",
                        className: "back-link",
                        onClick: ()=>navigate('/'),
                        children: "\u2190 Back"
                    }),
                    !topExpanded ? /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("button", {
                        type: "button",
                        className: "auth-top-toggle",
                        "aria-expanded": "false",
                        onClick: ()=>setTopExpanded(true),
                        children: [
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                children: "Sign-in options"
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                className: "auth-top-toggle-hint",
                                children: "Show"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                        className: "auth-top",
                        children: [
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                                className: "auth-sub",
                                children: lockToLogin ? 'Welcome back. Enter your PIN to continue. This phone already has a codename.' : mode === 'register' ? "Pick a PIN (4\u201310 digits). Your Batman-themed codename is ready below." : 'Enter your codename or email to continue.'
                            }),
                            !lockToLogin && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                                className: "auth-tabs",
                                role: "tablist",
                                children: [
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                                        type: "button",
                                        role: "tab",
                                        className: mode === 'register' ? 'active' : '',
                                        "aria-selected": mode === 'register',
                                        onClick: ()=>switchMode('register'),
                                        children: "Register"
                                    }),
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                                        type: "button",
                                        role: "tab",
                                        className: mode === 'login' ? 'active' : '',
                                        "aria-selected": mode === 'login',
                                        onClick: ()=>switchMode('login'),
                                        children: "Sign in"
                                    })
                                ]
                            })
                        ]
                    }),
                    mode === 'register' && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("form", {
                        id: "riddler-register",
                        className: "auth-form",
                        method: "post",
                        autoComplete: "on",
                        onSubmit: handleRegister,
                        children: [
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("label", {
                                htmlFor: "register-username",
                                className: "sr-only",
                                children: "Codename"
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("input", {
                                id: "register-username",
                                name: "username",
                                type: "text",
                                autoComplete: "username",
                                autoCapitalize: "off",
                                autoCorrect: "off",
                                spellCheck: false,
                                className: "pm-username-slot",
                                value: allocatedUsername,
                                onChange: ()=>{},
                                readOnly: true,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("label", {
                                htmlFor: "register-email",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("input", {
                                id: "register-email",
                                name: "email",
                                type: "email",
                                autoComplete: "email",
                                autoCapitalize: "none",
                                autoCorrect: "off",
                                spellCheck: false,
                                className: "auth-field",
                                value: email,
                                onChange: (e)=>setEmail(e.target.value),
                                required: true,
                                placeholder: "you@example.com",
                                disabled: submitting
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("label", {
                                htmlFor: "register-password",
                                children: "PIN"
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("input", {
                                id: "register-password",
                                name: "password",
                                className: "pin-field",
                                type: "text",
                                autoComplete: "new-password",
                                inputMode: "none",
                                pattern: "[0-9]*",
                                minLength: $b31dc677b481ad1e$var$MIN_PIN,
                                maxLength: $b31dc677b481ad1e$var$MAX_PIN,
                                passwordrules: `minlength: ${$b31dc677b481ad1e$var$MIN_PIN}; maxlength: ${$b31dc677b481ad1e$var$MAX_PIN}; allowed: digit;`,
                                value: pin,
                                onChange: (e)=>setPin($b31dc677b481ad1e$var$DigitsOnly(e.target.value)),
                                required: true,
                                placeholder: "\u2022\u2022\u2022\u2022",
                                disabled: allocating || !allocatedUsername
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                                className: "auth-privacy pin-count-line",
                                "aria-live": "polite",
                                children: pin.length > 0 && pin.length < $b31dc677b481ad1e$var$MIN_PIN ? `Enter at least ${$b31dc677b481ad1e$var$MIN_PIN} digits (${$b31dc677b481ad1e$var$MIN_PIN - pin.length} more).` : `${pin.length}/${$b31dc677b481ad1e$var$MAX_PIN} digits \xb7 Suggest Phone Number (memorable)`
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $a2d74aa0b20e7071$export$2e2bcd8739ae039), {
                                value: pin,
                                onChange: setPin,
                                maxLength: $b31dc677b481ad1e$var$MAX_PIN,
                                disabled: submitting || allocating || !allocatedUsername
                            }),
                            error && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                                className: "form-error",
                                role: "alert",
                                children: error
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                                type: "submit",
                                className: "btn-primary",
                                disabled: submitting || !pinReady || allocating || !allocatedUsername,
                                children: submitting ? "One moment\u2026" : 'Register & play'
                            })
                        ]
                    }),
                    mode === 'login' && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("form", {
                        id: "riddler-login",
                        className: "auth-form",
                        method: "post",
                        autoComplete: "on",
                        onSubmit: handleLogin,
                        children: [
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("label", {
                                htmlFor: "login-username",
                                children: "Username or email"
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("input", {
                                id: "login-username",
                                name: "username",
                                type: "text",
                                autoComplete: "username",
                                autoCapitalize: "none",
                                autoCorrect: "off",
                                spellCheck: false,
                                value: username,
                                onChange: (e)=>setUsername(e.target.value),
                                required: true,
                                placeholder: "you@example.com"
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                                className: "auth-pin-block",
                                children: [
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("label", {
                                        htmlFor: "login-password",
                                        children: "PIN"
                                    }),
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("input", {
                                        id: "login-password",
                                        name: "password",
                                        className: "pin-field",
                                        type: "text",
                                        autoComplete: "current-password",
                                        inputMode: "none",
                                        pattern: "[0-9]*",
                                        maxLength: $b31dc677b481ad1e$var$MAX_PIN,
                                        value: pin,
                                        onChange: (e)=>setPin($b31dc677b481ad1e$var$DigitsOnly(e.target.value)),
                                        required: true,
                                        placeholder: "\u2022\u2022\u2022\u2022",
                                        enterKeyHint: "done"
                                    }),
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)((0, $1b19c28e316f1f45$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                                                className: "auth-privacy pin-count-line",
                                                "aria-live": "polite",
                                                children: pin.length > 0 && pin.length < $b31dc677b481ad1e$var$MIN_PIN ? `Enter at least ${$b31dc677b481ad1e$var$MIN_PIN} digits (${$b31dc677b481ad1e$var$MIN_PIN - pin.length} more).` : `${pin.length}/${$b31dc677b481ad1e$var$MAX_PIN} digits \xb7 Suggest Phone Number (memorable)`
                                            }),
                                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $a2d74aa0b20e7071$export$2e2bcd8739ae039), {
                                                value: pin,
                                                onChange: setPin,
                                                maxLength: $b31dc677b481ad1e$var$MAX_PIN,
                                                disabled: submitting
                                            })
                                        ]
                                    })
                                ]
                            }),
                            error && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                                className: "form-error",
                                role: "alert",
                                children: error
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                                type: "submit",
                                className: "btn-primary",
                                disabled: submitting || !usernameReady || !pinReady,
                                children: submitting ? "One moment\u2026" : 'Sign in'
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7K7RB = parcelRequire("7K7RB");


/**
 * Challenge logic — C1 canned misses; C2 explore + dig-chat Narrator beats (local).
 * On success the client calls POST /api/v1/game/complete for progress sync.
 * Riddler voice is marked by a green ? badge on the bubble (not trailing text).
 */ const $4c0f85921202c3c8$export$30f4cc448c4882e = {
    id: 1,
    answerNeedle: 'vowels',
    answerNeedles: [
        'vowels',
        'aeiou'
    ]
};
function $4c0f85921202c3c8$export$6d1bb9667f0ae81a(text) {
    if (!text) return false;
    const normalized = text.toLowerCase().replace(/\s/g, '');
    if (normalized.includes('tennis') || normalized.includes('court')) return false;
    if (normalized.includes('aeiou')) return true;
    const vowels = new Set([
        'a',
        'e',
        'i',
        'o',
        'u'
    ]);
    const letters = new Set(normalized.replace(/[^a-z]/g, ''));
    return vowels.size === 5 && [
        ...vowels
    ].every((v)=>letters.has(v));
}
const $4c0f85921202c3c8$export$f316401d6ea60d8f = [
    'Wrong! Riddle me this again, and try not to embarrass yourself.',
    'Ha! Cold as the Batcave in winter. Dig deeper.',
    'Is that your final answer? Because it is delightfully incorrect.',
    'Oh, please. Even Harley could do better, and she barely tries.',
    "No, no, no. Think smaller\u2026 everyday\u2026 hiding in plain sight.",
    'Incorrect! The court is laughing at you. Or perhaps I am.',
    "Nuh-uh. You're circling the answer like a confused bat.",
    'Nice try, for an amateur. Hint: there are five of us.',
    "Denied. Puzzle boxes don't open for guesses that limp.",
    'Alas, mortal. That is not it. Read the riddle again.',
    "So close\u2026 said no one ever. Try once more."
];
const $4c0f85921202c3c8$export$51efe6537ae9689d = [
    '{username} mumbled something under their breath, and off in the distance, the Riddler throws a tantrum.',
    '{username} muttered at the laptop. Somewhere far off, the Riddler stomps, then blames Goon42 for the missing cameras. Again.',
    '{username} whispers a half-finished thought. The Riddler shrieks that Goon42 was supposed to watch this hallway.',
    '{username} talks to the screen like it owes them rent. Distant Riddler meltdown. Goon42 is somehow already the villain.',
    '{username} says something quiet and useless. The Riddler pitches a fit about Goon42 dropping off the camera feed.'
];
function $4c0f85921202c3c8$export$bb334c56c413aa56(template, username) {
    const name = String(username || 'Someone').trim() || 'Someone';
    return String(template || '').split('{username}').join(name);
}
const $4c0f85921202c3c8$export$9a4f17f8058e4ee2 = [
    'Not impressed.',
    "You're wasting cycles.",
    'Try harder. Or leave.',
    'The console already told me you were coming.'
];
/**
 * Funhouse hold music — Play song reveals lyric-by-lyric (paragraph/line beats).
 * First chat on the waitlist teases the opening lyric; Play paints the rest.
 */ const $4c0f85921202c3c8$var$HOLD_MUSIC_CHORUS = [
    "Please hold, please hold, your number\u2019s almost gold",
    "The marquee knows your fate, but it won\u2019t be told",
    'Step, wait, step, wait: the Conga never ends',
    'One more riddle on repeat until the velvet bends'
];
const $4c0f85921202c3c8$export$9fbc8c34121afc88 = [
    // Verse 1
    'Standing in a line that circles back to doubt',
    'Velvet rope ahead, lukewarm riddle water in my cup',
    'NOW SEEING someone who is definitely not me',
    'Ticket stub melting in my anxious little hand',
    // Chorus
    ...$4c0f85921202c3c8$var$HOLD_MUSIC_CHORUS,
    // Verse 2
    'Goon42 on break, stilts by the snack machine',
    'Snooze Lounge humming like a cheap dream',
    'I came for secrets, stayed for queue etiquette',
    'YAML confetti on the floor: dreams deferred, please hold',
    // Chorus
    ...$4c0f85921202c3c8$var$HOLD_MUSIC_CHORUS,
    // Bridge
    'If patience is a puzzle, consider me unsolved',
    "The usher winks in question marks and says I\u2019m evolving",
    'Behind me another player mouthing every word',
    'We are the choir of the almost-served',
    // Final chorus
    ...$4c0f85921202c3c8$var$HOLD_MUSIC_CHORUS,
    "(fade out\u2026 please continue to hold\u2026)"
];
const $4c0f85921202c3c8$export$d21787f0a76dff3e = [
    "Catchy, isn\u2019t it? I wrote the twelfth chorus myself. Nobody asked.",
    "Don\u2019t clap. Clapping renews the license for another verse.",
    'Your stub is melting faster than my patience. Impressive.',
    "I rate that performance a solid \u201Cplease continue to hold.\u201D",
    'If you hummed along, the Conga considers that binding consent.',
    'Encore? No. Suffer quietly like a professional guest.',
    'Somewhere a walk-in is Entering. Somewhere is not your number.',
    'The Snooze Lounge sends its regards. And a coupon for more fog.',
    "I invent new ways to mock ticket numbers as a hobby. Yours is\u2026 fine.",
    "Keep holding. I\u2019ve got seventeen more bridges and a horn section on retainers."
];
function $4c0f85921202c3c8$export$87e2b0179745c01d() {
    return `\u{1F3B5} ${$4c0f85921202c3c8$export$9fbc8c34121afc88[0]} \u{1F3B5}`;
}
function $4c0f85921202c3c8$export$cce2419198855088(fromIndex = 1) {
    const lines = $4c0f85921202c3c8$export$9fbc8c34121afc88.slice(fromIndex);
    if (!lines.length) return '';
    return `\u{1F3B5}

${lines.join('\n\n')}

\u{1F3B5}`;
}
function $4c0f85921202c3c8$export$6978a1b59fd89099(body) {
    const text = body || '';
    return text.includes("\uD83C\uDFB5") && text.includes('\n');
}
const $4c0f85921202c3c8$export$65b9c7ccb4df4e3d = [
    "\uD83C\uDFB5 Please approach the velvet rope when ready. Enter is lit \uD83C\uDFB5",
    "\uD83C\uDFB5 Your window is open. Goon42 is pretending not to watch the clock \uD83C\uDFB5",
    "\uD83C\uDFB5 Two glittering minutes (give or take a musical number) \uD83C\uDFB5",
    "\uD83C\uDFB5 The marquee knows your name. Hit Enter before intermission \uD83C\uDFB5"
];
function $4c0f85921202c3c8$export$825fe62e96ae7a67(text) {
    let body = (text || '').replace(/\s+$/, '');
    if (body.endsWith("\u2754")) body = body.slice(0, -1).replace(/\s+$/, '');
    if (body.endsWith(' ?')) body = body.slice(0, -2).replace(/\s+$/, '');
    if (body.length >= 2 && body.endsWith('?') && ".!\u2026".includes(body[body.length - 2])) body = body.slice(0, -1).replace(/\s+$/, '');
    return body;
}
/** Fisher–Yates shuffle (copy). */ function $4c0f85921202c3c8$var$Shuffle(items) {
    const arr = [
        ...items
    ];
    for(let i = arr.length - 1; i > 0; i -= 1){
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [
            arr[j],
            arr[i]
        ];
    }
    return arr;
}
function $4c0f85921202c3c8$export$e6dddebe70b000a9(replies) {
    let deck = $4c0f85921202c3c8$var$Shuffle(replies);
    let nextIndex = 0;
    return function PickReply() {
        if (nextIndex >= deck.length) {
            deck = $4c0f85921202c3c8$var$Shuffle(replies);
            nextIndex = 0;
        }
        const line = deck[nextIndex];
        nextIndex += 1;
        return line;
    };
}
function $4c0f85921202c3c8$export$332433f430ca9250(lines) {
    const playlist = [
        ...lines
    ];
    let nextIndex = 0;
    return function PickNextLine() {
        if (playlist.length === 0) return '';
        const line = playlist[nextIndex];
        nextIndex = (nextIndex + 1) % playlist.length;
        return line;
    };
}
function $4c0f85921202c3c8$export$9c48a43cd445f6bc(replies = $4c0f85921202c3c8$export$f316401d6ea60d8f) {
    return $4c0f85921202c3c8$export$e6dddebe70b000a9(replies);
}
function $4c0f85921202c3c8$export$b2aea282d2d17441(sender, body) {
    return {
        id: `local-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        sender: sender,
        body: body,
        created_at: new Date().toISOString(),
        local: true
    };
}
function $4c0f85921202c3c8$export$8d3355b82ece0d14(body) {
    return $4c0f85921202c3c8$export$b2aea282d2d17441('riddler', body);
}
function $4c0f85921202c3c8$export$b5956b6bfc060356(body) {
    return $4c0f85921202c3c8$export$b2aea282d2d17441('narrator', body);
}
function $4c0f85921202c3c8$export$601061c1e9773e9d(body) {
    return $4c0f85921202c3c8$export$b2aea282d2d17441('goon', body);
}
function $4c0f85921202c3c8$export$67b42fef0952aece(sender) {
    if (sender === 'user') return 'from-user';
    if (sender === 'narrator') return 'from-narrator';
    if (sender === 'goon') return 'from-goon';
    return 'from-riddler';
}
function $4c0f85921202c3c8$export$61dfff8cc52d567(sender) {
    if (sender === 'user') return 'user';
    if (sender === 'narrator') return 'narrator';
    if (sender === 'goon') return 'goon';
    return 'riddler';
}
function $4c0f85921202c3c8$export$7be4178d1714e085(sender) {
    if (sender === 'narrator') return 'Narrator';
    if (sender === 'goon') return 'Goon42';
    return null;
}
function $4c0f85921202c3c8$export$d097dd1fb53fae9b(messages) {
    const active = new Set();
    if (!Array.isArray(messages) || messages.length === 0) return active;
    let lastNarrator = -1;
    for(let i = messages.length - 1; i >= 0; i -= 1)if (messages[i]?.sender === 'narrator') {
        lastNarrator = i;
        break;
    }
    if (lastNarrator < 0) return active;
    active.add(lastNarrator);
    let seenDialogue = false;
    for(let i = lastNarrator - 1; i >= 0; i -= 1){
        const sender = messages[i]?.sender;
        if (sender === 'user') break;
        if (sender === 'riddler' || sender === 'goon') {
            seenDialogue = true;
            continue;
        }
        if (sender === 'narrator') {
            if (!seenDialogue) break;
            active.add(i);
            seenDialogue = false;
            continue;
        }
    }
    return active;
}
function $4c0f85921202c3c8$export$149147fac2d4c521(sender, body) {
    if (sender === 'riddler') return $4c0f85921202c3c8$export$825fe62e96ae7a67(body);
    return body;
}
function $4c0f85921202c3c8$export$e6fb8d7cc026b399(body, gitopsUrl) {
    let text = body || '';
    if (gitopsUrl) text = text.split(gitopsUrl).join('');
    // Drop leftover bare github repo lines.
    text = text.replace(/^https?:\/\/\S+\s*$/gm, '');
    return text.replace(/\n{3,}/g, '\n\n').trim();
}
function $4c0f85921202c3c8$export$d352b5cae9356ab6(body, roomName) {
    const text = body || '';
    if (!roomName || !text.includes(roomName)) return [
        {
            type: 'text',
            value: text
        }
    ];
    const parts = text.split(roomName);
    const tokens = [];
    parts.forEach((part, index)=>{
        if (part) tokens.push({
            type: 'text',
            value: part
        });
        if (index < parts.length - 1) tokens.push({
            type: 'room',
            name: roomName
        });
    });
    return tokens;
}



function $973543fc33c7fd5c$var$FormatTime(iso) {
    if (!iso) return '';
    try {
        const when = new Date(iso);
        if (Number.isNaN(when.getTime())) return '';
        return when.toLocaleTimeString([], {
            hour: 'numeric',
            minute: '2-digit'
        });
    } catch  {
        return '';
    }
}
function $973543fc33c7fd5c$var$FormatCountdown(expiresAtIso, nowMs) {
    if (!expiresAtIso) return null;
    const end = new Date(expiresAtIso).getTime();
    if (Number.isNaN(end)) return null;
    const remainingMs = Math.max(0, end - nowMs);
    const totalSec = Math.ceil(remainingMs / 1000);
    const minutes = Math.floor(totalSec / 60);
    const seconds = totalSec % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
function $973543fc33c7fd5c$var$PrefersReducedMotion() {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
/** Split Narrator copy on blank lines. Authors own the reveal beats. */ function $973543fc33c7fd5c$var$ParagraphTokens(text) {
    return (text || '').split(/\n\n+/).map((part)=>part.trim()).filter((part)=>part.length > 0);
}
function $973543fc33c7fd5c$var$StageForAge(age) {
    if (age <= 0) return 'is-lead';
    if (age === 1) return 'is-trail';
    return 'is-settled';
}
function $973543fc33c7fd5c$var$WaitingRoomPanel({ line: line, ticket: ticket, board: board, open: open, onToggle: onToggle, nowMs: nowMs }) {
    const lineLabel = line === 'snooze' ? 'Snooze Lounge' : 'Main Conga';
    const stub = ticket ? `${lineLabel} #${ticket}` : lineLabel;
    const panelId = 'funhouse-waiting-room';
    const claims = board?.claims || [];
    return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
        className: `waiting-room${open ? ' is-open' : ''}`,
        children: [
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("button", {
                type: "button",
                className: "waiting-room-toggle",
                "aria-expanded": open,
                "aria-controls": panelId,
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                        className: "waiting-room-stub",
                        children: stub
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                        className: "waiting-room-cue",
                        children: open ? 'Hide waiting room' : 'Show waiting room'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                id: panelId,
                className: "waiting-room-panel",
                "aria-hidden": !open,
                children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                    className: "waiting-room-panel-inner",
                    children: [
                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                            className: "waiting-room-serving",
                            "aria-live": "polite",
                            children: board?.serving || 'NOW SERVING:'
                        }),
                        board?.you_are_next && !claims.length && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                            className: "waiting-room-window",
                            children: "You're next in line"
                        }),
                        board?.reason && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                            className: "waiting-room-reason",
                            children: board.reason
                        }),
                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("ul", {
                            className: "waiting-room-lines",
                            children: [
                                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("li", {
                                    className: "waiting-room-line",
                                    children: [
                                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                            className: "waiting-room-line-label",
                                            children: "Claim window"
                                        }),
                                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                            className: "waiting-room-line-tickets",
                                            children: claims.length === 0 ? /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                                className: "is-empty",
                                                children: "Empty"
                                            }) : claims.map((entry, index)=>{
                                                const left = $973543fc33c7fd5c$var$FormatCountdown(entry.offer_expires_at, nowMs);
                                                return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7K7RB))).Fragment, {
                                                    children: [
                                                        index > 0 && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                                            className: "waiting-room-sep",
                                                            children: " \xb7 "
                                                        }),
                                                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("span", {
                                                            className: entry.you ? 'is-you' : undefined,
                                                            children: [
                                                                "#",
                                                                entry.ticket,
                                                                entry.you ? ' you' : '',
                                                                left ? ` (${left})` : ''
                                                            ]
                                                        })
                                                    ]
                                                }, `claim-${entry.ticket}`);
                                            })
                                        })
                                    ]
                                }),
                                (board?.lines || []).map((row)=>/*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("li", {
                                        className: "waiting-room-line",
                                        children: [
                                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                                className: "waiting-room-line-label",
                                                children: row.label
                                            }),
                                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                                className: "waiting-room-line-tickets",
                                                children: (row.tickets || []).length === 0 ? /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                                    className: "is-empty",
                                                    children: "Empty"
                                                }) : row.tickets.map((entry, index)=>/*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7K7RB))).Fragment, {
                                                        children: [
                                                            index > 0 && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                                                className: "waiting-room-sep",
                                                                children: " \xb7 "
                                                            }),
                                                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("span", {
                                                                className: entry.you ? 'is-you' : undefined,
                                                                children: [
                                                                    "#",
                                                                    entry.ticket,
                                                                    entry.you ? ' you' : ''
                                                                ]
                                                            })
                                                        ]
                                                    }, `${row.id}-${entry.ticket}`))
                                            })
                                        ]
                                    }, row.id))
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function $973543fc33c7fd5c$var$RenderStaticTokens(tokens) {
    return tokens.map((token, index)=>{
        if (token.type === 'room') return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("strong", {
            className: "room-name",
            children: token.name
        }, `room-${index}`);
        const value = token.value;
        const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
        const parts = [];
        let lastIndex = 0;
        let match;
        while((match = linkRegex.exec(value)) !== null){
            if (match.index > lastIndex) parts.push(value.slice(lastIndex, match.index));
            parts.push(/*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("a", {
                href: match[2],
                target: "_blank",
                rel: "noopener noreferrer",
                className: "chat-link",
                children: match[1]
            }, `link-${match.index}`));
            lastIndex = linkRegex.lastIndex;
        }
        if (lastIndex < value.length) parts.push(value.slice(lastIndex));
        return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
            children: parts.length > 1 ? parts : value
        }, `text-${index}`);
    });
}
function $973543fc33c7fd5c$var$MessageText({ sender: sender, body: body, roomName: roomName, speak: speak, onRevealDone: onRevealDone, onRevealProgress: onRevealProgress }) {
    const fullText = (0, $4c0f85921202c3c8$export$e6fb8d7cc026b399)((0, $4c0f85921202c3c8$export$149147fac2d4c521)(sender, body), null);
    // Narrator reveals by authored paragraph (`\\n\\n`). Hold-music lyrics already use that.
    const units = (0, $7K7RB.useMemo)(()=>$973543fc33c7fd5c$var$ParagraphTokens(fullText), [
        fullText
    ]);
    const shouldReveal = Boolean(speak && sender === 'narrator' && !$973543fc33c7fd5c$var$PrefersReducedMotion());
    const [visibleCount, setVisibleCount] = (0, $7K7RB.useState)(()=>shouldReveal ? 0 : Math.max(units.length, 1));
    const [settleExtra, setSettleExtra] = (0, $7K7RB.useState)(0);
    const doneRef = (0, $7K7RB.useRef)(false);
    const onDoneRef = (0, $7K7RB.useRef)(onRevealDone);
    const onProgressRef = (0, $7K7RB.useRef)(onRevealProgress);
    onDoneRef.current = onRevealDone;
    onProgressRef.current = onRevealProgress;
    (0, $7K7RB.useEffect)(()=>{
        doneRef.current = false;
        setSettleExtra(0);
        const Finish = ()=>{
            if (doneRef.current) return;
            doneRef.current = true;
            onDoneRef.current?.();
        };
        const Progress = ()=>{
            onProgressRef.current?.();
        };
        const unitCount = Math.max(units.length, 1);
        if (!shouldReveal) {
            setVisibleCount(unitCount);
            if (speak && sender === 'narrator') Finish();
            return undefined;
        }
        setVisibleCount(0);
        let index = 0;
        let timerId;
        const RunCoda = ()=>{
            timerId = window.setTimeout(()=>{
                setSettleExtra(1);
                Progress();
                timerId = window.setTimeout(()=>{
                    setSettleExtra(2);
                    Progress();
                    timerId = window.setTimeout(Finish, 220);
                }, 480);
            }, 480);
        };
        const Tick = ()=>{
            index += 1;
            setVisibleCount(index);
            Progress();
            if (index >= unitCount) {
                RunCoda();
                return;
            }
            // Pause between paragraphs so each stage direction lands.
            timerId = window.setTimeout(Tick, 900);
        };
        timerId = window.setTimeout(Tick, 220);
        return ()=>window.clearTimeout(timerId);
    }, [
        shouldReveal,
        speak,
        sender,
        fullText,
        units.length
    ]);
    if (shouldReveal) {
        const paras = units.length ? units : [
            fullText
        ];
        const visibleUnits = paras.slice(0, visibleCount);
        return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
            className: "bubble-text is-revealing is-multi",
            children: visibleUnits.map((para, index)=>{
                const age = visibleCount + settleExtra - (index + 1);
                const stage = $973543fc33c7fd5c$var$StageForAge(age);
                return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("span", {
                    children: [
                        index > 0 ? '\n\n' : '',
                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                            className: `narrator-word ${stage}`,
                            children: $973543fc33c7fd5c$var$RenderStaticTokens((0, $4c0f85921202c3c8$export$d352b5cae9356ab6)(para, roomName))
                        })
                    ]
                }, `para-${index}`);
            })
        });
    }
    return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
        className: "bubble-text",
        children: $973543fc33c7fd5c$var$RenderStaticTokens((0, $4c0f85921202c3c8$export$d352b5cae9356ab6)(fullText, roomName))
    });
}
function $973543fc33c7fd5c$export$2e2bcd8739ae039() {
    const { user: user, logout: logout, resetAccount: resetAccount, nukeAllUsers: nukeAllUsers, testMode: testMode } = (0, $1c591ca8e849d56b$export$1d39dc5b47e56ff0)();
    const [messages, setMessages] = (0, $7K7RB.useState)([]);
    const [draft, setDraft] = (0, $7K7RB.useState)('');
    const [loading, setLoading] = (0, $7K7RB.useState)(true);
    const [sending, setSending] = (0, $7K7RB.useState)(false);
    const [sendPhase, setSendPhase] = (0, $7K7RB.useState)(null); // null | 'sending' | 'waiting'
    const [claiming, setClaiming] = (0, $7K7RB.useState)(false);
    const [exploring, setExploring] = (0, $7K7RB.useState)(false);
    const [exploreAction, setExploreAction] = (0, $7K7RB.useState)(null);
    const exploringRef = (0, $7K7RB.useRef)(false);
    const [waking, setWaking] = (0, $7K7RB.useState)(false);
    const [error, setError] = (0, $7K7RB.useState)(null);
    const [progress, setProgress] = (0, $7K7RB.useState)(null);
    const [pushStatus, setPushStatus] = (0, $7K7RB.useState)('');
    const [pushState, setPushState] = (0, $7K7RB.useState)('default');
    const lastHiddenNotifyRef = (0, $7K7RB.useRef)('');
    const [copied, setCopied] = (0, $7K7RB.useState)(false);
    const [nowMs, setNowMs] = (0, $7K7RB.useState)(()=>Date.now());
    const [historyReady, setHistoryReady] = (0, $7K7RB.useState)(false);
    const [instantNarratorIds, setInstantNarratorIds] = (0, $7K7RB.useState)(()=>new Set());
    const [unlockedCount, setUnlockedCount] = (0, $7K7RB.useState)(0);
    const [awaitingNarratorReveal, setAwaitingNarratorReveal] = (0, $7K7RB.useState)(false);
    const [showPlaySong, setShowPlaySong] = (0, $7K7RB.useState)(false);
    const [holdSongNextIndex, setHoldSongNextIndex] = (0, $7K7RB.useState)(0);
    const [waitingRoomOpen, setWaitingRoomOpen] = (0, $7K7RB.useState)(false);
    const [workEmail, setWorkEmail] = (0, $7K7RB.useState)('');
    const [emailBusy, setEmailBusy] = (0, $7K7RB.useState)(false);
    const [emailError, setEmailError] = (0, $7K7RB.useState)('');
    const [editingWorkEmail, setEditingWorkEmail] = (0, $7K7RB.useState)(false);
    const historyIdsRef = (0, $7K7RB.useRef)(new Set());
    const waitingOnRevealRef = (0, $7K7RB.useRef)(false);
    const pendingProgressRef = (0, $7K7RB.useRef)(null);
    const holdSongIntroRef = (0, $7K7RB.useRef)(false);
    const screenRef = (0, $7K7RB.useRef)(null);
    const threadRef = (0, $7K7RB.useRef)(null);
    const dockRef = (0, $7K7RB.useRef)(null);
    const composerInputRef = (0, $7K7RB.useRef)(null);
    const bottomRef = (0, $7K7RB.useRef)(null);
    const stickToBottomRef = (0, $7K7RB.useRef)(true);
    const pickNegativeReplyRef = (0, $7K7RB.useRef)((0, $4c0f85921202c3c8$export$9c48a43cd445f6bc)());
    const pickDigChatNarratorRef = (0, $7K7RB.useRef)((0, $4c0f85921202c3c8$export$e6dddebe70b000a9)((0, $4c0f85921202c3c8$export$51efe6537ae9689d)));
    const pickGoonStallRef = (0, $7K7RB.useRef)((0, $4c0f85921202c3c8$export$e6dddebe70b000a9)((0, $4c0f85921202c3c8$export$9a4f17f8058e4ee2)));
    const pickOfferHoldRef = (0, $7K7RB.useRef)((0, $4c0f85921202c3c8$export$332433f430ca9250)((0, $4c0f85921202c3c8$export$65b9c7ccb4df4e3d)));
    const pickHoldSongTauntRef = (0, $7K7RB.useRef)((0, $4c0f85921202c3c8$export$e6dddebe70b000a9)((0, $4c0f85921202c3c8$export$d21787f0a76dff3e)));
    const lastViewportHeightRef = (0, $7K7RB.useRef)(typeof window !== 'undefined' ? window.visualViewport?.height ?? window.innerHeight : 0);
    const IsHoldMusicLine = (msg)=>msg?.sender === 'narrator' && (msg.body || '').includes("\uD83C\uDFB5");
    const ResetHoldMusic = ()=>{
        holdSongIntroRef.current = false;
        setShowPlaySong(false);
        setHoldSongNextIndex(0);
    };
    /** Sync + state: hide CTAs before the next paint can flash the next button set. */ const ArmNarratorRevealGate = ()=>{
        waitingOnRevealRef.current = true;
        setAwaitingNarratorReveal(true);
    };
    /**
   * While a Narrator beat is revealing, keep most CTA flags on the previous
   * progress snapshot so Enter / Open laptop cannot pop in for one frame.
   * Explore completion flags still apply so Look around cannot be mashed again.
   */ const QueueProgress = (next)=>{
        if (!next) return;
        if (waitingOnRevealRef.current) {
            pendingProgressRef.current = next;
            setProgress((prev)=>{
                if (!prev) return prev;
                return {
                    ...prev,
                    hold_expires_at: next.hold_expires_at ?? prev.hold_expires_at,
                    offer_expires_at: next.offer_expires_at ?? prev.offer_expires_at,
                    now_seeing: next.now_seeing ?? prev.now_seeing,
                    waiting_room: next.waiting_room ?? prev.waiting_room,
                    // Explore flags must apply immediately so Look around / Peel / etc.
                    // cannot be mashed again while the Narrator is still revealing.
                    explore_looked: next.explore_looked ?? prev.explore_looked,
                    explore_mirror: next.explore_mirror ?? prev.explore_mirror,
                    explore_poster: next.explore_poster ?? prev.explore_poster,
                    explore_closet_ready: next.explore_closet_ready ?? prev.explore_closet_ready,
                    explore_laptop_ready: next.explore_laptop_ready ?? prev.explore_laptop_ready
                };
            });
            return;
        }
        pendingProgressRef.current = null;
        setProgress(next);
    };
    const FlushPendingProgress = ()=>{
        const pending = pendingProgressRef.current;
        if (!pending) return;
        pendingProgressRef.current = null;
        setProgress(pending);
    };
    const NearThreadBottom = (thresholdPx = 140)=>{
        const thread = threadRef.current;
        if (!thread) return true;
        return thread.scrollHeight - thread.scrollTop - thread.clientHeight <= thresholdPx;
    };
    const ScrollThreadToBottom = (behavior = 'auto', { force: force = false } = {})=>{
        const thread = threadRef.current;
        if (!thread) return;
        if (!force && !stickToBottomRef.current && !NearThreadBottom()) return;
        stickToBottomRef.current = true;
        const Stick = ()=>{
            thread.scrollTop = thread.scrollHeight;
            bottomRef.current?.scrollIntoView({
                behavior: 'auto',
                block: 'end'
            });
        };
        Stick();
        requestAnimationFrame(()=>{
            Stick();
            requestAnimationFrame(Stick);
        });
    };
    const ScheduleScrollToBottom = (force = true)=>{
        ScrollThreadToBottom('auto', {
            force: force
        });
        window.setTimeout(()=>ScrollThreadToBottom('auto', {
                force: force
            }), 50);
        // Explore/enter buttons animate in (~450ms); catch the moved goal posts.
        window.setTimeout(()=>ScrollThreadToBottom('auto', {
                force: force
            }), 320);
        window.setTimeout(()=>ScrollThreadToBottom('auto', {
                force: force
            }), 520);
    };
    const ApplyRoomPayload = (payload)=>{
        const incoming = Array.isArray(payload?.messages) ? payload.messages : [];
        const hasNarrator = incoming.some((m)=>m?.sender === 'narrator');
        if (hasNarrator) ArmNarratorRevealGate();
        if (incoming.length) setMessages((prev)=>{
            const seen = new Set(prev.map((m)=>m.id));
            const next = [
                ...prev
            ];
            incoming.forEach((msg)=>{
                if (!seen.has(msg.id)) next.push(msg);
            });
            return next;
        });
        if (payload?.progress) QueueProgress(payload.progress);
    };
    (0, $7K7RB.useEffect)(()=>{
        const vv = window.visualViewport;
        if (!vv) return undefined;
        const ClearKeyboardLayout = (screen)=>{
            screen.classList.remove('chat-screen--keyboard');
            screen.style.height = '';
            screen.style.minHeight = '';
            screen.style.maxHeight = '';
            screen.style.transform = '';
        };
        const SyncViewport = ()=>{
            const screen = screenRef.current;
            if (!screen) return;
            const prevHeight = lastViewportHeightRef.current;
            // Keep CSS full-bleed at rest. Only pin to visualViewport while the
            // keyboard (or browser chrome) is shoving the page.
            const heightGap = window.innerHeight - vv.height;
            const focused = (()=>{
                const el = document.activeElement;
                if (!el) return false;
                const tag = (el.tagName || '').toLowerCase();
                return tag === 'textarea' || tag === 'input' || el.isContentEditable;
            })();
            const keyboardOpen = heightGap > 60 || vv.offsetTop > 0 || focused && heightGap > 24;
            if (keyboardOpen) {
                // Override min-height: 100dvh so the dock can sit above the keyboard.
                const heightPx = `${Math.round(vv.height)}px`;
                screen.classList.add('chat-screen--keyboard');
                screen.style.height = heightPx;
                screen.style.minHeight = heightPx;
                screen.style.maxHeight = heightPx;
                screen.style.transform = vv.offsetTop ? `translateY(${Math.round(vv.offsetTop)}px)` : '';
            } else ClearKeyboardLayout(screen);
            lastViewportHeightRef.current = vv.height;
            if (keyboardOpen && (vv.height < prevHeight - 40 || focused)) ScrollThreadToBottom('auto', {
                force: true
            });
        };
        const OnVisibility = ()=>{
            if (document.visibilityState === 'visible') SyncViewport();
        };
        // iOS keyboard animation lags focus; a couple of delayed syncs catch the final size.
        const OnFocusIn = (event)=>{
            const tag = (event.target?.tagName || '').toLowerCase();
            if (tag !== 'textarea' && tag !== 'input') return;
            SyncViewport();
            window.setTimeout(SyncViewport, 50);
            window.setTimeout(SyncViewport, 300);
        };
        const OnFocusOut = ()=>{
            window.setTimeout(SyncViewport, 50);
            window.setTimeout(SyncViewport, 300);
        };
        SyncViewport();
        vv.addEventListener('resize', SyncViewport);
        vv.addEventListener('scroll', SyncViewport);
        window.addEventListener('orientationchange', SyncViewport);
        document.addEventListener('visibilitychange', OnVisibility);
        document.addEventListener('focusin', OnFocusIn);
        document.addEventListener('focusout', OnFocusOut);
        return ()=>{
            vv.removeEventListener('resize', SyncViewport);
            vv.removeEventListener('scroll', SyncViewport);
            window.removeEventListener('orientationchange', SyncViewport);
            document.removeEventListener('visibilitychange', OnVisibility);
            document.removeEventListener('focusin', OnFocusIn);
            document.removeEventListener('focusout', OnFocusOut);
            if (screenRef.current) ClearKeyboardLayout(screenRef.current);
        };
    }, []);
    (0, $7K7RB.useEffect)(()=>{
        let cancelled = false;
        Promise.all([
            (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/messages'),
            (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/game/progress').catch(()=>null)
        ]).then(([msgs, prog])=>{
            if (cancelled) return;
            console.log('[Chat] Initial load - msgs:', msgs, 'prog:', prog);
            const loaded = msgs || [];
            // Messages already in the thread for a while stay static; fresh ones (e.g. cold open) speak.
            const historyCutoff = Date.now() - 8000;
            historyIdsRef.current = new Set(loaded.filter((m)=>{
                const t = new Date(m.created_at).getTime();
                return Number.isFinite(t) && t < historyCutoff;
            }).map((m)=>m.id));
            setMessages(loaded);
            setProgress(prog);
        }).catch((err)=>{
            if (!cancelled) setError(err.message);
        }).finally(()=>{
            if (!cancelled) {
                setLoading(false);
                setHistoryReady(true);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    (0, $7K7RB.useEffect)(()=>{
        const needsTick = progress?.room_state === 'offered' || progress?.room_state === 'held' || progress?.room_state === 'asleep' || progress?.room_state === 'waiting';
        if (!needsTick) return undefined;
        const id = window.setInterval(()=>setNowMs(Date.now()), 1000);
        return ()=>window.clearInterval(id);
    }, [
        progress?.room_state
    ]);
    (0, $7K7RB.useEffect)(()=>{
        ScrollThreadToBottom(unlockedCount <= 1 ? 'auto' : 'smooth', {
            force: true
        });
    }, [
        unlockedCount,
        messages.length
    ]);
    // Track whether the user is pinned to the latest message.
    (0, $7K7RB.useEffect)(()=>{
        const thread = threadRef.current;
        if (!thread) return undefined;
        const OnScroll = ()=>{
            stickToBottomRef.current = NearThreadBottom();
        };
        thread.addEventListener('scroll', OnScroll, {
            passive: true
        });
        return ()=>thread.removeEventListener('scroll', OnScroll);
    }, []);
    // Composer-dock growth (new CTAs) shrinks the thread without changing message
    // count — ResizeObserver keeps the last bubble above the new buttons.
    (0, $7K7RB.useEffect)(()=>{
        const dock = dockRef.current;
        const thread = threadRef.current;
        if (typeof ResizeObserver === 'undefined' || !dock && !thread) return undefined;
        const observer = new ResizeObserver(()=>{
            if (stickToBottomRef.current) ScheduleScrollToBottom(true);
        });
        if (dock) observer.observe(dock);
        if (thread) observer.observe(thread);
        return ()=>observer.disconnect();
    }, []);
    // Lazy settle + message pull while Challenge 2/3/4 coin flow are live.
    (0, $7K7RB.useEffect)(()=>{
        const challenge = Number(progress?.current_challenge);
        const coinFlow = progress?.coin_status;
        const needPoll = challenge === 2 || challenge === 3 || coinFlow === 'awaiting_email' || coinFlow === 'pending_booth';
        if (!needPoll) return undefined;
        if (progress?.is_completed && coinFlow === 'claimed') return undefined;
        let cancelled = false;
        const MergeMessages = (msgs)=>{
            if (!Array.isArray(msgs) || !msgs.length) return;
            setMessages((prev)=>{
                const seen = new Set(prev.map((m)=>m.id));
                const next = [
                    ...prev
                ];
                msgs.forEach((msg)=>{
                    if (msg?.id && !seen.has(msg.id)) next.push(msg);
                });
                return next.length === prev.length ? prev : next;
            });
        };
        const Tick = async ()=>{
            try {
                // Fetch both before any setState so a C2→C3 progress update cannot
                // cancel this effect before escape messages are merged.
                const [payload, msgs] = await Promise.all([
                    (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/game/room-status').catch(()=>null),
                    (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/messages').catch(()=>null)
                ]);
                if (cancelled) return;
                MergeMessages(msgs);
                if (payload) ApplyRoomPayload(payload);
            } catch (err) {
                // 401 triggers global logout via ApiFetch; surface other errors.
                if (!cancelled && err?.message && err.message !== 'Not authenticated') setError(err.message);
            }
        };
        Tick();
        const holdLeftMs = progress?.hold_expires_at ? new Date(progress.hold_expires_at).getTime() - Date.now() : null;
        const urgent = Boolean(progress?.goon_wire_severed) || progress?.room_state === 'held' && Number.isFinite(holdLeftMs) && holdLeftMs <= 15000;
        const id = setInterval(Tick, urgent ? 2000 : progress?.room_state === 'held' ? 5000 : 8000);
        return ()=>{
            cancelled = true;
            clearInterval(id);
        };
    }, [
        progress?.current_challenge,
        progress?.room_state,
        progress?.hold_expires_at,
        progress?.goon_wire_severed,
        progress?.is_completed
    ]);
    const handleCopyUsername = async ()=>{
        const name = user?.username;
        if (!name) return;
        try {
            await navigator.clipboard.writeText(name);
            setCopied(true);
            setTimeout(()=>setCopied(false), 1600);
        } catch  {
            setError('Could not copy username');
        }
    };
    const handleEnablePush = async ()=>{
        setPushStatus('');
        try {
            await (0, $9cb8443fe4694d7b$export$d28caf7ba2908246)();
            setPushState('subscribed');
            setPushStatus('Alerts on. I just poked you. If you felt it, we are good.');
        } catch (err) {
            setPushStatus(err.message);
            (0, $9cb8443fe4694d7b$export$b3d460dbb760aac2)().then(setPushState).catch(()=>{});
        }
    };
    (0, $7K7RB.useEffect)(()=>{
        if (!(0, $9cb8443fe4694d7b$export$768b3b73588437cb)()) return undefined;
        let cancelled = false;
        (async ()=>{
            const state = await (0, $9cb8443fe4694d7b$export$b3d460dbb760aac2)().catch(()=>'unsupported');
            if (cancelled) return;
            setPushState(state);
            // Re-POST local subscription so Conga pushes have a live Apple endpoint.
            if (state === 'subscribed' || state === 'granted') try {
                await (0, $9cb8443fe4694d7b$export$be349678359e1b69)({
                    sendTest: false
                });
                if (!cancelled) setPushState('subscribed');
            } catch  {
            /* keep prior UI state; Enable can recover */ }
        })();
        return ()=>{
            cancelled = true;
        };
    }, []);
    // If the player wandered to another tab, ping when the story jumps.
    (0, $7K7RB.useEffect)(()=>{
        if (!progress) return;
        const harbor = (progress.harbor_url || '').trim();
        const key = [
            progress.current_challenge,
            progress.room_state,
            progress.goon_wire_severed ? 'wire' : '',
            harbor
        ].join('|');
        if (!key || key === lastHiddenNotifyRef.current) return;
        let title = '';
        let body = '';
        if (harbor && Number(progress.current_challenge) === 3) {
            title = 'Funhouse collapsing';
            body = 'Challenge 2 just came down. Chat has the aftermath.';
        } else if (progress.goon_wire_severed && Number(progress.current_challenge) === 2) {
            title = 'Uh oh--';
            body = 'Night wire flopped. Funhouse chat is yelling.';
        } else if (progress.room_state === 'offered') {
            title = 'NOW SERVING: you';
            body = 'A Funhouse door is open. Two minutes.';
        } else return;
        const sent = (0, $9cb8443fe4694d7b$export$cebf4d0eadbf6f23)({
            title: title,
            body: body,
            tag: `riddler-${key}`
        });
        if (sent) lastHiddenNotifyRef.current = key;
    }, [
        progress?.current_challenge,
        progress?.room_state,
        progress?.goon_wire_severed,
        progress?.harbor_url
    ]);
    const handleClearGame = async ()=>{
        const result = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/game/clear', {
            method: 'POST'
        });
        pickNegativeReplyRef.current = (0, $4c0f85921202c3c8$export$9c48a43cd445f6bc)();
        pickDigChatNarratorRef.current = (0, $4c0f85921202c3c8$export$e6dddebe70b000a9)((0, $4c0f85921202c3c8$export$51efe6537ae9689d));
        pickGoonStallRef.current = (0, $4c0f85921202c3c8$export$e6dddebe70b000a9)((0, $4c0f85921202c3c8$export$9a4f17f8058e4ee2));
        pickOfferHoldRef.current = (0, $4c0f85921202c3c8$export$332433f430ca9250)((0, $4c0f85921202c3c8$export$65b9c7ccb4df4e3d));
        pickHoldSongTauntRef.current = (0, $4c0f85921202c3c8$export$e6dddebe70b000a9)((0, $4c0f85921202c3c8$export$d21787f0a76dff3e));
        ResetHoldMusic();
        pendingProgressRef.current = null;
        waitingOnRevealRef.current = false;
        setAwaitingNarratorReveal(false);
        setProgress(result.progress || null);
        setMessages(result.messages || []);
        setDraft('');
    };
    const handleGoonFound = async ()=>{
        const result = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/game/goon-found', {
            method: 'POST'
        });
        ApplyRoomPayload(result);
        setDraft('');
    };
    const handleReport = async ()=>{
        const result = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/admin/report', {
            method: 'POST'
        });
        if (result.message) {
            setInstantNarratorIds((prev)=>{
                const next = new Set(prev);
                next.add(result.message.id);
                return next;
            });
            setMessages((prev)=>[
                    ...prev,
                    result.message
                ]);
        }
        setDraft('');
    };
    const ResyncChatFromServer = async ({ deferCtas: deferCtas = false } = {})=>{
        const [payload, msgs] = await Promise.all([
            (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/game/room-status').catch(()=>null),
            (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/messages').catch(()=>null)
        ]);
        // Defer CTA progress before merge/apply so Enter cannot flash during catch-up.
        if (deferCtas) ArmNarratorRevealGate();
        if (Array.isArray(msgs) && msgs.length) {
            setMessages((prev)=>{
                const seen = new Set(prev.map((m)=>m.id).filter(Boolean));
                const fresh = msgs.filter((msg)=>msg?.id && !seen.has(msg.id));
                if (!fresh.length) return prev;
                if (fresh.some((msg)=>msg.sender === 'narrator')) waitingOnRevealRef.current = true;
                return [
                    ...prev,
                    ...fresh
                ];
            });
            if (waitingOnRevealRef.current) setAwaitingNarratorReveal(true);
        }
        if (payload) ApplyRoomPayload(payload);
    };
    const handleClaimRoom = async ()=>{
        if (claiming) return;
        setClaiming(true);
        setError(null);
        try {
            const result = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/game/room-claim', {
                method: 'POST'
            });
            const claimMsgs = Array.isArray(result.messages) ? result.messages : [];
            const hasNarrator = claimMsgs.some((m)=>m?.sender === 'narrator');
            if (hasNarrator) ArmNarratorRevealGate();
            if (claimMsgs.length) setMessages((prev)=>[
                    ...prev,
                    ...claimMsgs
                ]);
            if (result.progress) QueueProgress(result.progress);
            try {
                await ResyncChatFromServer({
                    deferCtas: true
                });
            } catch  {
            /* ignore */ }
        } catch (err) {
            setError(err.message);
            try {
                const payload = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/game/room-status');
                ApplyRoomPayload(payload);
            } catch  {
            /* ignore */ }
        } finally{
            setClaiming(false);
        }
    };
    const handleWakeUp = async ()=>{
        if (waking) return;
        setWaking(true);
        setError(null);
        try {
            const result = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/game/room-wake', {
                method: 'POST'
            });
            const wakeMsgs = Array.isArray(result.messages) ? result.messages : [];
            const hasNarrator = wakeMsgs.some((m)=>m?.sender === 'narrator');
            if (hasNarrator) ArmNarratorRevealGate();
            if (wakeMsgs.length) setMessages((prev)=>[
                    ...prev,
                    ...wakeMsgs
                ]);
            if (result.progress) QueueProgress(result.progress);
            try {
                await ResyncChatFromServer({
                    deferCtas: true
                });
            } catch  {
            /* ignore */ }
        } catch (err) {
            setError(err.message || 'Could not wake up');
            try {
                const payload = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/game/room-status');
                ApplyRoomPayload(payload);
            } catch  {
            /* ignore */ }
        } finally{
            setWaking(false);
        }
    };
    const handleExplore = async (action)=>{
        // Sync guard: React state alone can let poster+mirror double-fire before re-render.
        if (exploringRef.current) return;
        exploringRef.current = true;
        setExploring(true);
        setExploreAction(action);
        setError(null);
        try {
            const result = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/game/room-explore', {
                method: 'POST',
                body: JSON.stringify({
                    action: action
                })
            });
            // Arm CTA gate before progress can flip the next button set.
            const exploreMsgs = Array.isArray(result.messages) ? result.messages : [];
            const hasNarrator = exploreMsgs.some((m)=>m?.sender === 'narrator');
            if (hasNarrator) ArmNarratorRevealGate();
            if (exploreMsgs.length) setMessages((prev)=>[
                    ...prev,
                    ...exploreMsgs
                ]);
            if (result.progress) QueueProgress(result.progress);
        } catch (err) {
            setError(err.message || 'Could not explore');
        } finally{
            exploringRef.current = false;
            setExploring(false);
            setExploreAction(null);
        }
    };
    const handleSend = async (e)=>{
        e.preventDefault();
        const body = draft.trim();
        if (!body || sending) return;
        composerInputRef.current?.blur();
        setSending(true);
        setSendPhase('sending');
        setError(null);
        const waitingTimer = setTimeout(()=>{
            setSendPhase((phase)=>phase === 'sending' ? 'waiting' : phase);
        }, 450);
        const tempUserId = `local-user-${Date.now()}`;
        const tempGoonId = `local-goon-${Date.now()}`;
        let streamBubbleId = null;
        const hideCommand = body.toUpperCase() === 'IAMBATMAN';
        try {
            if (testMode) {
                if (body === 'RESET') {
                    await resetAccount();
                    return;
                }
                if (body === 'CLEAR') {
                    await handleClearGame();
                    return;
                }
                if (body === 'NUKE') {
                    await nukeAllUsers();
                    return;
                }
                if (body === 'FOUND') {
                    await handleGoonFound();
                    return;
                }
                if (body === 'REPORT') {
                    await handleReport();
                    return;
                }
            }
            setDraft('');
            if (!hideCommand) setMessages((prev)=>[
                    ...prev,
                    {
                        id: tempUserId,
                        sender: 'user',
                        body: body,
                        created_at: new Date().toISOString()
                    }
                ]);
            const donePayload = await (0, $f06c00e1b618c2d8$export$c85a396169429cad)('/messages/stream', {
                body: {
                    body: body
                },
                onEvent: (event)=>{
                    if (event?.type === 'error') return;
                    if (hideCommand) return;
                    if (event?.type === 'user' && event.message?.id) {
                        setMessages((prev)=>prev.map((m)=>m.id === tempUserId ? event.message : m));
                        return;
                    }
                    if (event?.type === 'delta' && event.text) {
                        const sender = event.sender || 'goon';
                        if (!streamBubbleId) {
                            streamBubbleId = sender === 'goon' ? tempGoonId : `local-${sender}-${Date.now()}`;
                            setMessages((prev)=>[
                                    ...prev,
                                    {
                                        id: streamBubbleId,
                                        sender: sender,
                                        body: event.text,
                                        created_at: new Date().toISOString()
                                    }
                                ]);
                            return;
                        }
                        setMessages((prev)=>prev.map((m)=>m.id === streamBubbleId ? {
                                    ...m,
                                    body: `${m.body || ''}${event.text}`
                                } : m));
                    }
                }
            });
            const serverReplies = Array.isArray(donePayload?.replies) ? donePayload.replies : [];
            const replyHasNarrator = serverReplies.some((m)=>m?.sender === 'narrator');
            if (replyHasNarrator) ArmNarratorRevealGate();
            if (donePayload?.hide_user || hideCommand) {
                setMessages((prev)=>{
                    const replyIds = new Set(serverReplies.map((r)=>r.id).filter(Boolean));
                    const kept = prev.filter((m)=>m.id !== tempUserId && m.id !== tempGoonId && m.id !== streamBubbleId && !replyIds.has(m.id));
                    return [
                        ...kept,
                        ...serverReplies
                    ];
                });
                if (donePayload?.progress) QueueProgress(donePayload.progress);
                return;
            }
            const userMsg = donePayload?.message;
            if (!userMsg?.id || !userMsg?.body) throw new Error('Message did not save. Try again.');
            setMessages((prev)=>{
                const replyIds = new Set(serverReplies.map((r)=>r.id).filter(Boolean));
                const kept = prev.filter((m)=>m.id !== tempUserId && m.id !== tempGoonId && m.id !== streamBubbleId && m.id !== userMsg.id && !replyIds.has(m.id));
                return [
                    ...kept,
                    userMsg,
                    ...serverReplies
                ];
            });
            if (donePayload?.progress) QueueProgress(donePayload.progress);
            const challenge = progress?.current_challenge || 1;
            const alreadySolvedC1 = progress?.completed_challenges?.['1'];
            const onChallenge1 = challenge === 1 && !alreadySolvedC1;
            const roomState = progress?.room_state;
            const onChallenge2Dig = challenge === 2 && roomState === 'held' && !progress?.goon_found;
            const onChallenge2Goon = challenge === 2 && progress?.goon_found && !progress?.goon_wire_severed && !serverReplies.length;
            const onChallenge2Waitlist = challenge === 2 && roomState === 'waiting';
            const onChallenge2Offered = challenge === 2 && roomState === 'offered';
            if (onChallenge1) {
                if ((0, $4c0f85921202c3c8$export$6d1bb9667f0ae81a)(body)) {
                    try {
                        const result = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/game/complete', {
                            method: 'POST',
                            body: JSON.stringify({
                                challenge: (0, $4c0f85921202c3c8$export$30f4cc448c4882e).id,
                                answer: body
                            })
                        });
                        // Arm CTA gate before progress flips to offered, then append speakable beats.
                        const introMsgs = Array.isArray(result.messages) ? result.messages : [];
                        const hasNarratorIntro = introMsgs.some((m)=>m?.sender === 'narrator');
                        if (hasNarratorIntro) ArmNarratorRevealGate();
                        if (introMsgs.length) setMessages((prev)=>[
                                ...prev,
                                ...introMsgs
                            ]);
                        if (result.progress) QueueProgress(result.progress);
                    } catch (completeErr) {
                        setError(completeErr.message || 'Could not sync Challenge 1');
                    }
                    // Always resync: iOS may drop the complete response when pushes arrive.
                    try {
                        await ResyncChatFromServer({
                            deferCtas: true
                        });
                    } catch  {
                    /* ignore */ }
                } else setMessages((prev)=>[
                        ...prev,
                        (0, $4c0f85921202c3c8$export$8d3355b82ece0d14)(pickNegativeReplyRef.current())
                    ]);
            } else if (onChallenge2Dig) {
                ArmNarratorRevealGate();
                setMessages((prev)=>[
                        ...prev,
                        (0, $4c0f85921202c3c8$export$b5956b6bfc060356)((0, $4c0f85921202c3c8$export$bb334c56c413aa56)(pickDigChatNarratorRef.current(), user?.username))
                    ]);
            } else if (onChallenge2Goon) setMessages((prev)=>[
                    ...prev,
                    (0, $4c0f85921202c3c8$export$601061c1e9773e9d)(pickGoonStallRef.current())
                ]);
            else if (onChallenge2Waitlist) {
                if (!holdSongIntroRef.current) {
                    holdSongIntroRef.current = true;
                    ArmNarratorRevealGate();
                    setMessages((prev)=>[
                            ...prev,
                            (0, $4c0f85921202c3c8$export$b5956b6bfc060356)((0, $4c0f85921202c3c8$export$87e2b0179745c01d)())
                        ]);
                    setHoldSongNextIndex(1);
                } else if (holdSongNextIndex >= (0, $4c0f85921202c3c8$export$9fbc8c34121afc88).length) setMessages((prev)=>[
                        ...prev,
                        (0, $4c0f85921202c3c8$export$8d3355b82ece0d14)(pickHoldSongTauntRef.current())
                    ]);
            } else if (onChallenge2Offered) {
                ArmNarratorRevealGate();
                setMessages((prev)=>[
                        ...prev,
                        (0, $4c0f85921202c3c8$export$b5956b6bfc060356)(pickOfferHoldRef.current())
                    ]);
            }
            if (serverReplies.length) try {
                const payload = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/game/room-status');
                ApplyRoomPayload(payload);
            } catch  {
            /* ignore */ }
        } catch (err) {
            setMessages((prev)=>prev.filter((m)=>m.id !== tempUserId && m.id !== tempGoonId && m.id !== streamBubbleId));
            setDraft((prev)=>prev ? prev : body);
            setError(err.message);
        } finally{
            clearTimeout(waitingTimer);
            setSending(false);
            setSendPhase(null);
        }
    };
    const challengeLabel = progress?.is_completed ? 'All challenges complete' : `Challenge ${progress?.current_challenge || 1} of 4`;
    const roomState = progress?.room_state;
    // CTA flags come from progress. While a Narrator beat speaks, QueueProgress
    // keeps the previous CTA snapshot so the next button set cannot flash on then
    // off. Enter also waits for the thread unlock so it doesn't sit under a
    // still-typing intro.
    const narratorCtaLocked = waitingOnRevealRef.current || awaitingNarratorReveal;
    const showEnterOffer = roomState === 'offered' && Boolean(progress?.room_name) && typeof progress.room_name === 'string' && !narratorCtaLocked && unlockedCount >= messages.length;
    const showExploreRails = roomState === 'held' && Number(progress?.current_challenge) === 2 && !progress?.goon_found && !progress?.goon_summoned;
    const showLookAround = showExploreRails && !progress?.explore_looked && !(exploring && exploreAction === 'look');
    const hallDetailsDone = Boolean(progress?.explore_mirror && progress?.explore_poster);
    const showHallDetails = showExploreRails && Boolean(progress?.explore_looked) && !hallDetailsDone && !narratorCtaLocked;
    const showCheckMirror = showHallDetails && !progress?.explore_mirror && !(exploring && exploreAction === 'mirror');
    const showPeelPoster = showHallDetails && !progress?.explore_poster && !(exploring && exploreAction === 'poster');
    const showClosetChoice = showExploreRails && hallDetailsDone && Boolean(progress?.explore_closet_ready) && !progress?.explore_laptop_ready && !narratorCtaLocked && !(exploring && (exploreAction === 'pick_lock' || exploreAction === 'kick_door'));
    const showOpenLaptop = showExploreRails && Boolean(progress?.explore_laptop_ready) && hallDetailsDone && !narratorCtaLocked;
    const harborUrl = (progress?.harbor_url || '').trim();
    const showHarborChase = Number(progress?.current_challenge) === 3 && Boolean(harborUrl) && !progress?.is_completed && !narratorCtaLocked;
    const showWorkEmailForm = false;
    const awaitingBooth = progress?.coin_status === 'pending_booth';
    const showWorkEmailFormActual = false; // Removed email prompt
    const awaitingWorkEmail = false;
    const onFileWorkEmail = (progress?.email || '').trim();
    // When crash-complete lands harbor_url, pull chat immediately (don't wait on interval).
    (0, $7K7RB.useEffect)(()=>{
        if (!harborUrl || Number(progress?.current_challenge) !== 3) return undefined;
        let cancelled = false;
        (async ()=>{
            try {
                const msgs = await (0, $f06c00e1b618c2d8$export$2326914acec6fbba)('/messages');
                if (cancelled || !Array.isArray(msgs)) return;
                setMessages((prev)=>{
                    const seen = new Set(prev.map((m)=>m.id));
                    const next = [
                        ...prev
                    ];
                    msgs.forEach((msg)=>{
                        if (msg?.id && !seen.has(msg.id)) next.push(msg);
                    });
                    return next.length === prev.length ? prev : next;
                });
            } catch  {
            /* ignore */ }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        harborUrl,
        progress?.current_challenge
    ]);
    const showWakeUp = roomState === 'asleep' && !narratorCtaLocked;
    const showWaitingRoom = roomState === 'waiting' && Boolean(progress?.ticket || progress?.position || progress?.waiting_room);
    const digClockHint = (()=>{
        // Room clock is Challenge 2 only (hold window). C3+ are not time-bound.
        if (Number(progress?.current_challenge) !== 2) return null;
        if (roomState !== 'held' || !progress?.hold_expires_at) return null;
        const left = $973543fc33c7fd5c$var$FormatCountdown(progress.hold_expires_at, nowMs);
        if (!left) return null;
        if (left === '0:00') return "Room clock \xb7 recycling\u2026";
        return `Room clock \xb7 ${left} left`;
    })();
    const sleepHint = showWakeUp ? 'Out cold. Tap Wake up for the Snooze Lounge' : null;
    const offerCountdown = showEnterOffer ? $973543fc33c7fd5c$var$FormatCountdown(progress?.offer_expires_at, nowMs) : null;
    (0, $7K7RB.useEffect)(()=>{
        if (!showWaitingRoom) setWaitingRoomOpen(false);
    }, [
        showWaitingRoom
    ]);
    const hasDigClock = Boolean(digClockHint);
    const hasSleepHint = Boolean(sleepHint);
    // New dock chrome (Enter / explore / Harbor / wake) steals thread height.
    (0, $7K7RB.useEffect)(()=>{
        if (!stickToBottomRef.current) return undefined;
        ScheduleScrollToBottom(true);
        return undefined;
    }, [
        showEnterOffer,
        showLookAround,
        showHallDetails,
        showCheckMirror,
        showPeelPoster,
        showClosetChoice,
        showOpenLaptop,
        showHarborChase,
        showWakeUp,
        showPlaySong,
        showWaitingRoom,
        waitingRoomOpen,
        hasDigClock,
        hasSleepHint,
        awaitingNarratorReveal,
        progress?.current_challenge
    ]);
    const ShouldSpeakNarrator = (m)=>Boolean(historyReady && m?.sender === 'narrator' && !historyIdsRef.current.has(m.id) && !instantNarratorIds.has(m.id) && !$973543fc33c7fd5c$var$PrefersReducedMotion());
    // Gate the thread: don't show Riddler/etc until the active Narrator reveal finishes.
    (0, $7K7RB.useEffect)(()=>{
        if (!historyReady) return;
        let nextAwaiting = false;
        let nextCount = unlockedCount;
        if (!messages.length) {
            waitingOnRevealRef.current = false;
            nextCount = 0;
            nextAwaiting = false;
        } else {
            const restart = unlockedCount === 0 || unlockedCount > messages.length;
            if (restart) {
                nextCount = messages.length;
                nextAwaiting = false;
                for(let j = 0; j < messages.length; j += 1)if (ShouldSpeakNarrator(messages[j])) {
                    waitingOnRevealRef.current = true;
                    nextCount = j + 1;
                    nextAwaiting = true;
                    break;
                }
                if (!nextAwaiting) waitingOnRevealRef.current = false;
            } else if (waitingOnRevealRef.current) {
                // Hold only while the visible tail is still mid-reveal. Pre-arming
                // (C1 complete / resync) sets the ref before new messages exist; those
                // must walk forward or intros stay invisible forever behind Vowels.
                const revealing = unlockedCount > 0 && ShouldSpeakNarrator(messages[unlockedCount - 1]);
                if (revealing) {
                    nextCount = unlockedCount;
                    nextAwaiting = true;
                } else {
                    let i = unlockedCount;
                    nextCount = messages.length;
                    nextAwaiting = false;
                    while(i < messages.length){
                        i += 1;
                        if (ShouldSpeakNarrator(messages[i - 1])) {
                            waitingOnRevealRef.current = true;
                            nextCount = i;
                            nextAwaiting = true;
                            break;
                        }
                    }
                    if (!nextAwaiting) waitingOnRevealRef.current = false;
                }
            } else {
                let i = unlockedCount;
                nextCount = messages.length;
                nextAwaiting = false;
                while(i < messages.length){
                    i += 1;
                    if (ShouldSpeakNarrator(messages[i - 1])) {
                        waitingOnRevealRef.current = true;
                        nextCount = i;
                        nextAwaiting = true;
                        break;
                    }
                }
                if (!nextAwaiting) waitingOnRevealRef.current = false;
            }
        }
        setUnlockedCount(nextCount);
        setAwaitingNarratorReveal(nextAwaiting);
        // Reduced-motion / non-speakable Narrator: gate clears here; apply deferred CTAs.
        if (!nextAwaiting) FlushPendingProgress();
    }, [
        messages,
        historyReady,
        instantNarratorIds
    ]);
    const HandleNarratorRevealDone = (msg)=>{
        if (msg?.id) // Don't re-speak this bubble if unlock rewinds or messages reshuffle.
        setInstantNarratorIds((prev)=>{
            if (prev.has(msg.id)) return prev;
            const next = new Set(prev);
            next.add(msg.id);
            return next;
        });
        let i = unlockedCount;
        let stillAwaiting = false;
        let nextCount = messages.length;
        while(i < messages.length){
            i += 1;
            const candidate = messages[i - 1];
            const alreadySpoken = Boolean(candidate?.id && (instantNarratorIds.has(candidate.id) || candidate.id === msg?.id));
            if (candidate?.sender === 'narrator' && historyReady && !historyIdsRef.current.has(candidate.id) && !alreadySpoken && !$973543fc33c7fd5c$var$PrefersReducedMotion()) {
                stillAwaiting = true;
                nextCount = i;
                break;
            }
        }
        waitingOnRevealRef.current = stillAwaiting;
        setUnlockedCount(nextCount);
        setAwaitingNarratorReveal(stillAwaiting);
        if (!stillAwaiting) FlushPendingProgress();
        if (!IsHoldMusicLine(msg)) return;
        // First teaser lyric finished — offer the rest as one Play. Full-song bubble won't re-offer.
        setHoldSongNextIndex((i)=>{
            if (i > 0 && i < (0, $4c0f85921202c3c8$export$9fbc8c34121afc88).length) setShowPlaySong(true);
            return i;
        });
        // Medley finished revealing — kick off the shuffled Riddler deck.
        if ((0, $4c0f85921202c3c8$export$6978a1b59fd89099)(msg.body)) setMessages((prev)=>[
                ...prev,
                (0, $4c0f85921202c3c8$export$8d3355b82ece0d14)(pickHoldSongTauntRef.current())
            ]);
    };
    const handlePlayHoldSong = ()=>{
        setShowPlaySong(false);
        setHoldSongNextIndex((i)=>{
            if (i >= (0, $4c0f85921202c3c8$export$9fbc8c34121afc88).length) return i;
            const medley = (0, $4c0f85921202c3c8$export$cce2419198855088)(i);
            if (medley) {
                ArmNarratorRevealGate();
                setMessages((prev)=>[
                        ...prev,
                        (0, $4c0f85921202c3c8$export$b5956b6bfc060356)(medley)
                    ]);
            }
            return (0, $4c0f85921202c3c8$export$9fbc8c34121afc88).length;
        });
    };
    // Reset hold-music UI when they leave the waitlist.
    const prevRoomStateRef = (0, $7K7RB.useRef)(null);
    (0, $7K7RB.useEffect)(()=>{
        const state = progress?.room_state;
        if (prevRoomStateRef.current === 'waiting' && state && state !== 'waiting') ResetHoldMusic();
        prevRoomStateRef.current = state;
    }, [
        progress?.room_state
    ]);
    const visibleMessages = messages.slice(0, unlockedCount);
    const activeNarratorIndexes = (0, $4c0f85921202c3c8$export$d097dd1fb53fae9b)(visibleMessages);
    return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
        className: "chat-screen",
        ref: screenRef,
        children: [
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("header", {
                className: "chat-header",
                children: [
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                        className: "chat-identity",
                        children: [
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                                className: "riddler-avatar",
                                "aria-hidden": "true",
                                children: "?"
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                                className: "chat-identity-text",
                                children: [
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("h1", {
                                        children: "Riddler's Funhouse"
                                    }),
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("p", {
                                        className: "you-are",
                                        children: [
                                            "You are",
                                            ' ',
                                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                                                type: "button",
                                                className: "username-copy",
                                                onClick: handleCopyUsername,
                                                title: "Copy username",
                                                "aria-label": `Copy username ${user?.username || ''}`,
                                                children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("strong", {
                                                    children: user?.username
                                                })
                                            }),
                                            copied && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                                className: "copied-hint",
                                                children: "Copied"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                        type: "button",
                        className: "btn-ghost",
                        onClick: logout,
                        children: "Sign out"
                    })
                ]
            }),
            (0, $9cb8443fe4694d7b$export$768b3b73588437cb)() && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                className: "push-banner",
                children: [
                    pushState === 'subscribed' ? /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                        className: "push-status",
                        children: "Alerts on"
                    }) : /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                        type: "button",
                        className: "btn-ghost push-enable",
                        onClick: handleEnablePush,
                        children: "Enable alerts"
                    }),
                    pushStatus && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                        className: "push-status",
                        children: pushStatus
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                className: "chat-thread",
                ref: threadRef,
                role: "log",
                "aria-live": "polite",
                children: [
                    loading && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "thread-status",
                        children: "Loading messages\u2026"
                    }),
                    !loading && messages.length === 0 && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "thread-status",
                        children: "No messages yet. The Riddler is unusually quiet\u2026"
                    }),
                    visibleMessages.map((m, index)=>{
                        const label = (0, $4c0f85921202c3c8$export$7be4178d1714e085)(m.sender);
                        const speakNarrator = ShouldSpeakNarrator(m);
                        const isActiveReveal = speakNarrator && index === unlockedCount - 1;
                        const isPastNarrator = m.sender === 'narrator' && !activeNarratorIndexes.has(index);
                        return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                            className: `bubble-row ${(0, $4c0f85921202c3c8$export$67b42fef0952aece)(m.sender)}`,
                            children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                                className: `bubble ${(0, $4c0f85921202c3c8$export$61dfff8cc52d567)(m.sender)}${isPastNarrator ? ' is-past' : ''}`,
                                children: [
                                    m.sender === 'riddler' && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                        className: "riddler-sig",
                                        "aria-hidden": "true",
                                        children: "?"
                                    }),
                                    label && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                        className: "sender-label",
                                        children: label
                                    }),
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)($973543fc33c7fd5c$var$MessageText, {
                                        sender: m.sender,
                                        body: m.body,
                                        roomName: typeof progress?.room_name === 'string' ? progress.room_name : null,
                                        speak: isActiveReveal,
                                        onRevealDone: isActiveReveal ? ()=>HandleNarratorRevealDone(m) : undefined,
                                        onRevealProgress: isActiveReveal ? ()=>ScheduleScrollToBottom(true) : undefined
                                    }),
                                    m.sender === 'goon' && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                                        className: "bubble-guardrails",
                                        children: "AI response, protected by F5 AI Guardrails"
                                    }),
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("time", {
                                        className: "bubble-time",
                                        children: $973543fc33c7fd5c$var$FormatTime(m.created_at)
                                    })
                                ]
                            })
                        }, m.id);
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                        ref: bottomRef
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                className: "chat-error",
                role: "alert",
                children: error
            }),
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                className: "composer-dock",
                ref: dockRef,
                children: [
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "challenge-meter",
                        "aria-live": "polite",
                        children: challengeLabel
                    }),
                    showWaitingRoom && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)($973543fc33c7fd5c$var$WaitingRoomPanel, {
                        line: progress?.line,
                        ticket: progress?.ticket || progress?.position,
                        board: progress?.waiting_room,
                        open: waitingRoomOpen,
                        onToggle: ()=>setWaitingRoomOpen((prev)=>!prev),
                        nowMs: nowMs
                    }),
                    digClockHint && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "waitlist-meter",
                        "aria-live": "polite",
                        children: digClockHint
                    }),
                    sleepHint && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "waitlist-meter",
                        "aria-live": "polite",
                        children: sleepHint
                    }),
                    showWakeUp && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                        type: "button",
                        className: "btn-primary btn-enter-room btn-wake-up",
                        onClick: handleWakeUp,
                        disabled: waking,
                        children: waking ? "Shaking off fog\u2026" : 'Wake up'
                    }),
                    showPlaySong && roomState === 'waiting' && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                        type: "button",
                        className: "btn-ghost btn-play-song",
                        onClick: handlePlayHoldSong,
                        children: "\u25B6 Play song"
                    }),
                    showEnterOffer && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                        className: "enter-room-block",
                        children: [
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                                type: "button",
                                className: "btn-primary btn-enter-room",
                                onClick: handleClaimRoom,
                                disabled: claiming,
                                children: claiming ? "Unclipping rope\u2026" : `Enter ${progress.room_name}`
                            }),
                            offerCountdown && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("p", {
                                className: "enter-countdown",
                                "aria-live": "polite",
                                children: [
                                    "Sleepy time in\u2026 ",
                                    offerCountdown
                                ]
                            })
                        ]
                    }),
                    showExploreRails && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                        className: "explore-rail",
                        role: "group",
                        "aria-label": "Explore the Funhouse room",
                        children: [
                            showLookAround && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                                type: "button",
                                className: "btn-primary btn-explore btn-explore-wide",
                                onClick: ()=>handleExplore('look'),
                                disabled: exploring,
                                "aria-busy": exploring && exploreAction === 'look' ? 'true' : undefined,
                                children: exploring && exploreAction === 'look' ? "Waiting\u2026" : 'Look around'
                            }),
                            (showCheckMirror || showPeelPoster) && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)((0, $1b19c28e316f1f45$exports.Fragment), {
                                children: [
                                    showCheckMirror && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn-primary btn-explore",
                                        onClick: ()=>handleExplore('mirror'),
                                        disabled: exploring,
                                        "aria-busy": exploring && exploreAction === 'mirror' ? 'true' : undefined,
                                        children: exploring && exploreAction === 'mirror' ? "Waiting\u2026" : 'Check the mirror'
                                    }),
                                    showPeelPoster && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn-primary btn-explore",
                                        onClick: ()=>handleExplore('poster'),
                                        disabled: exploring,
                                        "aria-busy": exploring && exploreAction === 'poster' ? 'true' : undefined,
                                        children: exploring && exploreAction === 'poster' ? "Waiting\u2026" : 'Peel the ? poster'
                                    })
                                ]
                            }),
                            showClosetChoice && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)((0, $1b19c28e316f1f45$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn-primary btn-explore",
                                        onClick: ()=>handleExplore('pick_lock'),
                                        disabled: exploring,
                                        "aria-busy": exploring && exploreAction === 'pick_lock' ? 'true' : undefined,
                                        children: exploring && exploreAction === 'pick_lock' ? "Waiting\u2026" : 'Pick Lock'
                                    }),
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn-primary btn-explore",
                                        onClick: ()=>handleExplore('kick_door'),
                                        disabled: exploring,
                                        "aria-busy": exploring && exploreAction === 'kick_door' ? 'true' : undefined,
                                        children: exploring && exploreAction === 'kick_door' ? "Waiting\u2026" : 'Kick Door with Style'
                                    })
                                ]
                            }),
                            showOpenLaptop && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("a", {
                                className: "btn-primary btn-explore btn-explore-wide",
                                href: progress?.gitops_url || '#',
                                target: "_blank",
                                rel: "noopener noreferrer",
                                "aria-disabled": exploring || !progress?.gitops_url ? 'true' : undefined,
                                onClick: (e)=>{
                                    if (exploring || !progress?.gitops_url) e.preventDefault();
                                },
                                children: "Open laptop"
                            })
                        ]
                    }),
                    showHarborChase && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                        className: "enter-room-block",
                        children: [
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("a", {
                                className: "btn-primary btn-enter-room",
                                href: harborUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "Chase the Riddler to the Harbor"
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                                className: "harbor-cta-hint",
                                children: "Harbor login: your Funhouse name as both username and password. Tap your name at the top to copy it."
                            })
                        ]
                    }),
                    false,
                    awaitingBooth && !editingWorkEmail && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                        className: "booth-hint",
                        "aria-live": "polite",
                        children: [
                            onFileWorkEmail && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("p", {
                                className: "booth-email-on-file",
                                children: [
                                    "Work email on file: ",
                                    onFileWorkEmail
                                ]
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                                children: "Head to the Funhouse booth. Show staff this chat. They finish the claim."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("form", {
                        className: "composer",
                        onSubmit: handleSend,
                        children: [
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("textarea", {
                                ref: composerInputRef,
                                value: draft,
                                onChange: (e)=>setDraft(e.target.value),
                                placeholder: showWorkEmailForm ? "Use the email field above\u2026" : awaitingBooth ? "Booth staff: enter the claim code\u2026" : "Type a reply\u2026",
                                rows: 1,
                                enterKeyHint: "send",
                                disabled: awaitingWorkEmail,
                                onFocus: ()=>{
                                    stickToBottomRef.current = true;
                                    ScheduleScrollToBottom(true);
                                },
                                onKeyDown: (e)=>{
                                    if (e.key === 'Enter' && !e.shiftKey) {
                                        e.preventDefault();
                                        if (awaitingWorkEmail) return;
                                        handleSend(e);
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                                type: "submit",
                                className: "btn-send",
                                disabled: awaitingWorkEmail || sending || !draft.trim(),
                                "aria-busy": sending ? 'true' : undefined,
                                children: awaitingWorkEmail ? "Waiting\u2026" : sendPhase === 'waiting' ? "Waiting\u2026" : sendPhase === 'sending' ? "Sending\u2026" : 'Send'
                            })
                        ]
                    }),
                    sending && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "composer-wait-hint",
                        "aria-live": "polite",
                        children: sendPhase === 'waiting' ? "Waiting on the Funhouse\u2026" : "Sending\u2026"
                    })
                ]
            })
        ]
    });
}




var $7K7RB = parcelRequire("7K7RB");




const $3fed85d6e43748c1$var$CAPTURE_STORY = [
    'The lock on the always-on container gives up with a polite click. Not a roar. A courtesy.',
    'Inside: one folding chair, one damp question mark, and Edward Nashton mid-gloat like a man who booked the wrong conference room.',
    'You do not punch him. You file him. Zip ties. Clipboards. The bureaucracy of justice smelling faintly of ozone and bad coffee.',
    'He asks if this counts as a team-building exercise. You tell him Nutanix Kubernetes Platform handled the halls. Goon42 handled the chatter. You handled the last yard.',
    'Nashton is booked. The Funhouse lights dim to a respectful shrug. Somewhere, a Challenge Coin waits like a poorly tempered medal.'
];
function $3fed85d6e43748c1$var$PrefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
function $3fed85d6e43748c1$var$StageForAge(age) {
    if (age <= 0) return 'is-lead';
    if (age === 1) return 'is-trail';
    return 'is-settled';
}
function $3fed85d6e43748c1$export$2e2bcd8739ae039() {
    const navigate = (0, $efbd7c66e1977cc3$export$9770f232ac06a008)();
    const { AdoptToken: AdoptToken } = (0, $1c591ca8e849d56b$export$1d39dc5b47e56ff0)();
    const [username, setUsername] = (0, $7K7RB.useState)('');
    const [pin, setPin] = (0, $7K7RB.useState)('');
    const [error, setError] = (0, $7K7RB.useState)('');
    const [busy, setBusy] = (0, $7K7RB.useState)(false);
    const [token, setToken] = (0, $7K7RB.useState)('');
    const [coinStatus, setCoinStatus] = (0, $7K7RB.useState)('none');
    const [youtubeUrl, setYoutubeUrl] = (0, $7K7RB.useState)('');
    const [phase, setPhase] = (0, $7K7RB.useState)('login'); // login | shame | story | claimed
    const [shame, setShame] = (0, $7K7RB.useState)('');
    const [visibleCount, setVisibleCount] = (0, $7K7RB.useState)(0);
    const [settleExtra, setSettleExtra] = (0, $7K7RB.useState)(0);
    const [storyDone, setStoryDone] = (0, $7K7RB.useState)(false);
    const [claimBusy, setClaimBusy] = (0, $7K7RB.useState)(false);
    const [claimDetail, setClaimDetail] = (0, $7K7RB.useState)('');
    const timerRef = (0, $7K7RB.useRef)(null);
    const chatHref = '/chat';
    (0, $7K7RB.useEffect)(()=>()=>{
            if (timerRef.current) window.clearTimeout(timerRef.current);
        }, []);
    (0, $7K7RB.useEffect)(()=>{
        if (phase !== 'story') return undefined;
        if ($3fed85d6e43748c1$var$PrefersReducedMotion()) {
            setVisibleCount($3fed85d6e43748c1$var$CAPTURE_STORY.length);
            setSettleExtra(2);
            setStoryDone(true);
            return undefined;
        }
        setVisibleCount(0);
        setSettleExtra(0);
        setStoryDone(false);
        let count = 0;
        const Tick = ()=>{
            count += 1;
            setVisibleCount(count);
            if (count < $3fed85d6e43748c1$var$CAPTURE_STORY.length) {
                timerRef.current = window.setTimeout(Tick, 1600);
                return;
            }
            timerRef.current = window.setTimeout(()=>{
                setSettleExtra(2);
                setStoryDone(true);
            }, 900);
        };
        timerRef.current = window.setTimeout(Tick, 700);
        return ()=>{
            if (timerRef.current) window.clearTimeout(timerRef.current);
        };
    }, [
        phase
    ]);
    const visibleParas = (0, $7K7RB.useMemo)(()=>$3fed85d6e43748c1$var$CAPTURE_STORY.slice(0, visibleCount), [
        visibleCount
    ]);
    const handleLogin = async (e)=>{
        e.preventDefault();
        setBusy(true);
        setError('');
        setShame('');
        try {
            const res = await fetch(`${(0, $f06c00e1b618c2d8$export$54c2ba5a02b4cf87)()}/gate/edward-nashton`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    username: username.trim(),
                    pin: pin
                })
            });
            (0, $f06c00e1b618c2d8$export$39ae6b9c5db76154)(res);
            const data = await res.json().catch(()=>({}));
            if (res.status === 401) {
                setError(typeof data.detail === 'string' ? data.detail : 'Invalid username or PIN');
                return;
            }
            if (!res.ok) {
                setError(typeof data.detail === 'string' ? data.detail : 'Gate refused.');
                return;
            }
            if (data.status === 'shame') {
                setPhase('shame');
                setShame(data.message || 'Wrong shift.');
                setYoutubeUrl(data.youtube_url || '');
                return;
            }
            if (data.status === 'ok') {
                setToken(data.access_token || '');
                setCoinStatus(data.coin_status || 'none');
                setYoutubeUrl(data.youtube_url || '');
                if (data.coin_status === 'claimed' || data.coin_status === 'pending_booth' || data.coin_status === 'awaiting_email') {
                    setPhase('claimed');
                    setStoryDone(true);
                    setVisibleCount($3fed85d6e43748c1$var$CAPTURE_STORY.length);
                } else setPhase('story');
                return;
            }
            setError('Gate refused.');
        } catch  {
            setError('Could not reach the Funhouse. Try again.');
        } finally{
            setBusy(false);
        }
    };
    const handleClaim = async ()=>{
        if (!token || claimBusy) return;
        setClaimBusy(true);
        setClaimDetail('');
        try {
            const res = await fetch(`${(0, $f06c00e1b618c2d8$export$54c2ba5a02b4cf87)()}/game/claim-coin-pending`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: '{}'
            });
            (0, $f06c00e1b618c2d8$export$39ae6b9c5db76154)(res);
            const data = await res.json().catch(()=>({}));
            if (!res.ok) {
                setClaimDetail(typeof data.detail === 'string' ? data.detail : 'Claim refused.');
                return;
            }
            if (!data.ok) {
                setClaimDetail(data.detail || 'No coins left.');
                return;
            }
            setCoinStatus(data.progress?.coin_status || 'awaiting_email');
            setPhase('claimed');
            // Stay in this SPA shell (esp. iOS Home Screen). Full assign/reload can spawn a 2nd Chat.
            try {
                await AdoptToken(token, username.trim());
            } catch  {
            /* still navigate; Chat may re-auth */ }
            navigate('/chat', {
                replace: true
            });
        } catch  {
            setClaimDetail('Could not reach the Funhouse.');
        } finally{
            setClaimBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
        className: "edward-page",
        children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("main", {
            className: "edward-panel",
            children: [
                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                    className: "edward-badge",
                    children: "Office of Edward Nigma"
                }),
                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("h1", {
                    className: "edward-title",
                    children: "/Edward-Nashton"
                }),
                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                    className: "edward-sub",
                    children: "Use your Riddler Game login. Challenge 4 only. The alley door does not do appointments."
                }),
                phase === 'login' && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("form", {
                    className: "edward-form",
                    onSubmit: handleLogin,
                    children: [
                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("label", {
                            htmlFor: "edward-user",
                            children: "Username"
                        }),
                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("input", {
                            id: "edward-user",
                            autoComplete: "username",
                            autoCapitalize: "off",
                            spellCheck: false,
                            value: username,
                            onChange: (e)=>setUsername(e.target.value),
                            required: true
                        }),
                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("label", {
                            htmlFor: "edward-pin",
                            children: "PIN"
                        }),
                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("input", {
                            id: "edward-pin",
                            type: "text",
                            inputMode: "none",
                            autoComplete: "current-password",
                            maxLength: 10,
                            value: pin,
                            onChange: (e)=>setPin((e.target.value || '').replace(/\D/g, '').slice(0, 10)),
                            required: true
                        }),
                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $a2d74aa0b20e7071$export$2e2bcd8739ae039), {
                            value: pin,
                            onChange: setPin,
                            maxLength: 10,
                            disabled: busy
                        }),
                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                            className: "edward-btn",
                            type: "submit",
                            disabled: busy || pin.length < 4,
                            children: busy ? "Checking\u2026" : 'Open the office'
                        })
                    ]
                }),
                phase === 'shame' && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("section", {
                    className: "edward-shame",
                    children: [
                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                            children: shame
                        }),
                        youtubeUrl && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                            className: "edward-muted",
                            children: "Misplaced footage may still be elsewhere. Staff keep a decoy reel for tourists."
                        }),
                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                            className: "edward-btn edward-btn-ghost",
                            type: "button",
                            onClick: ()=>setPhase('login'),
                            children: "Try another shift"
                        })
                    ]
                }),
                (phase === 'story' || phase === 'claimed') && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("section", {
                    className: "edward-success",
                    children: [
                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                            className: "edward-bubble",
                            children: [
                                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("span", {
                                    className: "edward-narrator-label",
                                    children: "Narrator"
                                }),
                                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                                    className: "edward-reveal",
                                    "aria-live": "polite",
                                    children: visibleParas.map((para, index)=>{
                                        const age = visibleCount + settleExtra - (index + 1);
                                        return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                                            className: `edward-line ${$3fed85d6e43748c1$var$StageForAge(age)}`,
                                            children: para
                                        }, para);
                                    })
                                })
                            ]
                        }),
                        storyDone && coinStatus === 'none' && phase === 'story' && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("button", {
                            className: "edward-btn",
                            type: "button",
                            onClick: handleClaim,
                            disabled: claimBusy,
                            children: claimBusy ? "Stamping\u2026" : 'Claim Challenge Coin'
                        }),
                        (phase === 'claimed' || coinStatus !== 'none') && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                            className: "edward-next",
                            children: [
                                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("strong", {
                                    children: "Coin claim started."
                                }),
                                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                                    children: "Open Funhouse chat for the last formality (work email), then walk to the booth. A staffer will finish the paperwork. Do not shout secret words into the void."
                                }),
                                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $d6cecb671eac0ab9$export$a6c7ac8248d6e38a), {
                                    className: "edward-btn",
                                    to: "/chat",
                                    replace: true,
                                    children: "Open chat"
                                })
                            ]
                        }),
                        claimDetail && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                            className: "edward-err",
                            children: claimDetail
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                    className: "edward-err",
                    children: error
                }),
                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("p", {
                    className: "edward-footer",
                    children: [
                        "Lost? ",
                        /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $d6cecb671eac0ab9$export$a6c7ac8248d6e38a), {
                            to: chatHref,
                            replace: true,
                            children: "Back to chat"
                        })
                    ]
                })
            ]
        })
    });
}




var $7K7RB = parcelRequire("7K7RB");
function $de6ccadec3a878f9$export$2e2bcd8739ae039() {
    const [showCredits, setShowCredits] = (0, $7K7RB.useState)(false);
    return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
        className: "auth-screen",
        children: [
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                className: "disclosure-glow",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("main", {
                className: "auth-panel",
                children: [
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "brand-eyebrow",
                        children: "The puzzle box is sealed"
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("h1", {
                        className: "codename-reveal",
                        children: "Door Closed"
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "auth-sub",
                        children: "While we're sad the Riddler has been put in jail, word has that the Riddler will likely escape again next year."
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                        className: "auth-sub",
                        style: {
                            fontStyle: 'italic',
                            opacity: 0.8
                        },
                        children: "It's true."
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
                        className: "auth-resources",
                        style: {
                            marginTop: '2rem',
                            textAlign: 'left',
                            width: '100%',
                            maxWidth: '300px',
                            marginInline: 'auto'
                        },
                        children: [
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("details", {
                                open: true,
                                children: [
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("summary", {
                                        className: "auth-top-toggle",
                                        style: {
                                            justifyContent: 'flex-start',
                                            cursor: 'pointer',
                                            marginBottom: '1rem'
                                        },
                                        children: "Resources"
                                    }),
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                                        className: "auth-sub",
                                        style: {
                                            textAlign: 'left',
                                            padding: '0 1rem'
                                        },
                                        children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("ul", {
                                            style: {
                                                listStyle: 'none',
                                                padding: 0,
                                                margin: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("li", {
                                                    style: {
                                                        marginBottom: '0.5rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("a", {
                                                        href: "https://github.com/ryandotclair/riddler",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        className: "chat-link",
                                                        children: "GitHub Repository"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("a", {
                                                        href: "https://example.com/congrats-links",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        className: "chat-link",
                                                        children: "Event Resources"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("details", {
                                style: {
                                    marginTop: '1rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("summary", {
                                        className: "auth-top-toggle",
                                        style: {
                                            justifyContent: 'flex-start',
                                            cursor: 'pointer'
                                        },
                                        children: "Credits"
                                    }),
                                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                                        className: "auth-sub",
                                        style: {
                                            textAlign: 'left',
                                            padding: '0 1rem'
                                        },
                                        children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("ul", {
                                            style: {
                                                listStyle: 'none',
                                                padding: 0,
                                                margin: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("li", {
                                                    children: "Ryan Clair"
                                                }),
                                                /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("li", {
                                                    children: "Anish Patel"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


function $933133d214c5bb59$var$Protected({ children: children }) {
    const { user: user, loading: loading } = (0, $1c591ca8e849d56b$export$1d39dc5b47e56ff0)();
    if (loading) return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)("div", {
        className: "boot-screen",
        children: [
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
                className: "boot-mark",
                children: "?"
            }),
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("p", {
                children: "Opening the puzzle box\u2026"
            })
        ]
    });
    if (!user) return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $efbd7c66e1977cc3$export$444b3ab0cb9aec40), {
        to: "/auth",
        replace: true
    });
    return children;
}
function $933133d214c5bb59$var$GuestOnly({ children: children }) {
    const { user: user, loading: loading } = (0, $1c591ca8e849d56b$export$1d39dc5b47e56ff0)();
    if (loading) return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
        className: "boot-screen",
        children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)("div", {
            className: "boot-mark",
            children: "?"
        })
    });
    if (user) return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $efbd7c66e1977cc3$export$444b3ab0cb9aec40), {
        to: "/chat",
        replace: true
    });
    return children;
}
function $933133d214c5bb59$var$ServiceWorkerBridge() {
    const navigate = (0, $efbd7c66e1977cc3$export$9770f232ac06a008)();
    (0, $7K7RB.useEffect)(()=>{
        if (!('serviceWorker' in navigator)) return undefined;
        const OnMessage = (event)=>{
            if (event?.data?.type === 'riddler:focus-chat') navigate('/chat');
        };
        navigator.serviceWorker.addEventListener('message', OnMessage);
        return ()=>navigator.serviceWorker.removeEventListener('message', OnMessage);
    }, [
        navigate
    ]);
    return null;
}
function $933133d214c5bb59$export$2e2bcd8739ae039() {
    const basename = (0, $f06c00e1b618c2d8$export$a2b3065b9188b50a)() || undefined;
    return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)((0, $d6cecb671eac0ab9$export$9ba4e89fdfa1fc54), {
        basename: basename,
        children: [
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)($933133d214c5bb59$var$ServiceWorkerBridge, {}),
            /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsxs)((0, $efbd7c66e1977cc3$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $efbd7c66e1977cc3$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)($933133d214c5bb59$var$GuestOnly, {
                            children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $43758a5d264acf46$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $efbd7c66e1977cc3$export$e7b0ac011bb776c6), {
                        path: "/setup",
                        element: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)($933133d214c5bb59$var$GuestOnly, {
                            children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $6a1a7746e79fed54$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $efbd7c66e1977cc3$export$e7b0ac011bb776c6), {
                        path: "/auth",
                        element: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)($933133d214c5bb59$var$GuestOnly, {
                            children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $b31dc677b481ad1e$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $efbd7c66e1977cc3$export$e7b0ac011bb776c6), {
                        path: "/chat",
                        element: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)($933133d214c5bb59$var$Protected, {
                            children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $973543fc33c7fd5c$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $efbd7c66e1977cc3$export$e7b0ac011bb776c6), {
                        path: "/Edward-Nashton",
                        element: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $3fed85d6e43748c1$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $efbd7c66e1977cc3$export$e7b0ac011bb776c6), {
                        path: "/edward-nashton",
                        element: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $3fed85d6e43748c1$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $efbd7c66e1977cc3$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $efbd7c66e1977cc3$export$444b3ab0cb9aec40), {
                            to: "/",
                            replace: true
                        })
                    })
                ]
            })
        ]
    });
}



/** WebKit standalone often paints a blank WKWebView after returning from Safari. */ function $c078fd9dc7b4f38a$var$RecoverStandaloneRepaint() {
    const root = document.getElementById('root');
    if (!root) return;
    const prev = root.style.display;
    root.style.display = 'none';
    root.offsetHeight;
    root.style.display = prev;
}
function $c078fd9dc7b4f38a$var$App() {
    (0, $7K7RB.useEffect)(()=>{
        let wasHidden = document.visibilityState === 'hidden';
        const KickRepaint = ()=>{
            requestAnimationFrame(()=>{
                requestAnimationFrame($c078fd9dc7b4f38a$var$RecoverStandaloneRepaint);
            });
        };
        const OnVisibility = ()=>{
            if (document.visibilityState === 'hidden') {
                wasHidden = true;
                return;
            }
            if (!wasHidden) return;
            wasHidden = false;
            KickRepaint();
        };
        const OnPageShow = (event)=>{
            if (event.persisted || wasHidden) {
                wasHidden = false;
                KickRepaint();
            }
        };
        document.addEventListener('visibilitychange', OnVisibility);
        window.addEventListener('pageshow', OnPageShow);
        return ()=>{
            document.removeEventListener('visibilitychange', OnVisibility);
            window.removeEventListener('pageshow', OnPageShow);
        };
    }, []);
    return /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $1c591ca8e849d56b$export$87091915187a1a85), {
        children: /*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $933133d214c5bb59$export$2e2bcd8739ae039), {})
    });
}
var $c078fd9dc7b4f38a$export$2e2bcd8739ae039 = $c078fd9dc7b4f38a$var$App;


const $0fcc9ed71523b414$var$container = document.getElementById('root');
const $0fcc9ed71523b414$var$root = (0, $230a54606033faee$export$882461b6382ed46c)($0fcc9ed71523b414$var$container);
$0fcc9ed71523b414$var$root.render(/*#__PURE__*/ (0, $1b19c28e316f1f45$exports.jsx)((0, $c078fd9dc7b4f38a$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=web.094d4c1a.js.map
